import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Select from 'react-select';
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { AddwithBlueCircle, AddwithWhiteCircle, DeleteDustbin, DownloadIcon, DropdownArrowOption, Eye, InfinityIcon, PerformanceIcon, UpdatePencil, InfoIcon, DisciplineIcon, TeamPerformanceIcon } from "../AllSvg";
import { Modal, Button } from "react-bootstrap";
import { ButtonVariants, CustomImageModal, customSortByKey, downloadAsExcel, handleAllError, handleErrorToast } from "../CustomFunctions";
import usePermission from "../../config/permissions";
import {
  CSSForSelect, getSectionsForLevel, isSectionEditableForLevel, isLevelEditable,
  isFinalized, getPrefillForLevel, getMyExistingEntry, groupRatingsBySection,
} from "../CustomUtilities";
import { formatDateTime, formattedDateLong } from "../Date";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { Tooltip, OverlayTrigger } from "react-bootstrap";



// const UploadAppraisalDetailsByEmployee = ({ i, setupId }) => {
//   const [show, setShow] = useState(false);

//   const handleShow = () => {
//     setShow(true);
//   }

//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       rating_period: setupId,
//       accuracy_emp: 0,
//       speedlyWork_emp: 0,
//       SelfInitiative_emp: 0,
//       responsbilityaccountability_emp: 0,
//       independentWorking_emp: 0,
//       decisonMakingCapability_emp: 0,
//       totalperformance_emp: 0,

//       punctuality_emp: 0,
//       teamwork_emp: 0,
//       loyalitytowardsWork_emp: 0,
//       dedicationtowardsWork_emp: 0,
//       obeideintorLeadership_emp: 0,
//       totaldecipline_emp: 0,
//       total_emp: 0,

//     });
//   }

//   const [submitConfirmation, setSubmitConfirmation] = useState(false);

//   const [formData, setFormData] = useState({
//     emp_code: sessionStorage.getItem("emp_code"),
//     rating_period: setupId,

//     accuracy_emp: 0,
//     speedlyWork_emp: 0,
//     SelfInitiative_emp: 0,
//     responsbilityaccountability_emp: 0,
//     independentWorking_emp: 0,
//     decisonMakingCapability_emp: 0,
//     totalperformance_emp: 0,

//     punctuality_emp: 0,
//     teamwork_emp: 0,
//     loyalitytowardsWork_emp: 0,
//     dedicationtowardsWork_emp: 0,
//     obeideintorLeadership_emp: 0,
//     totaldecipline_emp: 0,

//     total_emp: 0,

//     emp_update_datetime: ""
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "emp_code",
//     ];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
//       }
//     });

//     console.log("newErrors")
//     console.log(newErrors)
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value, min, max } = e.target;
//     const minValue = parseFloat(min);
//     const maxValue = parseFloat(max);
//     const numericValue = parseFloat(value);

//     if (!isNaN(numericValue)) {
//       // Allow numbers up to one decimal place
//       const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

//       if (!decimalPrecisionCheck.test(numericValue.toString())) {
//         setErrors({
//           ...errors,
//           [name]: "Only up to one decimal place allowed.",
//         });

//         setInputState({
//           ...inputState,
//           [name]: "error",
//         });
//       } else if (numericValue < minValue) {
//         setErrors({
//           ...errors,
//           [name]: `Min limit ${minValue}`,
//         });

//         setInputState({
//           ...inputState,
//           [name]: "error",
//         });
//       } else if (numericValue > maxValue) {
//         setErrors({
//           ...errors,
//           [name]: `Max limit ${maxValue}`,
//         });

//         setInputState({
//           ...inputState,
//           [name]: "error",
//         });
//       } else {
//         setErrors({
//           ...errors,
//           [name]: "",
//         });

//         setFormData({
//           ...formData,
//           [name]: numericValue,
//         });

//         setInputState({
//           ...inputState,
//           [name]: "success",
//         });
//       }
//     } else {
//       setErrors({});
//       setFormData({
//         ...formData,
//         [name]: 0,
//       });

//       setInputState({
//         ...inputState,
//         [name]: "",
//       });
//     }
//   };

//   const [loading, setLoading] = useState(false);

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     const updatedFormData = {
//       ...formData,

//       totalperformance_emp: (
//         (parseFloat(formData.accuracy_emp) || 0) +
//         (parseFloat(formData.speedlyWork_emp) || 0) +
//         (parseFloat(formData.SelfInitiative_emp) || 0) +
//         (parseFloat(formData.responsbilityaccountability_emp) || 0) +
//         (parseFloat(formData.independentWorking_emp) || 0) +
//         (parseFloat(formData.decisonMakingCapability_emp) || 0)
//       ).toFixed(1),

//       totaldecipline_emp: (
//         (parseFloat(formData.punctuality_emp) || 0) +
//         (parseFloat(formData.teamwork_emp) || 0) +
//         (parseFloat(formData.loyalitytowardsWork_emp) || 0) +
//         (parseFloat(formData.dedicationtowardsWork_emp) || 0) +
//         (parseFloat(formData.obeideintorLeadership_emp) || 0)
//       ).toFixed(1),

//       total_emp: (
//         (parseFloat(formData.accuracy_emp) || 0) +
//         (parseFloat(formData.speedlyWork_emp) || 0) +
//         (parseFloat(formData.SelfInitiative_emp) || 0) +
//         (parseFloat(formData.responsbilityaccountability_emp) || 0) +
//         (parseFloat(formData.independentWorking_emp) || 0) +
//         (parseFloat(formData.decisonMakingCapability_emp) || 0) +
//         (parseFloat(formData.punctuality_emp) || 0) +
//         (parseFloat(formData.teamwork_emp) || 0) +
//         (parseFloat(formData.loyalitytowardsWork_emp) || 0) +
//         (parseFloat(formData.dedicationtowardsWork_emp) || 0) +
//         (parseFloat(formData.obeideintorLeadership_emp) || 0)
//       ).toFixed(1),

//       emp_update_datetime: new Date().toISOString(),
//     };


//     if (validateForm()) {

//       console.log("updatedFormData")
//       console.log(updatedFormData)

//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please wait...");
//       let ress = await axios.post(`${BASE_URL}/wfm/appraisalspost/`, updatedFormData);
//       if (ress.status === 200) {
//         window.location.reload();
//         handleClose();
//       } else {
//         alert(ress);
//       }
//       try {

//         // alert("appraisalspost");
//       } catch (err) {
//         handleAllError(err);
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   return (
//     <>
//       <button title="Upload Self Appraisal Ratings" className="upload-svg" onClick={handleShow}>
//         <AddwithWhiteCircle /> {" "}Self Appraisal
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title>Employee Self Appraisal "{formattedDateLong(i?.rating_period_start)} to {formattedDateLong(i?.rating_period_end)}" Ratings Upload</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

//           <form className="register-form">
//             <div className="flex-row justify-center">
//               <table className="nested-table-lightblue width-40vw">
//                 <thead>
//                   <tr>
//                     <th className="align-center">Rating Analysis</th>
//                     <th colSpan={2} className="align-center">Total Rating Marks</th>
//                     <th className="align-center width-5vw">Rating</th>
//                   </tr>
//                   <tr>
//                     <th className="align-center"></th>
//                     <th className="align-center">+VE Marks</th>
//                     <th className="align-center">-VE Marks</th>
//                     <th className="align-center"></th>
//                   </tr>
//                   <tr>
//                     <th colSpan={4} className="align-leftt">PERFORMANCE</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <React.Fragment>
//                     {[
//                       { label: "Accuracy", name: "accuracy_emp", min: -20, max: 20 },
//                       { label: "Speedly Work", name: "speedlyWork_emp", min: -10, max: 10 },
//                       { label: "Self Initiative", name: "SelfInitiative_emp", min: -15, max: 15 },
//                       { label: "Responsibility & Accountability", name: "responsbilityaccountability_emp", min: -10, max: 10 },
//                       { label: "Independent Working", name: "independentWorking_emp", min: -5, max: 5 },
//                       { label: "Decision Making Capability", name: "decisonMakingCapability_emp", min: -10, max: 10 },
//                     ].map(({ label, name, min, max }) => (
//                       <tr key={name}>
//                         <td className="text-center">{label}</td>
//                         <td className="text-center">{max}</td>
//                         <td className="text-center">{min}</td>
//                         <td>
//                           <input
//                             type="number"
//                             step={0}
//                             min={min}
//                             max={max}
//                             name={name}
//                             placeholder="Enter Rating"
//                             value={formData[name]}
//                             onChange={handleInputChange}
//                             onWheel={(e) => e.target.blur()}
//                             className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
//                           />
//                           <div className="align-center">
//                             {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <th className="align-right"></th>
//                       <th className="align-center">70</th>
//                       <th className="align-center">-70</th>
//                       <th className="align-right">
//                         {(
//                           formData.accuracy_emp +
//                           formData.speedlyWork_emp +
//                           formData.SelfInitiative_emp +
//                           formData.responsbilityaccountability_emp +
//                           formData.independentWorking_emp +
//                           formData.decisonMakingCapability_emp
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                     <tr>
//                       <th colSpan={4} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
//                     </tr>
//                     {[
//                       { label: "Punctuality", name: "punctuality_emp", min: -5, max: 5 },
//                       { label: "Teamwork", name: "teamwork_emp", min: -5, max: 5 },
//                       { label: "Loyalty Towards Work", name: "loyalitytowardsWork_emp", min: -5, max: 5 },
//                       { label: "Dedication Towards Work", name: "dedicationtowardsWork_emp", min: -5, max: 5 },
//                       { label: "Obedient & Leadership", name: "obeideintorLeadership_emp", min: -10, max: 10 }
//                     ].map(({ label, name, min, max }) => (
//                       <tr key={name}>
//                         <td className="text-center">{label}</td>
//                         <td className="text-center">{max}</td>
//                         <td className="text-center">{min}</td>
//                         <td>
//                           <input
//                             type="number"
//                             step={0}
//                             min={min}
//                             max={max}
//                             name={name}
//                             placeholder="Enter Rating"
//                             value={formData[name]}
//                             onChange={handleInputChange}
//                             onWheel={(e) => e.target.blur()}
//                             className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
//                           />
//                           <div className="align-center">
//                             {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <th className="align-right"></th>
//                       <th className="align-center">30</th>
//                       <th className="align-center">-30</th>
//                       <th className="align-right">
//                         {(
//                           formData.punctuality_emp +
//                           formData.teamwork_emp +
//                           formData.loyalitytowardsWork_emp +
//                           formData.dedicationtowardsWork_emp +
//                           formData.obeideintorLeadership_emp
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                     <tr>
//                       <th className="align-right">Total Rating Marks</th>
//                       <th className="align-center">100</th>
//                       <th className="align-center">-100</th>
//                       <th className="align-right">
//                         {(
//                           formData.accuracy_emp +
//                           formData.speedlyWork_emp +
//                           formData.SelfInitiative_emp +
//                           formData.responsbilityaccountability_emp +
//                           formData.independentWorking_emp +
//                           formData.decisonMakingCapability_emp +
//                           formData.punctuality_emp +
//                           formData.teamwork_emp +
//                           formData.loyalitytowardsWork_emp +
//                           formData.dedicationtowardsWork_emp +
//                           formData.obeideintorLeadership_emp
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                   </React.Fragment>
//                 </tbody>
//               </table>
//             </div>

//             <div className="float-right">
//               <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
//                 <input
//                   type="checkbox"
//                   checked={submitConfirmation}
//                   onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
//                 />
//                 <></>
//                 <span>
//                   Click to Confirm and Sumbit
//                 </span>
//               </label>
//             </div>
//             <br />

//             <div className="button-models">
//               <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                 Cancel
//               </button>

//               {submitConfirmation ?
//                 <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
//                   {loading ? 'Submiting...' : 'Submit'}
//                 </button>
//                 :
//                 <button
//                   className={`model-button model-button-cancel  font-weight500`}
//                   disabled={!submitConfirmation}
//                 >
//                   {"Confirmation Needed"}
//                 </button>
//               }
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };





// ─── Add these to your EXISTING import block at the very top of the file ───
// (keep your current imports for React, useState, useEffect, axios, BASE_URL,
//  Modal, ToastContainer, toast, AddwithWhiteCircle, etc. — just add these two lines)


// ─── Module-level constants (declared OUTSIDE the component, only once) ───

// Fallback descriptions pulled from the official appraisal criteria sheet.
// Used whenever a criterion doesn't already carry its own `data.description`.


// Accent colors per section, keyed by (lowercased) section name.





// ─── Your component (unchanged logic, only the three consts removed from inside) ───

// const UploadAppraisalDetailsByEmployee = ({ i, setupId }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [fetching, setFetching] = useState(false);
//   const [submitConfirmation, setSubmitConfirmation] = useState(false);

//   // Dynamic Data States
//   const [appraisalTypes, setAppraisalTypes] = useState([]);
//   const [appraisalSubDetails, setAppraisalSubDetails] = useState({});
//   const [formData, setFormData] = useState({});
//   const [errors, setErrors] = useState({});

//   // Employee details from session
//   const empCode = sessionStorage.getItem("emp_code");
//   const subCompany = sessionStorage.getItem("company_id");

//   // Fetch Appraisal Data when Modal Opens
//   useEffect(() => {
//     if (show && subCompany) {
//       fetchAllAppraisalData();
//     }
//   }, [show, subCompany]);

//   const fetchAllAppraisalData = async () => {
//     setFetching(true);
//     try {
//       // 1. Fetch Appraisal Types
//       const typesRes = await axios.get(`${BASE_URL}/wfm/appraisal-types-by-subcompany/${subCompany}/`);
//       const types = typesRes.data || [];
//       setAppraisalTypes(types);

//       // 2. Fetch Sub Details for each Type
//       const subDetailsMap = {};
//       const initialFormState = {};

//       for (const type of types) {
//         const subRes = await axios.get(`${BASE_URL}/wfm/appraisal-sub-details-by-appraisal-type/${type.id}/`);
//         subDetailsMap[type.id] = subRes.data || [];

//         // Initialize form data with 0 for each sub-detail
//         (subRes.data || []).forEach(detail => {
//           initialFormState[detail.id] = "";
//         });
//       }

//       setAppraisalSubDetails(subDetailsMap);
//       setFormData(initialFormState);
//     } catch (error) {
//       console.error("Error fetching appraisal data:", error);
//       toast.error("Failed to load appraisal form data.");
//     } finally {
//       setFetching(false);
//     }
//   };

//   const handleShow = () => setShow(true);

//   const handleClose = () => {
//     setShow(false);
//     setSubmitConfirmation(false);
//     setFormData({});
//     setErrors({});
//   };

//   const handleInputChange = (e, detailId, maxVal) => {
//     const value = e.target.value;
//     const numericValue = parseFloat(value);

//     if (value === "") {
//       setFormData({ ...formData, [detailId]: "" });
//       setErrors({ ...errors, [detailId]: "Required" });
//       return;
//     }

//     if (!isNaN(numericValue)) {
//       const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

//       if (!decimalPrecisionCheck.test(value)) {
//         setErrors({ ...errors, [detailId]: "Only up to one decimal place." });
//       } else if (numericValue < 0) {
//         setErrors({ ...errors, [detailId]: "Cannot be negative" });
//       } else if (numericValue > maxVal) {
//         setErrors({ ...errors, [detailId]: `Max limit ${maxVal}` });
//       } else {
//         const newErrors = { ...errors };
//         delete newErrors[detailId];
//         setErrors(newErrors);
//       }
//       setFormData({ ...formData, [detailId]: numericValue });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] === "" || formData[key] === undefined) {
//         newErrors[key] = "Required";
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (Object.keys(errors).length > 0 || !validateForm()) {
//       toast.error("Please fix errors before submitting.");
//       return;
//     }

//     setLoading(true);
//     const loadingToastId = toast.loading("Submitting Ratings...");

//     // Constructing payload as an array of objects based on API requirements
//     const payload = Object.keys(formData).map((subDetailId) => ({
//       employee: empCode,
//       appraisal_sub_details: subDetailId,
//       employee_marks: formData[subDetailId].toString(),
//       created_by: empCode, // Adjust based on your auth logic
//       updated_by: empCode,
//       financial_period_start: i?.rating_period_start,
//       financial_period_end: i?.rating_period_end,
//     }));

//     try {
//       // Adjust the endpoint to the one that accepts the array
//       const response = await axios.post(`${BASE_URL}/wfm/employee-appraisal-rating-bulk/`, payload);

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Appraisal submitted successfully!");

//         handleClose();
//       } else {
//         toast.error("Something went wrong.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error(err?.response?.data?.message || "Failed to submit ratings.");
//     } finally {
//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     }
//   };

//   // Helper to extract global rating legend from the first available sub-detail
//   const renderRatingLegend = () => {
//     let ratingSchema = null;

//     // Find the first sub-detail that has rating guidelines to show as legend
//     for (const key in appraisalSubDetails) {
//       const detailsArray = appraisalSubDetails[key];
//       if (detailsArray.length > 0 && detailsArray[0].appraisal_rating_details?.data) {
//         ratingSchema = detailsArray[0].appraisal_rating_details.data;
//         break;
//       }
//     }

//     if (!ratingSchema) return null;

//     // Filter out totalRating to just loop through string labels like "Good", "Fair"
//     const validKeys = Object.keys(ratingSchema).filter(k => k !== 'totalRating');

//     return (
//       <div className="rating-legend-container mt-4 p-3 bg-light rounded border">
//         <h6 className="mb-3 text-muted fw-bold">Score Guidelines</h6>
//         <div className="d-flex flex-wrap gap-4">
//           {validKeys.map((key) => {
//             const range = ratingSchema[key];
//             return (
//               <div key={key} className="d-flex align-items-center">
//                 <span className="fw-bold me-2">{key}:</span>
//                 <span className="badge bg-secondary">
//                   {range.max} - {range.min}
//                 </span>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <>
//       <button title="Upload Self Appraisal Ratings" className="upload-svg" onClick={handleShow}>
//         <AddwithWhiteCircle /> Self Appraisal
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model modal-xl" backdrop="static">
//         <Modal.Header closeButton className="">
//           <Modal.Title>
//             Self Appraisal : {i?.rating_period_start} to {i?.rating_period_end}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="bg-light">
//           <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

//           {fetching ? (
//             <div className="text-center p-5">
//               <div className="spinner-border text-primary" role="status"></div>
//               <p className="mt-2 text-muted">Loading appraisal criteria...</p>
//             </div>
//           ) : (
//             <form className="register-form p-2">

//               <div className="row g-3 mb-4">
//                 <div className="col-md-4">
//                   <div className="card h-100 shadow-sm border-0" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//                     <div className="card-body text-white">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
//                           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
//                           </svg>
//                         </div>
//                         <div>
//                           <h5 className="mb-0 fw-bold">Performance</h5>
//                           <small className="opacity-75">Criteria Categories</small>
//                         </div>
//                       </div>
//                       <div className="d-flex justify-content-between align-items-center">
//                         <span className="fs-6">Total Sections</span>
//                         <span className="badge bg-white text-primary fs-6 px-3 py-2">{appraisalTypes.length}</span>
//                       </div>
//                       <div className="d-flex justify-content-between align-items-center mt-2">
//                         <span className="fs-6">Criteria Count</span>
//                         <span className="badge bg-white text-primary fs-6 px-3 py-2">
//                           {appraisalTypes.reduce((acc, type) => acc + (appraisalSubDetails[type.id] || []).length, 0)}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-md-4">
//                   <div className="card h-100 shadow-sm border-0" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
//                     <div className="card-body text-white">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
//                           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <circle cx="12" cy="12" r="10" />
//                             <path d="M12 6v6l4 2" />
//                           </svg>
//                         </div>
//                         <div>
//                           <h5 className="mb-0 fw-bold">Weightage</h5>
//                           <small className="opacity-75">Maximum Marks</small>
//                         </div>
//                       </div>
//                       <div className="d-flex justify-content-between align-items-center">
//                         <span className="fs-6">Total Weightage</span>
//                         <span className="badge bg-white text-danger fs-6 px-3 py-2">100</span>
//                       </div>
//                       <div className="progress mt-3" style={{ height: '8px' }}>
//                         <div className="progress-bar bg-white" style={{ width: '100%' }}></div>
//                       </div>
//                       <small className="opacity-75 mt-2 d-block">100% Complete</small>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-md-4">
//                   <div className="card h-100 shadow-sm border-0" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
//                     <div className="card-body text-white">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="bg-white bg-opacity-25 rounded-circle p-3 me-3">
//                           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <path d="M12 2v4M12 22v-4M4 12H2M6 12H4M20 12h-2M22 12h-2M19.07 4.93l-2.83 2.83M4.93 19.07l2.83-2.83M19.07 19.07l-2.83-2.83M4.93 4.93l2.83 2.83" />
//                             <circle cx="12" cy="12" r="3" />
//                           </svg>
//                         </div>
//                         <div>
//                           <h5 className="mb-0 fw-bold">Self Rating</h5>
//                           <small className="opacity-75">Your Assessment</small>
//                         </div>
//                       </div>
//                       <div className="d-flex justify-content-between align-items-center">
//                         <span className="fs-6">Total Rated</span>
//                         <span className="badge bg-white text-primary fs-6 px-3 py-2">
//                           {Object.keys(formData).filter(key => formData[key] !== "" && formData[key] !== undefined).length}
//                         </span>
//                       </div>
//                       <div className="d-flex justify-content-between align-items-center mt-2">
//                         <span className="fs-6">Pending</span>
//                         <span className="badge bg-white text-primary fs-6 px-3 py-2">
//                           {appraisalTypes.reduce((acc, type) => acc + (appraisalSubDetails[type.id] || []).length, 0) -
//                             Object.keys(formData).filter(key => formData[key] !== "" && formData[key] !== undefined).length}
//                         </span>
//                       </div>
//                       {submitConfirmation && (
//                         <div className="mt-2">
//                           <span className="badge bg-success text-white fs-6 px-3 py-2">
//                             ✓ Ready to Submit
//                           </span>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="table table-bordered table-hover bg-white shadow-sm rounded">
//                   <thead className="table-dark text-center">
//                     <tr>
//                       <th className="align-middle w-50 text-start ps-4">Performance Criteria</th>
//                       <th className="align-middle text-center w-25">Weightage (Out Of)</th>
//                       <th className="align-middle text-center w-25">Your Self Rating</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {appraisalTypes.map((type) => {
//                       const sectionDetails = appraisalSubDetails[type.id] || [];
//                       const totalWeightage = sectionDetails.reduce((sum, detail) =>
//                         sum + parseInt(detail.appraisal_rating_details?.out_of || detail.data?.weightage || 10), 0
//                       );

//                       return (
//                         <React.Fragment key={type.id}>
//                           {/* Section Header */}
//                           <tr className="table-secondary">
//                             <td colSpan={3} className="fw-bold fs-5 text-uppercase ps-3 py-3">
//                               {type.name}
//                             </td>
//                           </tr>

//                           {/* Section Sub Details */}
//                           {sectionDetails.map((detail) => {
//                             const maxMarks = parseInt(detail.appraisal_rating_details?.out_of || detail.data?.weightage || 10);

//                             return (
//                               <tr key={detail.id}>
//                                 <td className="align-middle ps-4">
//                                   <div className="d-flex align-items-center">
//                                     <span className="fw-semibold">{detail.name}</span>
//                                     {detail.data?.description && (
//                                       <OverlayTrigger
//                                         placement="right"
//                                         overlay={
//                                           <Tooltip className="custom-tooltip">
//                                             <div className="p-2" style={{ maxWidth: '300px' }}>
//                                               <strong>Description:</strong>
//                                               <p className="mb-0 mt-1">{detail.data.description}</p>
//                                             </div>
//                                           </Tooltip>
//                                         }
//                                       >
//                                         <span className="ms-2 text-primary cursor-pointer">
//                                           <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                             <circle cx="12" cy="12" r="10" />
//                                             <path d="M12 16v-4M12 8h.01" />
//                                           </svg>
//                                         </span>
//                                       </OverlayTrigger>
//                                     )}
//                                     {detail.data?.mandatory && (
//                                       <span className="ms-2">
//                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2">
//                                           <circle cx="12" cy="12" r="10" />
//                                           <path d="M12 8v8M8 12h8" />
//                                         </svg>
//                                       </span>
//                                     )}
//                                   </div>
//                                 </td>

//                                 <td className="align-middle text-center fw-bold text-muted">
//                                   <span className="badge bg-secondary bg-opacity-10 text-secondary px-3 py-2 fs-6">
//                                     {maxMarks}
//                                   </span>
//                                 </td>

//                                 <td className="align-middle text-center">
//                                   <input
//                                     type="number"
//                                     step={0.1}
//                                     min={0}
//                                     max={maxMarks}
//                                     placeholder={`0 - ${maxMarks}`}
//                                     value={formData[detail.id] === undefined ? "" : formData[detail.id]}
//                                     onChange={(e) => handleInputChange(e, detail.id, maxMarks)}
//                                     onWheel={(e) => e.target.blur()}
//                                     className={`form-control text-center mx-auto w-75 ${errors[detail.id] ? 'is-invalid' : ''
//                                       } ${formData[detail.id] !== undefined && formData[detail.id] !== "" ? 'border-success' : ''}`}
//                                     style={{
//                                       transition: 'all 0.3s ease',
//                                       borderWidth: '2px'
//                                     }}
//                                   />
//                                   {errors[detail.id] && (
//                                     <div className="invalid-feedback d-block fw-bold text-danger">
//                                       {errors[detail.id]}
//                                     </div>
//                                   )}
//                                 </td>
//                               </tr>
//                             );
//                           })}

//                           {/* Section Footer - Shows Total Weightage */}
//                           <tr className="table-info">
//                             <td colSpan={3} className="text-end pe-4 py-2 fw-semibold">
//                               <span className="badge bg-opacity-10 text-primary px-4 py-2">
//                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="me-2">
//                                   <circle cx="12" cy="12" r="10" />
//                                   <path d="M12 6v6l4 2" />
//                                 </svg>
//                                 Section Total Weightage: {totalWeightage}
//                               </span>
//                             </td>
//                           </tr>
//                         </React.Fragment>
//                       );
//                     })}

//                   </tbody>
//                 </table>
//               </div>

//               {/* Rating Legend Cards */}
//               <div className="row g-3 mb-4">
//                 <div className="col-12">
//                   <div className="card shadow-sm">
//                     <div className="card-body">
//                       <h6 className="fw-bold mb-3">📊 Rating Legend</h6>
//                       <div className="row g-2">
//                         <div className="col-md-2">
//                           <div className="p-2 text-center rounded" style={{ background: '#28a745', color: 'white' }}>
//                             <strong>Excellent</strong>
//                             <div className="small">10-9</div>
//                           </div>
//                         </div>
//                         <div className="col-md-2">
//                           <div className="p-2 text-center rounded" style={{ background: '#17a2b8', color: 'white' }}>
//                             <strong>Good</strong>
//                             <div className="small">8-7</div>
//                           </div>
//                         </div>
//                         <div className="col-md-2">
//                           <div className="p-2 text-center rounded" style={{ background: '#ffc107', color: 'dark' }}>
//                             <strong>Fair</strong>
//                             <div className="small">7-5</div>
//                           </div>
//                         </div>
//                         <div className="col-md-2">
//                           <div className="p-2 text-center rounded" style={{ background: '#fd7e14', color: 'white' }}>
//                             <strong>Poor</strong>
//                             <div className="small">5-3</div>
//                           </div>
//                         </div>
//                         <div className="col-md-2">
//                           <div className="p-2 text-center rounded" style={{ background: '#dc3545', color: 'white' }}>
//                             <strong>Worst</strong>
//                             <div className="small">3-0</div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Enhanced Submission Toggle Area */}
//               <div className="mt-4 p-4 border rounded bg-white shadow-sm">
//                 <div className="row align-items-center">
//                   <div className="col-md-8">
//                     <div className="form-check form-switch fs-5">
//                       <input
//                         className="form-check-input cursor-pointer"
//                         type="checkbox"
//                         id="confirmSubmitSwitch"
//                         checked={submitConfirmation}
//                         onChange={() => setSubmitConfirmation(!submitConfirmation)}
//                         style={{ width: '3em', height: '1.5em' }}
//                       />
//                       <label className="form-check-label fw-bold ms-3 text-dark" htmlFor="confirmSubmitSwitch">
//                         <span className="d-flex align-items-center">
//                           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={submitConfirmation ? '#28a745' : '#6c757d'} strokeWidth="2" className="me-2">
//                             <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//                             <polyline points="22 4 12 14.01 9 11.01" />
//                           </svg>
//                           I have reviewed my ratings and confirm they are accurate to the best of my knowledge.
//                         </span>
//                       </label>
//                     </div>
//                   </div>
//                   <div className="col-md-4 text-end">
//                     <div className="d-flex gap-3 justify-content-end">
//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary px-4 fw-bold"
//                         onClick={handleClose}
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         type="button"
//                         className={`btn px-5 fw-bold ${submitConfirmation ? 'btn-success' : 'btn-secondary'
//                           }`}
//                         onClick={handleFormSubmit}
//                         disabled={!submitConfirmation || loading}
//                       >
//                         {loading ? (
//                           <>
//                             <span className="spinner-border spinner-border-sm me-2" />
//                             Submitting...
//                           </>
//                         ) : (
//                           <>
//                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="me-2">
//                               <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34" />
//                               <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
//                             </svg>
//                             Submit Appraisal
//                           </>
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


const getRatingLabel = (value, maxVal) => {
  if (
    value === "" ||
    value === undefined ||
    value === null ||
    Number(value) < 0 ||
    !maxVal
  )
    return null;

  const pct = (Number(value) / maxVal) * 100;

  if (pct >= 90)
    return {
      label: "Excellent",
      bg: "#EAFBF2",
      color: "#15803D",
      border: "#BBF7D0",
      textColor: "#fff"
    };

  if (pct >= 70)
    return {
      label: "Good",
      bg: "#EAF3FF",
      color: "#2563EB",
      border: "#BFDBFE",
      textColor: "#fff"
    };

  if (pct >= 45)
    return {
      label: "Fair",
      bg: "#FFF8E7",
      color: "#D97706",
      border: "#FDE68A",
      textColor: "#fff"
    };

  if (pct >= 30)
    return {
      label: "Poor",
      bg: "#FFF2E8",
      color: "#EA580C",
      border: "#FED7AA",
      textColor: "#fff"
    };

  return {
    label: "Worst",
    bg: "#FDECEC",
    color: "#DC2626",
    border: "#FECACA",
    textColor: "#fff"
  };
};

const SectionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
  </svg>
);

const CardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

const OverallIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 0 1-10 0V4z" />
    <path d="M17 5h3a2 2 0 0 1-2 4M7 5H4a2 2 0 0 0 2 4" />
  </svg>
);

const UploadAppraisalDetailsByEmployee = ({ i, setupId, onSuccess }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  // Dynamic Data States
  const [appraisalTypes, setAppraisalTypes] = useState([]);
  const [appraisalSubDetails, setAppraisalSubDetails] = useState({});
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  // Employee details from session
  const empCode = sessionStorage.getItem("emp_code");
  const subCompany = sessionStorage.getItem("company_id");

  // Fetch Appraisal Data when Modal Opens
  useEffect(() => {
    if (show && subCompany) {
      fetchAllAppraisalData();
    }
  }, [show, subCompany]);

  const fetchAllAppraisalData = async () => {
    setFetching(true);
    try {
      // 1. Fetch Appraisal Types
      const typesRes = await axios.get(`${BASE_URL}/wfm/appraisal-types-by-subcompany/${subCompany}/`);
      const types = typesRes.data || [];
      setAppraisalTypes(types);

      // 2. Fetch Sub Details for each Type
      const subDetailsMap = {};
      const initialFormState = {};

      for (const type of types) {
        const subRes = await axios.get(`${BASE_URL}/wfm/appraisal-sub-details-by-appraisal-type/${type.id}/`);
        subDetailsMap[type.id] = subRes.data || [];

        // Initialize form data with 0 for each sub-detail
        (subRes.data || []).forEach(detail => {
          initialFormState[detail.id] = "";
        });
      }

      setAppraisalSubDetails(subDetailsMap);
      setFormData(initialFormState);
    } catch (error) {
      console.error("Error fetching appraisal data:", error);
      toast.error("Failed to load appraisal form data.");
    } finally {
      setFetching(false);
    }
  };

  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
    setSubmitConfirmation(false);
    setFormData({});
    setErrors({});
  };

  // Same validation semantics as before — only the control changed from <input type="number">
  // to <select>, so the incoming value is always a clean string ("", "0", "7.5"...).
  const handleInputChange = (e, detailId, maxVal, type) => {
    if (!isEmployeeEditable(type)) {
      return;
    }
    const value = e.target.value;
    const numericValue = parseFloat(value);

    if (value === "") {
      setFormData({ ...formData, [detailId]: "" });
      setErrors({ ...errors, [detailId]: "Required" });
      return;
    }

    if (!isNaN(numericValue)) {
      if (numericValue < 0) {
        setErrors({ ...errors, [detailId]: "Cannot be negative" });
      } else if (numericValue > maxVal) {
        setErrors({ ...errors, [detailId]: `Max limit ${maxVal}` });
      } else {
        const newErrors = { ...errors };
        delete newErrors[detailId];
        setErrors(newErrors);
      }
      setFormData({ ...formData, [detailId]: numericValue });
    }
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   Object.keys(formData).forEach((key) => {
  //     if (formData[key] === "" || formData[key] === undefined) {
  //       newErrors[key] = "Required";
  //     }
  //   });

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validateForm = () => {
    const newErrors = {};

    appraisalTypes.forEach((type) => {
      // Skip non-editable sections
      if (!isEmployeeEditable(type)) return;

      (appraisalSubDetails[type.id] || []).forEach((detail) => {
        const value = formData[detail.id];

        if (value === "" || value === undefined || value === null) {
          newErrors[detail.id] = "Required";
        }
      });
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (Object.keys(errors).length > 0 || !validateForm()) {
      toast.error("Please fix errors before submitting.");
      return;
    }

    setLoading(true);
    const loadingToastId = toast.loading("Submitting Ratings...");

    // Constructing payload as an array of objects based on API requirements
    // const payload = Object.keys(formData).map((subDetailId) => ({
    //   employee: empCode,
    //   appraisal_sub_details: subDetailId,
    //   employee_marks: formData[subDetailId].toString(),
    //   created_by: empCode, // Adjust based on your auth logic
    //   updated_by: empCode,
    //   financial_period_start: i?.rating_period_start,
    //   financial_period_end: i?.rating_period_end,
    // }));

    const payload = appraisalTypes.flatMap((type) => {
      if (!isEmployeeEditable(type)) return [];

      return (appraisalSubDetails[type.id] || []).map((detail) => ({
        employee: empCode,
        appraisal_sub_details: detail.id,
        employee_marks: String(formData[detail.id] || 0),
        created_by: empCode,
        updated_by: empCode,
        financial_period_start: i?.rating_period?.rating_period_start,
        financial_period_end: i?.rating_period?.rating_period_end,
      }));
    });

    try {
      // Adjust the endpoint to the one that accepts the array
      const response = await axios.post(`${BASE_URL}/wfm/employee-appraisal-rating-bulk/`, payload);

      if (response.status === 200 || response.status === 201) {
        toast.success("Appraisal submitted successfully!");
        onSuccess?.(response.data);
        handleClose();
      } else {
        toast.error("Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to submit ratings.");
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  // Helper: max marks for a sub-detail (same fallback chain as original)
  const getMaxMarks = (detail) =>
    parseInt(detail.appraisal_rating_details?.out_of || detail.data?.weightage || 10);

  // Helper: generate select options for a given max value, in steps of 0.5
  const getRatingOptions = (maxVal) => {
    const options = [];
    for (let v = 0; v <= maxVal; v += 0.5) {
      options.push(Number(v.toFixed(1)));
    }
    return options;
  };

  // Per-section (appraisal type) scored total / max total
  const getSectionTotals = (type) => {
    const sectionDetails = appraisalSubDetails[type.id] || [];
    const max = sectionDetails.reduce((sum, d) => sum + getMaxMarks(d), 0);
    const scored = sectionDetails.reduce((sum, d) => {
      const v = formData[d.id];
      return sum + (v === "" || v === undefined ? 0 : Number(v));
    }, 0);
    return { scored, max };
  };

  // Overall totals across all sections
  const getOverallTotals = () => {
    return appraisalTypes.reduce(
      (acc, type) => {
        const { scored, max } = getSectionTotals(type);
        return { scored: acc.scored + scored, max: acc.max + max };
      },
      { scored: 0, max: 0 }
    );
  };

  // Collect distinct rating schemas by their "out_of" value, for the legend block.
  const getLegendSchemas = () => {
    const seen = {};
    for (const key in appraisalSubDetails) {
      for (const detail of appraisalSubDetails[key]) {
        const schema = detail.appraisal_rating_details?.data;
        const outOf = detail.appraisal_rating_details?.out_of;
        if (schema && outOf && !seen[outOf]) {
          seen[outOf] = schema;
        }
      }
    }
    return seen; // { "10": {...}, "5": {...} }
  };

  const renderRatingLegend = () => {
    const schemas = getLegendSchemas();
    const outOfValues = Object.keys(schemas);
    if (outOfValues.length === 0) return null;

    return (
      <div className="sar-legend-box">
        <div className="sar-legend-title">Rating Scale</div>
        {outOfValues.map((outOf) => {
          const schema = schemas[outOf];
          const validKeys = Object.keys(schema).filter((k) => k !== "totalRating");
          return (
            <div className="sar-legend-row" key={outOf}>
              <span className="sar-legend-scale-label">Out of {outOf}</span>
              {validKeys.map((key) => {
                const range = schema[key];
                const tag = getRatingLabel(range.max, Number(outOf)) || { color: "#6c757d" };
                return (
                  <span key={key} className="sar-legend-pill" style={{
                    background: tag.bg,
                    color: tag.color,
                    border: `1px solid ${tag.border}`,
                  }}>
                    {range.min}-{range.max} {key}
                  </span>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  const overall = getOverallTotals();
  const overallPct = overall.max ? Math.round((overall.scored / overall.max) * 100) : 0;
  const overallTag = getRatingLabel(overall.scored, overall.max);
  const totalRatedCount = Object.keys(formData).filter(
    (key) => formData[key] !== "" && formData[key] !== undefined
  ).length;
  const totalFieldsCount = Object.keys(formData).length;


  const getSectionIcon = (sectionName, size = 26) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return <PerformanceIcon size={size} color="#2563EB" />;

      case "discipline & behaviour":
      case "discipline and behaviour":
        return <DisciplineIcon size={size} color="#16A34A" />;

      case "team performance":
        return <TeamPerformanceIcon size={size} color="#7C3AED" />;

      default:
        return <PerformanceIcon size={size} color="#2563EB" />;
    }
  };

  const getSectionColor = (sectionName) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return "#2563EB";

      case "discipline & behaviour":
      case "discipline and behaviour":
        return "#16A34A";

      case "team performance":
        return "#7C3AED";

      default:
        return "#2563EB";
    }
  };

  const isEmployeeEditable = (type) => {
    const section = type?.name?.trim()?.toLowerCase();

    return section === "performance";
  };

  return (
    <>
      <button title="Upload Self Evaluation Ratings" className="flex items-center font-size-text gap-2 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition" onClick={handleShow}>
        {/* <AddwithWhiteCircle />  */}
        <AddwithBlueCircle />
        {" "}Self Evaluation
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model modal-xl" backdrop="static">
        <Modal.Header closeButton className="sar-modal-header">
          <div>
            <Modal.Title className="sar-modal-title">Self evaluation ratings {" "} - {formattedDateLong(i?.rating_period?.rating_period_start)} to {formattedDateLong(i?.rating_period?.rating_period_end)}</Modal.Title>
            <div className="sar-modal-subtitle">
              Rate yourself on each parameter honestly and to the best of your ability.

            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="bg-light">
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          {fetching ? (
            <div className="text-center p-5">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-2 text-muted">Loading appraisal criteria...</p>
            </div>
          ) : (
            <form className="register-form p-2">

              {/* ---- Summary cards ---- */}
              <div className="sar-summary-row">
                {appraisalTypes.map((type) => {
                  const { scored, max } = getSectionTotals(type);
                  const pct = max ? Math.round((scored / max) * 100) : 0;
                  return (
                    <div className="sar-summary-card sar-card-neutral" key={type.id}>
                      <div
                        className="sar-card-icon"
                        style={{
                          background: `${getSectionColor(type.name)}15`,
                        }}
                      >
                        {getSectionIcon(type.name)}
                      </div>
                      <div className="sar-card-label">{type.name}</div>
                      {/* <div className="sar-card-score">
                        {scored.toFixed(1)} <small>/ {max}</small>
                      </div> */}
                      <div className="sar-card-score">
                        <span
                          className="sar-card-score-value"
                          style={{ color: getSectionColor(type.name) }}
                        >
                          {scored.toFixed(1)}
                        </span>

                        <small className="sar-card-score-max">
                          / {max}
                        </small>
                      </div>
                      {/* <div className="sar-card-progress-track">
                        <div
                          className="sar-card-progress-fill"
                          style={{ width: `${pct}%`, background: "rgb(37,118,188)" }}
                        />
                      </div> */}
                      <div className="sar-card-progress-track">
                        <div
                          className="sar-card-progress-fill"
                          style={{
                            width: `${pct}%`,
                            background: getSectionColor(type.name),
                          }}
                        />
                      </div>
                      <div className="sar-card-progress-pct">{pct}%</div>
                    </div>
                  );
                })}

                <div className="sar-summary-card sar-card-overall">
                  <div className="sar-card-icon">
                    <OverallIcon />
                  </div>
                  <div className="sar-card-label">Overall</div>
                  <div className="sar-card-score">
                    {overall.scored.toFixed(1)} <small>/ {overall.max}</small>
                  </div>
                  <div className="sar-card-progress-track">
                    <div
                      className="sar-card-progress-fill"
                      style={{ width: `${overallPct}%`, background: "#fff" }}
                    />
                  </div>
                  {overallTag && (
                    <span className="sar-card-badge" style={{ background: overallTag.color }}>
                      {overallTag.label}
                    </span>
                  )}
                </div>
              </div>

              {/* ---- Ratings table ---- */}
              <div className="sar-table-wrap">
                <table className="table sar-table mb-0">
                  <thead>

                    <tr>
                      <th className="w-25">Parameter</th>
                      <th className="w-25">Description</th>
                      <th className="text-center">Max marks</th>
                      <th className="text-center">Your rating</th>
                      <th className="text-center">Score</th>
                    </tr>
                  </thead>

                  <tbody>
                    {appraisalTypes.map((type) => {
                      const sectionDetails = appraisalSubDetails[type.id] || [];
                      const { scored, max } = getSectionTotals(type);

                      return (
                        <React.Fragment key={type.id}>
                          {/* Section Header */}
                          <tr className="sar-section-row">
                            <td colSpan={5}>
                              <span className="sar-section-icon">
                                <SectionIcon />
                              </span>
                              {type.name?.toUpperCase()}
                              {!isEmployeeEditable(type) && (
                                <span className="sar-lock-badge">
                                  🔒 View only
                                </span>
                              )}
                              {/* {type.view_only && <span className="sar-lock-badge">🔒 View only</span>} */}
                              <span className="sar-section-total-badge">
                                Total {scored.toFixed(1)} / {max}
                              </span>
                            </td>
                          </tr>

                          {/* Section Sub Details */}
                          {sectionDetails.map((detail) => {
                            const maxMarks = getMaxMarks(detail);
                            const currentValue = formData[detail.id];
                            const tag = getRatingLabel(currentValue, maxMarks);
                            const isFilled = currentValue !== "" && currentValue !== undefined;

                            return (
                              <tr key={detail.id} className="sar-param-row">
                                {/* <td>
                                  <span className="sar-param-name">{detail.name}
                                    {detail.data?.mandatory && (
                                      <span className="required">*</span>
                                    )}
                                  </span>
                                  {detail.data?.description && (
                                    <OverlayTrigger
                                      placement="right"
                                      overlay={
                                        <Tooltip className="custom-tooltip">
                                          <div className="p-2" style={{ maxWidth: "300px" }}>

                                            <p className="mb-0 mt-1">{detail.data.description}</p>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span className="sar-info-icon">
                                       
                                        <InfoIcon size={16} color="currentColor" />
                                      </span>
                                    </OverlayTrigger>
                                  )}

                                </td> */}

                                <td>
                                  <span className="sar-param-name">{detail.name}
                                    {detail.data?.mandatory && (
                                      <span className="required">*</span>
                                    )}
                                  </span>
                                </td>

                                <td className="sar-param-desc">
                                  {detail.data?.description || "-"}
                                </td>
                                <td className="text-center">
                                  <span className="sar-max-badge">{maxMarks}</span>
                                </td>

                                <td className="text-center">
                                  <select
                                    value={currentValue === undefined ? "" : currentValue}
                                    onChange={(e) => handleInputChange(e, detail.id, maxMarks, type)}
                                    // disabled={type.view_only}
                                    disabled={!isEmployeeEditable(type)}
                                    className={`sar-rating-select ${errors[detail.id] ? "sar-select-error" : isFilled ? "sar-select-filled" : ""
                                      }`}
                                  >
                                    <option value="">--</option>
                                    {getRatingOptions(maxMarks).map((opt) => (
                                      <option key={opt} value={opt}>
                                        {opt}
                                      </option>
                                    ))}
                                  </select>
                                  {/* {tag && (
                                    <span className="sar-rating-tag" style={{ color: tag.color }}>
                                      {tag.label}
                                    </span>
                                  )} */}
                                  {isEmployeeEditable(type) && tag && (
                                    <span
                                      className="sar-rating-tag"
                                      style={{
                                        color: tag.color,

                                      }}
                                    >
                                      {tag.label}
                                    </span>
                                  )}
                                  {errors[detail.id] && (
                                    <div className="sar-error-text">{errors[detail.id]}</div>
                                  )}
                                </td>

                                <td className="sar-score-cell">
                                  {isFilled ? Number(currentValue).toFixed(1) : "0.0"}
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}

                    {/* Grand total row */}
                    <tr className="sar-total-row">
                      <td colSpan={2}>TOTAL RATING MARKS</td>
                      <td className="text-center">{overall.max}</td>
                      <td className="text-center"></td>
                      <td className="text-center">
                        {overall.scored.toFixed(1)} / {overall.max}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* ---- Rating scale legend (driven by API data) ---- */}
              {renderRatingLegend()}

              {/* ---- Confirmation + actions ---- */}
              <div className="sar-confirm-box">
                <div className="form-check form-switch d-flex align-items-start">
                  <input
                    className="form-check-input cursor-pointer mt-1"
                    type="checkbox"
                    id="confirmSubmitSwitch"
                    checked={submitConfirmation}
                    onChange={() => setSubmitConfirmation(!submitConfirmation)}
                    style={{ width: "2.6em", height: "1.3em" }}
                  />
                  <label className="form-check-label ms-3" htmlFor="confirmSubmitSwitch">
                    <div className="sar-confirm-text">
                      I confirm that the above self evaluation ratings are accurate and complete.
                    </div>
                    <div className="sar-confirm-subtext">
                      Ratings cannot be edited once submitted for this stage.
                    </div>
                  </label>
                </div>
              </div>

              <div className="sar-footer-actions">
                <button type="button" className="sar-btn-cancel" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="sar-btn-submit"
                  onClick={handleFormSubmit}
                  disabled={!submitConfirmation || loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Submitting...
                    </>
                  ) : (
                    "Submit rating"
                  )}
                </button>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};








// const EditAppraisalDetailsByEmployee = ({ i, getDepartmentAppraisalData }) => {
//   const [show, setShow] = useState(false);

//   const handleShow = () => {
//     setFormData(i);
//     setShow(true);
//   }

//   const handleClose = () => {
//     setShow(false);
//   }

//   const [formData, setFormData] = useState({
//     emp_code: sessionStorage.getItem("emp_code"),

//     accuracy_emp: 0,
//     speedlyWork_emp: 0,
//     SelfInitiative_emp: 0,
//     responsbilityaccountability_emp: 0,
//     independentWorking_emp: 0,
//     decisonMakingCapability_emp: 0,
//     totalperformance_emp: 0,

//     punctuality_emp: 0,
//     teamwork_emp: 0,
//     loyalitytowardsWork_emp: 0,
//     dedicationtowardsWork_emp: 0,
//     obeideintorLeadership_emp: 0,
//     totaldecipline_emp: 0,

//     total_emp: 0,

//     emp_update_datetime: ""
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "emp_code",
//     ];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
//       }
//     });

//     console.log("newErrors")
//     console.log(newErrors)
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value, min, max } = e.target;
//     const minValue = parseFloat(min);
//     const maxValue = parseFloat(max);
//     const numericValue = parseFloat(value);

//     if (!isNaN(numericValue)) {
//       // Allow numbers up to one decimal place
//       const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

//       if (!decimalPrecisionCheck.test(numericValue.toString())) {
//         setErrors({
//           ...errors,
//           [name]: "Only up to one decimal place allowed.",
//         });

//         setInputState({
//           ...inputState,
//           [name]: "error",
//         });
//       } else if (numericValue < minValue) {
//         setErrors({
//           ...errors,
//           [name]: `Min limit ${minValue}`,
//         });

//         setInputState({
//           ...inputState,
//           [name]: "error",
//         });
//       } else if (numericValue > maxValue) {
//         setErrors({
//           ...errors,
//           [name]: `Max limit ${maxValue}`,
//         });

//         setInputState({
//           ...inputState,
//           [name]: "error",
//         });
//       } else {
//         setErrors({
//           ...errors,
//           [name]: "",
//         });

//         setFormData({
//           ...formData,
//           [name]: numericValue,
//         });

//         setInputState({
//           ...inputState,
//           [name]: "success",
//         });
//       }
//     } else {
//       setErrors({});
//       setFormData({
//         ...formData,
//         [name]: 0,
//       });

//       setInputState({
//         ...inputState,
//         [name]: "",
//       });
//     }
//   };
//   const [loading, setLoading] = useState(false);

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     const updatedFormData = {
//       ...formData,

//       totalperformance_emp: (
//         (parseFloat(formData.accuracy_emp) || 0) +
//         (parseFloat(formData.speedlyWork_emp) || 0) +
//         (parseFloat(formData.SelfInitiative_emp) || 0) +
//         (parseFloat(formData.responsbilityaccountability_emp) || 0) +
//         (parseFloat(formData.independentWorking_emp) || 0) +
//         (parseFloat(formData.decisonMakingCapability_emp) || 0)
//       ).toFixed(1),

//       totaldecipline_emp: (
//         (parseFloat(formData.punctuality_emp) || 0) +
//         (parseFloat(formData.teamwork_emp) || 0) +
//         (parseFloat(formData.loyalitytowardsWork_emp) || 0) +
//         (parseFloat(formData.dedicationtowardsWork_emp) || 0) +
//         (parseFloat(formData.obeideintorLeadership_emp) || 0)
//       ).toFixed(1),

//       total_emp: (
//         (parseFloat(formData.accuracy_emp) || 0) +
//         (parseFloat(formData.speedlyWork_emp) || 0) +
//         (parseFloat(formData.SelfInitiative_emp) || 0) +
//         (parseFloat(formData.responsbilityaccountability_emp) || 0) +
//         (parseFloat(formData.independentWorking_emp) || 0) +
//         (parseFloat(formData.decisonMakingCapability_emp) || 0) +
//         (parseFloat(formData.punctuality_emp) || 0) +
//         (parseFloat(formData.teamwork_emp) || 0) +
//         (parseFloat(formData.loyalitytowardsWork_emp) || 0) +
//         (parseFloat(formData.dedicationtowardsWork_emp) || 0) +
//         (parseFloat(formData.obeideintorLeadership_emp) || 0)
//       ).toFixed(1),

//       emp_update_datetime: new Date().toISOString(),
//     };


//     if (validateForm()) {

//       console.log("updatedFormData")
//       console.log(updatedFormData)

//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please wait...");
//       let ress = await axios.put(`${BASE_URL}/wfm/QuickAppresalUpdate/${i.id}/`, updatedFormData);
//       if (ress.status === 200) {
//         window.location.reload();
//         handleClose();
//       } else {
//         alert(ress);
//       }
//       try {

//         // alert("appraisalspost");
//       } catch (err) {
//         handleAllError(err);
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   return (
//     <>
//       <button title="Update Self Appraisal Ratings" className="update-svg" onClick={handleShow}>
//         <UpdatePencil />{" "}Self Appraisal
//         {/* <AddwithWhiteCircle />{" "}Self Appraisal */}
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title>Employee Self Appraisal "{formattedDateLong(i.rating_period_start)} to {formattedDateLong(i.rating_period_end)}" Ratings Update</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

//           <form className="register-form">
//             <div className="flex-row justify-center">
//               <table className="nested-table-lightblue width-40vw">
//                 <thead>
//                   <tr>
//                     <th className="align-center">Rating Analysis</th>
//                     <th colSpan={2} className="align-center">Total Rating Marks</th>
//                     <th className="align-center width-5vw">Rating</th>
//                   </tr>
//                   <tr>
//                     <th className="align-center"></th>
//                     <th className="align-center">+VE Marks</th>
//                     <th className="align-center">-VE Marks</th>
//                     <th className="align-center"></th>
//                   </tr>
//                   <tr>
//                     <th colSpan={4} className="align-leftt">PERFORMANCE</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <React.Fragment>
//                     {[
//                       { label: "Accuracy", name: "accuracy_emp", min: -20, max: 20 },
//                       { label: "Speedly Work", name: "speedlyWork_emp", min: -10, max: 10 },
//                       { label: "Self Initiative", name: "SelfInitiative_emp", min: -15, max: 15 },
//                       { label: "Responsibility & Accountability", name: "responsbilityaccountability_emp", min: -10, max: 10 },
//                       { label: "Independent Working", name: "independentWorking_emp", min: -5, max: 5 },
//                       { label: "Decision Making Capability", name: "decisonMakingCapability_emp", min: -10, max: 10 },
//                     ].map(({ label, name, min, max }) => (
//                       <tr key={name}>
//                         <td className="text-center">{label}</td>
//                         <td className="text-center">{max}</td>
//                         <td className="text-center">{min}</td>
//                         <td>
//                           <input
//                             type="number"
//                             step={0}
//                             min={min}
//                             max={max}
//                             name={name}
//                             placeholder="Enter Rating"
//                             value={formData[name]}
//                             onChange={handleInputChange}
//                             onWheel={(e) => e.target.blur()}
//                             className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
//                           />
//                           <div className="align-center">
//                             {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <th className="align-right"></th>
//                       <th className="align-center">70</th>
//                       <th className="align-center">-70</th>
//                       <th className="align-right">
//                         {(
//                           (parseFloat(formData.accuracy_emp) || 0) +
//                           (parseFloat(formData.speedlyWork_emp) || 0) +
//                           (parseFloat(formData.SelfInitiative_emp) || 0) +
//                           (parseFloat(formData.responsbilityaccountability_emp) || 0) +
//                           (parseFloat(formData.independentWorking_emp) || 0) +
//                           (parseFloat(formData.decisonMakingCapability_emp) || 0)
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                     <tr>
//                       <th colSpan={4} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
//                     </tr>
//                     {[
//                       { label: "Punctuality", name: "punctuality_emp", min: -5, max: 5 },
//                       { label: "Teamwork", name: "teamwork_emp", min: -5, max: 5 },
//                       { label: "Loyalty Towards Work", name: "loyalitytowardsWork_emp", min: -5, max: 5 },
//                       { label: "Dedication Towards Work", name: "dedicationtowardsWork_emp", min: -5, max: 5 },
//                       { label: "Obedient & Leadership", name: "obeideintorLeadership_emp", min: -10, max: 10 }
//                     ].map(({ label, name, min, max }) => (
//                       <tr key={name}>
//                         <td className="text-center">{label}</td>
//                         <td className="text-center">{max}</td>
//                         <td className="text-center">{min}</td>
//                         <td>
//                           <input
//                             type="number"
//                             step={0}
//                             min={min}
//                             max={max}
//                             name={name}
//                             placeholder="Enter Rating"
//                             value={formData[name]}
//                             onChange={handleInputChange}
//                             onWheel={(e) => e.target.blur()}
//                             className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
//                           />
//                           <div className="align-center">
//                             {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <th className="align-right"></th>
//                       <th className="align-center">30</th>
//                       <th className="align-center">-30</th>
//                       <th className="align-right">
//                         {(
//                           (parseFloat(formData.punctuality_emp) || 0) +
//                           (parseFloat(formData.teamwork_emp) || 0) +
//                           (parseFloat(formData.loyalitytowardsWork_emp) || 0) +
//                           (parseFloat(formData.dedicationtowardsWork_emp) || 0) +
//                           (parseFloat(formData.obeideintorLeadership_emp) || 0)
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                     <tr>
//                       <th className="align-right">Total Rating Marks</th>
//                       <th className="align-center">100</th>
//                       <th className="align-center">-100</th>
//                       <th className="align-right">
//                         {(
//                           (parseFloat(formData.accuracy_emp) || 0) +
//                           (parseFloat(formData.speedlyWork_emp) || 0) +
//                           (parseFloat(formData.SelfInitiative_emp) || 0) +
//                           (parseFloat(formData.responsbilityaccountability_emp) || 0) +
//                           (parseFloat(formData.independentWorking_emp) || 0) +
//                           (parseFloat(formData.decisonMakingCapability_emp) || 0) +
//                           (parseFloat(formData.punctuality_emp) || 0) +
//                           (parseFloat(formData.teamwork_emp) || 0) +
//                           (parseFloat(formData.loyalitytowardsWork_emp) || 0) +
//                           (parseFloat(formData.dedicationtowardsWork_emp) || 0) +
//                           (parseFloat(formData.obeideintorLeadership_emp) || 0)
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                   </React.Fragment>
//                 </tbody>
//               </table>
//             </div>

//             <div className="button-models">
//               <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                 Cancel
//               </button>

//               <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
//                 {loading ? 'Updating...' : 'Update'}
//               </button>
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };






// const getExistingRatingsArray = (results) => results?.ratings || results?.results || results?.appraisal_ratings || [];
const getExistingRatingsArray = (results) => {
  if (Array.isArray(results)) return results;
  return results?.ratings || results?.results || results?.appraisal_ratings || [];
};

const getSubDetailId = (record) =>
  typeof record?.appraisal_sub_details === "object"
    ? record.appraisal_sub_details?.id
    : record?.appraisal_sub_details;

const EditAppraisalDetailsByEmployee = ({ i, results, onSuccess }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  // Dynamic Data States — same as Upload
  const [appraisalTypes, setAppraisalTypes] = useState([]);
  const [appraisalSubDetails, setAppraisalSubDetails] = useState({});
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  // subDetailId -> existing rating record id (needed for the PUT payload)
  const [recordIdMap, setRecordIdMap] = useState({});

  const empCode = sessionStorage.getItem("emp_code");
  const subCompany = sessionStorage.getItem("company_id");

  useEffect(() => {
    if (show && subCompany) {
      fetchAllAppraisalData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, subCompany]);

  const fetchAllAppraisalData = async () => {
    setFetching(true);
    try {
      // 1. Fetch Appraisal Types — same endpoint as Upload
      const typesRes = await axios.get(`${BASE_URL}/wfm/appraisal-types-by-subcompany/${subCompany}/`);
      const types = typesRes.data || [];
      setAppraisalTypes(types);

      // 2. Fetch Sub Details for each Type — same as Upload
      const subDetailsMap = {};
      const initialFormState = {};

      for (const type of types) {
        const subRes = await axios.get(`${BASE_URL}/wfm/appraisal-sub-details-by-appraisal-type/${type.id}/`);
        subDetailsMap[type.id] = subRes.data || [];

        (subRes.data || []).forEach((detail) => {
          initialFormState[detail.id] = ""; // will be overwritten with existing marks below
        });
      }

      setAppraisalSubDetails(subDetailsMap);

      // 3. Prefill with existing ratings from `results`
      const existingRatings = getExistingRatingsArray(results);
      const idMap = {};

      existingRatings.forEach((record) => {
        const subDetailId = getSubDetailId(record);
        if (subDetailId === undefined || subDetailId === null) return;

        if (Object.prototype.hasOwnProperty.call(initialFormState, subDetailId)) {
          initialFormState[subDetailId] =
            record.employee_marks !== undefined && record.employee_marks !== null
              ? Number(record.employee_marks)
              : "";
        }
        idMap[subDetailId] = record.id;
      });

      setRecordIdMap(idMap);
      setFormData(initialFormState);
    } catch (error) {
      console.error("Error fetching appraisal data:", error);
      toast.error("Failed to load appraisal form data.");
    } finally {
      setFetching(false);
    }
  };

  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
    setSubmitConfirmation(false);
    setFormData({});
    setErrors({});
    setRecordIdMap({});
  };

  // Same validation semantics as Upload — only editable (Performance) section marks can change
  const handleInputChange = (e, detailId, maxVal, type) => {
    if (!isEmployeeEditable(type)) {
      return;
    }
    const value = e.target.value;
    const numericValue = parseFloat(value);

    if (value === "") {
      setFormData({ ...formData, [detailId]: "" });
      setErrors({ ...errors, [detailId]: "Required" });
      return;
    }

    if (!isNaN(numericValue)) {
      if (numericValue < 0) {
        setErrors({ ...errors, [detailId]: "Cannot be negative" });
      } else if (numericValue > maxVal) {
        setErrors({ ...errors, [detailId]: `Max limit ${maxVal}` });
      } else {
        const newErrors = { ...errors };
        delete newErrors[detailId];
        setErrors(newErrors);
      }
      setFormData({ ...formData, [detailId]: numericValue });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    appraisalTypes.forEach((type) => {
      // Skip non-editable sections
      if (!isEmployeeEditable(type)) return;

      (appraisalSubDetails[type.id] || []).forEach((detail) => {
        const value = formData[detail.id];

        if (value === "" || value === undefined || value === null) {
          newErrors[detail.id] = "Required";
        }
      });
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (Object.keys(errors).length > 0 || !validateForm()) {
      toast.error("Please fix errors before submitting.");
      return;
    }

    setLoading(true);
    const loadingToastId = toast.loading("Updating Ratings...");

    // Bulk UPDATE payload — needs the existing record `id` for each sub-detail so the
    // backend knows which row to update (unlike Upload's create payload).
    // Only editable (Performance) sections are sent, same restriction as Upload.
    const payload = appraisalTypes.flatMap((type) => {
      if (!isEmployeeEditable(type)) return [];

      return (appraisalSubDetails[type.id] || [])
        .filter((detail) => recordIdMap[detail.id] !== undefined)
        .map((detail) => ({
          id: recordIdMap[detail.id],
          employee: empCode,
          appraisal_sub_details: detail.id,
          employee_marks: String(formData[detail.id] || 0),
          updated_by: empCode,
        }));
    });

    try {
      const response = await axios.put(`${BASE_URL}/wfm/employee-appraisal-rating-bulk-with-lock-update/`, payload);

      if (response.status === 200 || response.status === 201) {
        toast.success("Appraisal updated successfully!");
        onSuccess?.(); // parent (Userdetailsmain) ka appData refresh
        handleClose();
      } else {
        toast.error("Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to update ratings.");
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  // Helper: max marks for a sub-detail — same fallback chain as Upload
  const getMaxMarks = (detail) =>
    parseInt(detail.appraisal_rating_details?.out_of || detail.data?.weightage || 10);

  const getRatingOptions = (maxVal) => {
    const options = [];
    for (let v = 0; v <= maxVal; v += 0.5) {
      options.push(Number(v.toFixed(1)));
    }
    return options;
  };

  const getSectionTotals = (type) => {
    const sectionDetails = appraisalSubDetails[type.id] || [];
    const max = sectionDetails.reduce((sum, d) => sum + getMaxMarks(d), 0);
    const scored = sectionDetails.reduce((sum, d) => {
      const v = formData[d.id];
      return sum + (v === "" || v === undefined ? 0 : Number(v));
    }, 0);
    return { scored, max };
  };

  const getOverallTotals = () => {
    return appraisalTypes.reduce(
      (acc, type) => {
        const { scored, max } = getSectionTotals(type);
        return { scored: acc.scored + scored, max: acc.max + max };
      },
      { scored: 0, max: 0 }
    );
  };

  const getLegendSchemas = () => {
    const seen = {};
    for (const key in appraisalSubDetails) {
      for (const detail of appraisalSubDetails[key]) {
        const schema = detail.appraisal_rating_details?.data;
        const outOf = detail.appraisal_rating_details?.out_of;
        if (schema && outOf && !seen[outOf]) {
          seen[outOf] = schema;
        }
      }
    }
    return seen; // { "10": {...}, "5": {...} }
  };

  const renderRatingLegend = () => {
    const schemas = getLegendSchemas();
    const outOfValues = Object.keys(schemas);
    if (outOfValues.length === 0) return null;

    return (
      <div className="sar-legend-box">
        <div className="sar-legend-title">Rating Scale</div>
        {outOfValues.map((outOf) => {
          const schema = schemas[outOf];
          const validKeys = Object.keys(schema).filter((k) => k !== "totalRating");
          return (
            <div className="sar-legend-row" key={outOf}>
              <span className="sar-legend-scale-label">Out of {outOf}</span>
              {validKeys.map((key) => {
                const range = schema[key];
                const tag = getRatingLabel(range.max, Number(outOf)) || { color: "#6c757d" };
                return (
                  <span key={key} className="sar-legend-pill" style={{
                    background: tag.bg,
                    color: tag.color,
                    border: `1px solid ${tag.border}`,
                  }}>
                    {range.min}-{range.max} {key}
                  </span>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  const overall = getOverallTotals();
  const overallPct = overall.max ? Math.round((overall.scored / overall.max) * 100) : 0;
  const overallTag = getRatingLabel(overall.scored, overall.max);
  const totalRatedCount = Object.keys(formData).filter(
    (key) => formData[key] !== "" && formData[key] !== undefined
  ).length;
  const totalFieldsCount = Object.keys(formData).length;

  const getSectionIcon = (sectionName, size = 26) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return <PerformanceIcon size={size} color="#2563EB" />;

      case "discipline & behaviour":
      case "discipline and behaviour":
        return <DisciplineIcon size={size} color="#16A34A" />;

      case "team performance":
        return <TeamPerformanceIcon size={size} color="#7C3AED" />;

      default:
        return <PerformanceIcon size={size} color="#2563EB" />;
    }
  };

  const getSectionColor = (sectionName) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return "#2563EB";

      case "discipline & behaviour":
      case "discipline and behaviour":
        return "#16A34A";

      case "team performance":
        return "#7C3AED";

      default:
        return "#2563EB";
    }
  };

  const isEmployeeEditable = (type) => {
    const section = type?.name?.trim()?.toLowerCase();

    return section === "performance";
  };

  return (
    <>
      <button title="Update Self Evaluation Ratings" className="flex font-size-text items-center  gap-3 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition" onClick={handleShow}>
        <UpdatePencil color="#2576BC" />{" "}Self Evaluation
        {/* <AddwithWhiteCircle />{" "}Self Appraisal */}
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model modal-xl" backdrop="static">
        <Modal.Header closeButton className="sar-modal-header">
          <div>
            <Modal.Title className="sar-modal-title">Edit self evaluation ratings</Modal.Title>
            <div className="sar-modal-subtitle">
              Update your ratings below &middot;{" "}
              {formattedDateLong(i?.rating_period?.rating_period_start)} to {formattedDateLong(i?.rating_period?.rating_period_end)}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="bg-light">
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          {fetching ? (
            <div className="text-center p-5">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-2 text-muted">Loading appraisal criteria...</p>
            </div>
          ) : (
            <form className="register-form p-2">

              {/* ---- Summary cards ---- */}
              <div className="sar-summary-row">
                {appraisalTypes.map((type) => {
                  const { scored, max } = getSectionTotals(type);
                  const pct = max ? Math.round((scored / max) * 100) : 0;
                  return (
                    <div className="sar-summary-card sar-card-neutral" key={type.id}>
                      <div
                        className="sar-card-icon"
                        style={{
                          background: `${getSectionColor(type.name)}15`,
                        }}
                      >
                        {getSectionIcon(type.name)}
                      </div>
                      <div className="sar-card-label">{type.name}</div>
                      <div className="sar-card-score">
                        <span
                          className="sar-card-score-value"
                          style={{ color: getSectionColor(type.name) }}
                        >
                          {scored.toFixed(1)}
                        </span>

                        <small className="sar-card-score-max">
                          / {max}
                        </small>
                      </div>
                      <div className="sar-card-progress-track">
                        <div
                          className="sar-card-progress-fill"
                          style={{
                            width: `${pct}%`,
                            background: getSectionColor(type.name),
                          }}
                        />
                      </div>
                      <div className="sar-card-progress-pct">{pct}%</div>
                    </div>
                  );
                })}

                <div className="sar-summary-card sar-card-overall">
                  <div className="sar-card-icon">
                    <OverallIcon />
                  </div>
                  <div className="sar-card-label">Overall</div>
                  <div className="sar-card-score">
                    {overall.scored.toFixed(1)} <small>/ {overall.max}</small>
                  </div>
                  <div className="sar-card-progress-track">
                    <div
                      className="sar-card-progress-fill"
                      style={{ width: `${overallPct}%`, background: "#fff" }}
                    />
                  </div>
                  {overallTag && (
                    <span className="sar-card-badge" style={{ background: overallTag.color }}>
                      {overallTag.label}
                    </span>
                  )}
                </div>
              </div>

              {/* ---- Ratings table ---- */}
              <div className="sar-table-wrap">
                <table className="table sar-table mb-0">
                  <thead>
                    <tr>
                      <th className="w-25">Parameter</th>
                      <th className="w-25">Description</th>
                      <th className="text-center">Max marks</th>
                      <th className="text-center">Your rating</th>
                      <th className="text-center">Score</th>
                    </tr>
                  </thead>

                  <tbody>
                    {appraisalTypes.map((type) => {
                      const sectionDetails = appraisalSubDetails[type.id] || [];
                      const { scored, max } = getSectionTotals(type);

                      return (
                        <React.Fragment key={type.id}>
                          {/* Section Header */}
                          <tr className="sar-section-row">
                            <td colSpan={5}>
                              <span className="sar-section-icon">
                                <SectionIcon />
                              </span>
                              {type.name?.toUpperCase()}
                              {!isEmployeeEditable(type) && (
                                <span className="sar-lock-badge">
                                  🔒 View only
                                </span>
                              )}
                              <span className="sar-section-total-badge">
                                Total {scored.toFixed(1)} / {max}
                              </span>
                            </td>
                          </tr>

                          {/* Section Sub Details */}
                          {sectionDetails.map((detail) => {
                            const maxMarks = getMaxMarks(detail);
                            const currentValue = formData[detail.id];
                            const tag = getRatingLabel(currentValue, maxMarks);
                            const isFilled = currentValue !== "" && currentValue !== undefined;

                            return (
                              <tr key={detail.id} className="sar-param-row">
                                <td>
                                  <span className="sar-param-name">{detail.name}
                                    {detail.data?.mandatory && (
                                      <span className="required">*</span>
                                    )}
                                  </span>
                                </td>

                                <td className="sar-param-desc">
                                  {detail.data?.description || "-"}
                                </td>

                                <td className="text-center">
                                  <span className="sar-max-badge">{maxMarks}</span>
                                </td>

                                <td className="text-center">
                                  <select
                                    value={currentValue === undefined ? "" : currentValue}
                                    onChange={(e) => handleInputChange(e, detail.id, maxMarks, type)}
                                    disabled={!isEmployeeEditable(type)}
                                    className={`sar-rating-select ${errors[detail.id] ? "sar-select-error" : isFilled ? "sar-select-filled" : ""
                                      }`}
                                  >
                                    <option value="">--</option>
                                    {getRatingOptions(maxMarks).map((opt) => (
                                      <option key={opt} value={opt}>
                                        {opt}
                                      </option>
                                    ))}
                                  </select>
                                  {isEmployeeEditable(type) && tag && (
                                    <span
                                      className="sar-rating-tag"
                                      style={{
                                        color: tag.color,
                                      }}
                                    >
                                      {tag.label}
                                    </span>
                                  )}
                                  {errors[detail.id] && (
                                    <div className="sar-error-text">{errors[detail.id]}</div>
                                  )}
                                </td>

                                <td className="sar-score-cell">
                                  {isFilled ? Number(currentValue).toFixed(1) : "0.0"}
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}

                    {/* Grand total row */}
                    <tr className="sar-total-row">
                      <td colSpan={2}>TOTAL RATING MARKS</td>
                      <td className="text-center">{overall.max}</td>
                      <td className="text-center"></td>
                      <td className="text-center">
                        {overall.scored.toFixed(1)} / {overall.max}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* ---- Rating scale legend (driven by API data) ---- */}
              {renderRatingLegend()}

              {/* ---- Confirmation + actions ---- */}
              <div className="sar-confirm-box">
                <div className="form-check form-switch d-flex align-items-start">
                  <input
                    className="form-check-input cursor-pointer mt-1"
                    type="checkbox"
                    id="confirmEditSwitch"
                    checked={submitConfirmation}
                    onChange={() => setSubmitConfirmation(!submitConfirmation)}
                    style={{ width: "2.6em", height: "1.3em" }}
                  />
                  <label className="form-check-label ms-3" htmlFor="confirmEditSwitch">
                    <div className="sar-confirm-text">
                      I confirm that the updated self evaluation ratings are accurate and complete.
                    </div>
                    <div className="sar-confirm-subtext">
                      ({totalRatedCount}/{totalFieldsCount} rated)
                    </div>
                  </label>
                </div>
              </div>

              <div className="sar-footer-actions">
                <button type="button" className="sar-btn-cancel" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="sar-btn-submit"
                  onClick={handleFormSubmit}
                  disabled={!submitConfirmation || loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Updating...
                    </>
                  ) : (
                    "Update rating"
                  )}
                </button>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

// const ViewAppraisalDetailsByEmployee = ({ i, display_flag }) => {
//   const [show, setShow] = useState(false);

//   const handleShow = () => {
//     setFormData(i);
//     setShow(true);
//   }

//   const handleClose = () => {
//     setShow(false);
//   }

//   const customCondition = sessionStorage.getItem("company_id") === "beb197dd-9ad1-4136-a1ad-bb469e7127a2"

//   const [formData, setFormData] = useState({});

//   return (
//     <>
//       {display_flag
//         ?
//         <button title="View Appraisal Raitings" className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition item-center" onClick={handleShow}>
//           <Eye />
//         </button>
//         :
//         <ButtonVariants
//           buttonDisplay={'BlueEye-Name'}
//           buttonDisplayName={'View Rating'}
//           buttonDisplayNameColor={'black'}
//           handleShow={handleShow}
//         />}

//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title>Appraisal Ratings for {formattedDateLong(i.rating_period_start)}-{formattedDateLong(i.rating_period_end)} - "{i.emp_code}-{i.name}"</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

//           <form className="register-form">
//             <div className="flex-row justify-center">
//               <table className="nested-table-lightblue width-40vw">
//                 <thead>
//                   <tr>
//                     <th className="align-center">Rating Analysis</th>
//                     <th colSpan={2} className="align-center">Total Rating Marks</th>
//                     <th className="align-center">Emp Rating</th>
//                     {/* {customCondition ? null :
//                       <th className="align-center">Reporting Head Rating</th>}
//                     <th className="align-center">HOD Rating</th> */}
//                     <th className="align-center">Final Rating</th>
//                   </tr>
//                   <tr>
//                     <th className="align-center"></th>
//                     <th className="align-center">+VE Marks</th>
//                     <th className="align-center">-VE Marks</th>
//                     <th className="align-center"></th>
//                     {/* {customCondition ? null :
//                       <th className="align-center"></th>}
//                     <th className="align-center"></th> */}
//                     <th className="align-center"></th>
//                   </tr>
//                   <tr>
//                     {/* <th colSpan={customCondition ? 6 : 7} className="align-leftt">PERFORMANCE</th> */}
//                     <th colSpan={customCondition ? 4 : 5} className="align-leftt">PERFORMANCE</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <React.Fragment>
//                     {[
//                       { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", rh: "accuracy_rh", hod: "accuracy_hod", min: -20, max: 20 },
//                       { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", rh: "speedlyWork_rh", hod: "speedlyWork_hod", min: -10, max: 10 },
//                       { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", rh: "SelfInitiative_rh", hod: "SelfInitiative_hod", min: -15, max: 15 },
//                       { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", rh: "responsbilityaccountability_rh", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
//                       { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", rh: "independentWorking_rh", hod: "independentWorking_hod", min: -5, max: 5 },
//                       { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", rh: "decisonMakingCapability_rh", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
//                     ].map(({ label, name, emp, rh, hod, min, max }) => (
//                       <tr key={name}>
//                         <td className="text-center">{label}</td>
//                         <td className="text-center">{max}</td>
//                         <td className="text-center">{min}</td>
//                         <td className="text-center">{formData[emp]}</td>
//                         {/* {customCondition ? null :
//                           <td className="text-center">{formData[rh]}</td>}
//                         <td className="text-center">{formData[hod]}</td> */}
//                         <td className="text-center">{formData[name]}</td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <th className="align-center"></th>
//                       <th className="align-center">70</th>
//                       <th className="align-center">-70</th>
//                       <th className="align-center">{formData.totalperformance_emp}</th>
//                       {/* {customCondition ? null :
//                         <th className="align-center">{formData.totalperformance_rh}</th>}
//                       <th className="align-center">{formData.totalperformance_hod}</th> */}
//                       <th className="align-center">
//                         {(
//                           (parseFloat(formData.accuracy_admin) || 0) +
//                           (parseFloat(formData.speedlyWork_admin) || 0) +
//                           (parseFloat(formData.SelfInitiative_admin) || 0) +
//                           (parseFloat(formData.responsbilityaccountability_admin) || 0) +
//                           (parseFloat(formData.independentWorking_admin) || 0) +
//                           (parseFloat(formData.decisonMakingCapability_admin) || 0)
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                     <tr>
//                       {/* <th colSpan={customCondition ? 6 : 7} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th> */}
//                       <th colSpan={customCondition ? 4 : 5} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
//                     </tr>
//                     {[
//                       { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", rh: "punctuality_rh", hod: "punctuality_hod", min: -5, max: 5 },
//                       { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", rh: "teamwork_rh", hod: "teamwork_hod", min: -5, max: 5 },
//                       { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", rh: "loyalitytowardsWork_rh", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
//                       { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", rh: "dedicationtowardsWork_rh", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
//                       { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", rh: "obeideintorLeadership_rh", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
//                     ].map(({ label, name, emp, rh, hod, min, max }) => (
//                       <tr key={name}>
//                         <td className="text-center">{label}</td>
//                         <td className="text-center">{max}</td>
//                         <td className="text-center">{min}</td>
//                         <td className="text-center">{formData[emp]}</td>
//                         {/* {customCondition ? null :
//                           <td className="text-center">{formData[rh]}</td>}
//                         <td className="text-center">{formData[hod]}</td> */}
//                         <td className="text-center">{formData[name]}</td>
//                       </tr>
//                     ))}
//                     <tr>
//                       <th className="align-center"></th>
//                       <th className="align-center">30</th>
//                       <th className="align-center">-30</th>
//                       <th className="align-center">{formData.totaldecipline_emp}</th>
//                       {/* {customCondition ? null :
//                         <th className="align-center">{formData.totaldecipline_rh}</th>}
//                       <th className="align-center">{formData.totaldecipline_hod}</th> */}
//                       <th className="align-center">
//                         {(
//                           (parseFloat(formData.punctuality_admin) || 0) +
//                           (parseFloat(formData.teamwork_admin) || 0) +
//                           (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
//                           (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
//                           (parseFloat(formData.obeideintorLeadership_admin) || 0)
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                     <tr>
//                       <th className="align-right">Total Rating Marks</th>
//                       <th className="align-center">100</th>
//                       <th className="align-center">-100</th>
//                       <th className="align-center">{formData.total_emp}</th>
//                       {/* {customCondition ? null :
//                         <th className="align-center">{formData.total_rh}</th>}
//                       <th className="align-center">{formData.total_hod}</th> */}
//                       <th className="align-center">
//                         {(
//                           (parseFloat(formData.accuracy_admin) || 0) +
//                           (parseFloat(formData.speedlyWork_admin) || 0) +
//                           (parseFloat(formData.SelfInitiative_admin) || 0) +
//                           (parseFloat(formData.responsbilityaccountability_admin) || 0) +
//                           (parseFloat(formData.independentWorking_admin) || 0) +
//                           (parseFloat(formData.decisonMakingCapability_admin) || 0) +
//                           (parseFloat(formData.punctuality_admin) || 0) +
//                           (parseFloat(formData.teamwork_admin) || 0) +
//                           (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
//                           (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
//                           (parseFloat(formData.obeideintorLeadership_admin) || 0)
//                         ).toFixed(1)}
//                       </th>
//                     </tr>
//                   </React.Fragment>
//                 </tbody>
//               </table>
//             </div>

//             <div className="button-models">
//               <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                 Close
//               </button>
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const ViewAppraisalDetailsByEmployee = ({ employeeCode, buttonLabel = "View Evaluation" }) => {
  const [show, setShow] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const empCode = employeeCode || sessionStorage.getItem("emp_code");

  useEffect(() => {
    if (show && empCode) {
      fetchAppraisalHistory();
    }
  }, [show, empCode]);

  const fetchAppraisalHistory = async () => {
    setFetching(true);
    setError(null);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employee-appraisal-rating-with-level-approvals/${empCode}/`
      );
      if (res.data?.status) {
        setData(res.data);
      } else {
        setError("No appraisal record found.");
      }
    } catch (err) {
      console.error("Error fetching appraisal history:", err);
      setError(err?.response?.data?.message || "Failed to load appraisal history.");
    } finally {
      setFetching(false);
    }
  };

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setData(null);
    setError(null);
  };

  // ---- Helpers -------------------------------------------------------

  const getFinalLevel = (levelWiseRatings = []) => {
    if (!levelWiseRatings.length) return null;
    return levelWiseRatings.reduce((max, lvl) =>
      lvl.level > (max?.level ?? -Infinity) ? lvl : max
      , null);
  };

  // rating_id -> marks_by_authority, scoped to the final level only
  const getFinalLevelMarksMap = (finalLevel) => {
    const map = {};
    (finalLevel?.ratings || []).forEach((r) => {
      map[r.rating_id] = r.marks_by_authority;
    });
    return map;
  };

  // const getMaxMarks = () => {
  //   const outOf = data?.appraisal?.rating_details?.out_of;
  //   return outOf ? Number(outOf) : 10;
  // };
  const getMaxMarks = (r) => {
    const outOf = r?.question?.appraisal_rating_details?.out_of;
    return outOf ? Number(outOf) : 10;
  };

  // Group ratings by question.type so the table renders section-wise,
  // same visual pattern as the upload/edit modal.
  const getGroupedRatings = () => {
    const groups = {};
    (data?.ratings || []).forEach((r) => {
      const key = r.question?.type || "general";
      if (!groups[key]) {
        groups[key] = { label: r.question?.type || "General", items: [] };
      }
      groups[key].items.push(r);
    });
    return groups;
  };

  const getSectionIcon = (sectionName, size = 26) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return <PerformanceIcon size={size} color="#2563EB" />;

      case "discipline & behaviour":
      case "discipline and behaviour":
        return <DisciplineIcon size={size} color="#16A34A" />;

      case "team performance":
        return <TeamPerformanceIcon size={size} color="#7C3AED" />;

      default:
        return <PerformanceIcon size={size} color="#2563EB" />;
    }
  };

  const getSectionColor = (sectionName) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return "#2563EB";

      case "discipline & behaviour":
      case "discipline and behaviour":
        return "#16A34A";

      case "team performance":
        return "#7C3AED";

      default:
        return "#2563EB";
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "sar-status-approved";
      case "rejected":
        return "sar-status-rejected";
      default:
        return "sar-status-pending";
    }
  };

  // ---- Legend (same schema-driven approach as upload modal) ----------

  // const renderRatingLegend = () => {
  //   const schema = data?.appraisal?.rating_details?.data;
  //   const outOf = data?.appraisal?.rating_details?.out_of;
  //   if (!schema || !outOf) return null;

  //   const validKeys = Object.keys(schema).filter((k) => k !== "totalRating");
  //   if (!validKeys.length) return null;

  //   return (
  //     <div className="sar-legend-box">
  //       <div className="sar-legend-title">Rating Scale</div>
  //       <div className="sar-legend-row">
  //         <span className="sar-legend-scale-label">Out of {outOf}</span>
  //         {validKeys.map((key) => {
  //           const range = schema[key];
  //           const tag = getRatingLabel(range.max, Number(outOf)) || { color: "#6c757d" };
  //           return (
  //             <span
  //               key={key}
  //               className="sar-legend-pill"
  //               style={{ background: tag.bg, color: tag.color, border: `1px solid ${tag.border}` }}
  //             >
  //               {range.min}-{range.max} {key}
  //             </span>
  //           );
  //         })}
  //       </div>
  //     </div>
  //   );
  // };

  // NEW — distinct scales collected per question, same pattern as AppraisalApproverRatingModal
  const renderRatingLegend = () => {
    const seen = {};
    (data?.ratings || []).forEach((r) => {
      const schema = r?.question?.appraisal_rating_details?.data;
      const outOf = getMaxMarks(r);
      if (schema && outOf && !seen[outOf]) {
        seen[outOf] = schema;
      }
    });

    const outOfValues = Object.keys(seen);
    if (!outOfValues.length) return null;

    return (
      <div className="sar-legend-box">
        <div className="sar-legend-title">Rating Scale</div>
        {outOfValues.map((outOf) => {
          const schema = seen[outOf];
          const validKeys = Object.keys(schema).filter((k) => k !== "totalRating");
          return (
            <div className="sar-legend-row" key={outOf}>
              <span className="sar-legend-scale-label">Out of {outOf}</span>
              {validKeys.map((key) => {
                const range = schema[key];
                const tag = getRatingLabel(range.max, Number(outOf)) || { color: "#6c757d" };
                return (
                  <span
                    key={key}
                    className="sar-legend-pill"
                    style={{ background: tag.bg, color: tag.color, border: `1px solid ${tag.border}` }}
                  >
                    {range.min}-{range.max} {key}
                  </span>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  // ---- Derived totals --------------------------------------------------

  // const finalLevel = getFinalLevel(data?.level_wise_ratings);
  // const finalLevelMarksMap = getFinalLevelMarksMap(finalLevel);
  // const maxPerParam = getMaxMarks();
  // const ratingsCount = data?.ratings?.length || 0;
  // const employeeMaxTotal = maxPerParam * ratingsCount;

  const finalLevel = getFinalLevel(data?.level_wise_ratings);
  const finalLevelMarksMap = getFinalLevelMarksMap(finalLevel);
  const employeeMaxTotal = (data?.ratings || []).reduce(
    (sum, r) => sum + getMaxMarks(r),
    0
  );

  const employeeTotal = (data?.ratings || []).reduce(
    (sum, r) => sum + (parseFloat(r.employee_marks) || 0),
    0
  );
  const finalTotal = (data?.ratings || []).reduce((sum, r) => {
    const v = finalLevelMarksMap[r.id];
    return sum + (parseFloat(v) || 0);
  }, 0);

  const employeePct = employeeMaxTotal ? Math.round((employeeTotal / employeeMaxTotal) * 100) : 0;
  const finalPct = employeeMaxTotal ? Math.round((finalTotal / employeeMaxTotal) * 100) : 0;

  const employeeTag = getRatingLabel(employeeTotal, employeeMaxTotal);
  const finalTag = getRatingLabel(finalTotal, employeeMaxTotal);

  const groupedRatings = getGroupedRatings();

  return (
    <>
      <button
        title={buttonLabel}
        className="flex items-center gap-2 p-2 font-size-text rounded-md hover:bg-gray-100 cursor-pointer transition"
        onClick={handleShow}
      >
        <Eye width={26} height={26} />
        {" "}{buttonLabel}
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model modal-xl" backdrop="static">
        <Modal.Header closeButton className="sar-modal-header">
          <div>
            <Modal.Title className="sar-modal-title">
              View Self Evaluation
              {data?.appraisal?.financial_year_start_date && (
                <>
                  {" "}- {formattedDateLong(data.appraisal.financial_year_start_date)} to{" "}
                  {formattedDateLong(data.appraisal.financial_year_end_date)}
                </>
              )}
            </Modal.Title>
            <div className="sar-modal-subtitle">
              Your self-evaluation and the final approved rating for this appraisal cycle.
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="bg-light">
          {fetching ? (
            <div className="text-center p-5">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-2 text-muted">Loading appraisal history...</p>
            </div>
          ) : error ? (
            <div className="text-center p-5 text-muted">{error}</div>
          ) : !data ? null : (
            <div className="register-form p-2">

              {/* ---- Employee info strip ---- */}
              <div className="sar-emp-info-strip d-flex justify-end align-items-center gap-3 mb-3">


                {finalLevel && (
                  <div className="d-flex gap-2">
                    <span style={{ fontWeight: '500', fontSize: '15px' }}>Final Status :</span>
                    <span request-status={finalLevel.status} style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "1px 14px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "600",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      border: "1px solid rgba(0,0,0,0.08)",
                      backgroundColor:
                        finalLevel.status === "approved"
                          ? "#43ff1e30"
                          : finalLevel.status === "rejected"
                            ? "#ff747c30"
                            : finalLevel.status === "pending"
                              ? "#f7ba1e30"
                              : "#f7ba1e30"
                    }} className={`request-status ms-auto  text-capitalize`}>
                      {finalLevel.status}
                    </span>
                  </div>
                )}
              </div>

              {/* ---- Summary cards: Self vs Final ---- */}
              <div className="sar-summary-row">
                <div className="sar-summary-card sar-card-neutral">
                  <div className="sar-card-icon" style={{ background: "#2563EB15" }}>
                    <PerformanceIcon size={26} color="#2563EB" />
                  </div>
                  <div className="sar-card-label">Your Rating</div>
                  <div className="sar-card-score">
                    <span className="sar-card-score-value" style={{ color: "#2563EB" }}>
                      {employeeTotal.toFixed(1)}
                    </span>
                    <small className="sar-card-score-max"> / {employeeMaxTotal}</small>
                  </div>
                  <div className="sar-card-progress-track">
                    <div
                      className="sar-card-progress-fill"
                      style={{ width: `${employeePct}%`, background: "#2563EB" }}
                    />
                  </div>
                  <div className="sar-card-progress-pct">{employeePct}%</div>
                  {employeeTag && (
                    <span className="sar-card-badge" style={{ background: employeeTag.color, color: employeeTag.textColor }}>
                      {employeeTag.label}
                    </span>
                  )}
                </div>

                <div className="sar-summary-card sar-card-overall">
                  <div className="sar-card-icon">
                    <OverallIcon />
                  </div>
                  <div className="sar-card-label">
                    Final Rating
                    {/* {finalLevel && (
                      <div className="sar-card-sublabel">
                        Level {finalLevel.level} &middot; {finalLevel.approver_name}
                      </div>
                    )} */}
                  </div>
                  <div className="sar-card-score">
                    {finalTotal.toFixed(1)} <small>/ {employeeMaxTotal}</small>
                  </div>
                  <div className="sar-card-progress-track">
                    <div
                      className="sar-card-progress-fill"
                      style={{ width: `${finalPct}%`, background: "#fff" }}
                    />
                  </div>
                  {finalTag && (
                    <span className="sar-card-badge" style={{ background: finalTag.color }}>
                      {finalTag.label}
                    </span>
                  )}
                </div>
              </div>

              {/* ---- Ratings table ---- */}
              <div className="sar-table-wrap">
                <table className="table sar-table mb-0">
                  <thead>
                    <tr>
                      <th className="w-25">Parameter</th>
                      <th className="w-25">Description</th>
                      <th className="text-center">Max marks</th>
                      <th className="text-center">Your Rating</th>
                      <th className="text-center">Final Rating</th>
                      <th className="w-25 text-center">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(groupedRatings).map(([key, group]) => {
                      const sectionEmpTotal = group.items.reduce(
                        (s, r) => s + (parseFloat(r.employee_marks) || 0), 0
                      );
                      const sectionFinalTotal = group.items.reduce(
                        (s, r) => s + (parseFloat(finalLevelMarksMap[r.id]) || 0), 0
                      );

                      const sectionMax = group.items.reduce((s, r) => s + getMaxMarks(r), 0);

                      return (
                        <React.Fragment key={key}>
                          <tr className="sar-section-row">
                            <td colSpan={6}>
                              <span className="sar-section-icon">
                                <SectionIcon />
                              </span>
                              {group.label?.toUpperCase()}
                              <span className="sar-section-total-badge">
                                You {sectionEmpTotal.toFixed(1)} / {sectionMax}
                                {" "}&middot;{" "}
                                Final {sectionFinalTotal.toFixed(1)} / {sectionMax}
                              </span>
                            </td>
                          </tr>

                          {group.items.map((r) => {
                            // const empMarks = parseFloat(r.employee_marks) || 0;
                            // const finalMarks = parseFloat(finalLevelMarksMap[r.id]) || 0;
                            // const empTag = getRatingLabel(empMarks, maxPerParam);
                            // const finalTagRow = getRatingLabel(finalMarks, maxPerParam);
                            const empMarks = parseFloat(r.employee_marks) || 0;
                            const finalMarks = parseFloat(finalLevelMarksMap[r.id]) || 0;
                            const rowMax = getMaxMarks(r);
                            const empTag = getRatingLabel(empMarks, rowMax);
                            const finalTagRow = getRatingLabel(finalMarks, rowMax);

                            return (
                              <tr key={r.id} className="sar-param-row">
                                <td>
                                  <span className="sar-param-name">{r.question?.name}</span>
                                </td>
                                <td className="sar-param-desc">
                                  {r.question?.data?.description || "-"}
                                </td>
                                <td className="text-center">
                                  <span className="sar-max-badge">{rowMax}</span>
                                </td>
                                <td className="text-center">
                                  <span className="sar-readonly-value">{empMarks.toFixed(1)}</span>
                                  {empTag && (
                                    <div className="sar-rating-tag" style={{ color: empTag.color }}>
                                      {empTag.label}
                                    </div>
                                  )}
                                </td>
                                <td className="text-center">
                                  <span className="sar-readonly-value" style={{ fontWeight: 600 }}>
                                    {finalMarks.toFixed(1)}
                                  </span>

                                </td>
                                <td className="sar-param-desc">
                                  {finalTagRow ? (
                                    <span
                                      className="sar-rating-tag"
                                      style={{
                                        color: finalTagRow.color,
                                        fontWeight: 600,
                                      }}
                                    >
                                      {finalTagRow.label}
                                    </span>
                                  ) : (
                                    "-"
                                  )}</td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}

                    <tr className="sar-total-row">
                      <td>TOTAL RATING MARKS</td>
                      <td></td>
                      <td className="text-center">{employeeMaxTotal}</td>
                      <td className="text-center">{employeeTotal.toFixed(1)}</td>
                      <td className="text-center">{finalTotal.toFixed(1)}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* ---- Legend ---- */}
              {renderRatingLegend()}

              {/* ---- Final approver remarks ---- */}
              {finalLevel?.remarks && (
                <div className="sar-confirm-box">
                  <div className="sar-confirm-text">
                    <strong>{finalLevel.approver_name} ({`Level ${finalLevel.level}`}) remarks:</strong>
                  </div>
                  <div className="sar-confirm-subtext">{finalLevel.remarks}</div>
                </div>
              )}

              <div className="sar-footer-actions">
                <button type="button" className="sar-btn-cancel" onClick={handleClose}>
                  Close
                </button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};



const AppraisalApproverRatingModal = ({
  show,
  onHide,
  employeeCode,
  level, // Fallback level from parent
  myEmpCode,
  onSuccess,
  isReadOnly // Passed from parent to indicate if next level already approved
}) => {
  const [fetching, setFetching] = useState(false);
  const [saving, setSaving] = useState(false);

  // Data States
  const [data, setData] = useState(null);
  const [masterTypes, setMasterTypes] = useState([]);
  const [unifiedQuestions, setUnifiedQuestions] = useState([]);

  // Form States
  const [marks, setMarks] = useState({});
  const [status, setStatus] = useState("approved");
  const [remarks, setRemarks] = useState("");
  const [actualLevel, setActualLevel] = useState(level);

  // NEW: final-submission lock confirmation (last hierarchy level only, e.g. Admin)
  const [finalConfirm, setFinalConfirm] = useState(false);

  // Helper: Extract marks for a specific past level for the table display
  const getMarksForLevel = (ratingId, searchLevel, ratingsArray) => {
    if (!ratingId) return "-"; // If it was never rated, no previous level has it
    const levelData = ratingsArray?.find(l => Number(l.level) === Number(searchLevel));
    if (!levelData) return "-";
    const ratingObj = levelData.ratings?.find(r => r.rating_id === ratingId);
    return ratingObj?.marks_by_authority ?? "-";
  };

  // NEW: section icon/color helpers (same pattern as UploadAppraisalDetailsByEmployee)
  const getSectionIcon = (sectionName, size = 26) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return <PerformanceIcon size={size} color="#2563EB" />;
      case "discipline & behaviour":
      case "discipline and behaviour":
        return <DisciplineIcon size={size} color="#16A34A" />;
      case "team performance":
        return <TeamPerformanceIcon size={size} color="#7C3AED" />;
      default:
        return <PerformanceIcon size={size} color="#2563EB" />;
    }
  };

  const getSectionColor = (sectionName) => {
    switch (sectionName?.trim().toLowerCase()) {
      case "performance":
        return "#2563EB";
      case "discipline & behaviour":
      case "discipline and behaviour":
        return "#16A34A";
      case "team performance":
        return "#7C3AED";
      default:
        return "#2563EB";
    }
  };

  // NEW: role-based section access — ReportingHead can only rate Performance & Discipline,
  // HOD and Admin can rate all sections
  const isSectionEnabledForRole = (sectionLabel, roleName) => {
    const role = (roleName || "").trim().toLowerCase();
    const section = (sectionLabel || "").trim().toLowerCase();

    if (role === "reportinghead") {
      return (
        section === "performance" ||
        section === "discipline & behaviour" ||
        section === "discipline and behaviour"
      );
    }

    // HOD, Admin, and any other role → all sections enabled
    return true;
  };

  useEffect(() => {
    if (show && employeeCode) fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, employeeCode]);

  const fetchHistory = async () => {
    setFetching(true);
    try {
      const companyId = sessionStorage.getItem("company_id");

      const [empRes, masterRes] = await Promise.all([
        axios.get(`${BASE_URL}/wfm/employee-appraisal-rating-with-level-approvals/${employeeCode}/`),
        axios.get(`${BASE_URL}/wfm/appraisal-types-with-sub-details-by-subcompany/${companyId}/`)
      ]);

      const resData = empRes.data;
      const masterData = masterRes.data;

      setData(resData);
      setMasterTypes(masterData);

      // 1. FIND ACTUAL LEVEL
      const hierarchyMatches = resData.appraisal?.hierarchy?.filter(
        (h) => String(h.approver).trim() === String(myEmpCode).trim()
      ) || [];
      const derivedLevel = hierarchyMatches.length > 0
        ? Math.max(...hierarchyMatches.map(m => Number(m.level)))
        : Number(level);
      setActualLevel(derivedLevel);

      // 2. BUILD UNIFIED QUESTIONS (now also carries max + rating schema for label/legend)
      const masterList = masterData[0]?.appraisal_types || [];
      const empRatings = resData.ratings || [];

      const unified = masterList.map(type => ({
        label: type.name,
        items: type.appraisal_sub_details.map(q => {
          const empRating = empRatings.find(er => er.question?.id === q.id);
          return {
            questionId: q.id,
            ratingId: empRating?.id || null,
            name: q.name,
            description: q.data.description,
            max: q.appraisal_rating_details?.out_of || 10,
            ratingSchema: q.appraisal_rating_details?.data || null, // NEW: for label/legend
            employee_marks: empRating?.employee_marks || null
          };
        })
      }));

      setUnifiedQuestions(unified);

      // 3. PREFILL & POPULATE MARKS
      const myEntry = resData.level_wise_ratings?.find((r) => Number(r.level) === Number(derivedLevel));
      const initialMarks = {};

      unified.forEach(group => {
        group.items.forEach(q => {
          if (myEntry && myEntry.ratings && q.ratingId) {
            const myRating = myEntry.ratings.find(r => r.rating_id === q.ratingId);
            if (myRating && myRating.marks_by_authority !== null && myRating.marks_by_authority !== undefined) {
              initialMarks[q.questionId] = myRating.marks_by_authority;
            }
          }

          if (initialMarks[q.questionId] === undefined) {
            if (derivedLevel > 1) {
              const prevLevelData = resData.level_wise_ratings?.find(l => Number(l.level) === derivedLevel - 1);
              const prevRating = prevLevelData?.ratings?.find(r => r.rating_id === q.ratingId);
              if (prevRating && prevRating.marks_by_authority) {
                initialMarks[q.questionId] = prevRating.marks_by_authority;
              }
            } else {
              if (q.employee_marks) {
                initialMarks[q.questionId] = q.employee_marks;
              }
            }
          }
        });
      });

      setMarks(initialMarks);
      if (myEntry) {
        setStatus(myEntry.status === "pending" ? "approved" : myEntry.status);
        setRemarks(myEntry.remarks || "");
      } else {
        setStatus("approved");
        setRemarks("");
      }

      // NEW: never load with the lock-confirmation pre-checked
      setFinalConfirm(false);

    } catch (err) {
      console.error(err);
      toast.error("Failed to load appraisal details.");
    } finally {
      setFetching(false);
    }
  };

  const handleClose = () => {
    setData(null);
    setMarks({});
    setRemarks("");
    setFinalConfirm(false);
    onHide();
  };

  if (!data || fetching) {
    return (
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model modal-xl" backdrop="static">
        <Modal.Body className="bg-light text-center p-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2 text-muted">Loading appraisal details...</p>
        </Modal.Body>
      </Modal>
    );
  }

  const levelWiseRatings = data.level_wise_ratings || [];
  const myEntry = levelWiseRatings.find((r) => Number(r.level) === Number(actualLevel));

  const hasNextLevelApproved = levelWiseRatings.some(
    (l) => Number(l.level) > Number(actualLevel) && l.status === "approved"
  );

  // NEW: is this approver the last level in the hierarchy (e.g. Admin)?
  const hierarchyLevels = (data.appraisal?.hierarchy || []).map(h => Number(h.level));
  const maxHierarchyLevel = hierarchyLevels.length ? Math.max(...hierarchyLevels) : Number(actualLevel);
  const isFinalLevel = Number(actualLevel) === Number(maxHierarchyLevel);

  // NEW: once final level has explicitly locked it, nobody can edit anymore
  const isLocked = isFinalLevel && myEntry?.is_final_submission === true;

  const editable = !isReadOnly && !hasNextLevelApproved && !isLocked;

  const myHierarchyEntry = data.appraisal?.hierarchy?.find((h) => Number(h.level) === Number(actualLevel));
  const myLevelWiseEntry = levelWiseRatings.find((l) => Number(l.level) === Number(actualLevel));
  const currentRoleName = myLevelWiseEntry?.role || myHierarchyEntry?.role || myHierarchyEntry?.designation || `Level ${actualLevel}`;

  // Calculate Previous Levels for dynamic columns
  const previousLevels = [];
  for (let i = 1; i < actualLevel; i++) {
    const hInfo = data.appraisal?.hierarchy?.find(h => Number(h.level) === i);
    const lRating = levelWiseRatings.find(l => Number(l.level) === i);
    const roleName = lRating?.role || hInfo?.role || hInfo?.designation || `Level ${i}`;
    previousLevels.push({ level: i, name: roleName });
  }

  const categoryColSpan = 4 + previousLevels.length;

  const getRatingOptions = (maxVal) => {
    const options = [];
    for (let v = 0; v <= maxVal; v += 0.5) options.push(Number(v.toFixed(1)));
    return options;
  };

  const handleMarkChange = (questionId, value) => {
    if (!editable) return;
    setMarks((prev) => ({ ...prev, [questionId]: value }));
  };

  // NEW: per-section totals for "your rating" cards
  const getSectionTotals = (group) => {
    const max = group.items.reduce((sum, q) => sum + Number(q.max || 0), 0);
    const scored = group.items.reduce((sum, q) => {
      const v = marks[q.questionId];
      return sum + (v === "" || v === undefined || v === null ? 0 : Number(v));
    }, 0);
    return { scored, max };
  };

  const getOverallTotals = () => {
    return unifiedQuestions.reduce(
      (acc, group) => {
        const { scored, max } = getSectionTotals(group);
        return { scored: acc.scored + scored, max: acc.max + max };
      },
      { scored: 0, max: 0 }
    );
  };

  // NEW: rating scale legend — collects distinct schemas by their "out_of" value
  const renderRatingLegend = () => {
    const seen = {};
    unifiedQuestions.forEach(group => {
      group.items.forEach(q => {
        if (q.ratingSchema && q.max && !seen[q.max]) {
          seen[q.max] = q.ratingSchema;
        }
      });
    });

    const outOfValues = Object.keys(seen);
    if (outOfValues.length === 0) return null;

    return (
      <div className="sar-legend-box">
        <div className="sar-legend-title">Rating Scale</div>
        {outOfValues.map((outOf) => {
          const schema = seen[outOf];
          const validKeys = Object.keys(schema).filter((k) => k !== "totalRating");
          return (
            <div className="sar-legend-row" key={outOf}>
              <span className="sar-legend-scale-label">Out of {outOf}</span>
              {validKeys.map((key) => {
                const range = schema[key];
                const tag = getRatingLabel(range.max, Number(outOf)) || { color: "#6c757d" };
                return (
                  <span key={key} className="sar-legend-pill" style={{
                    background: tag.bg,
                    color: tag.color,
                    border: `1px solid ${tag.border}`,
                  }}>
                    {range.min}-{range.max} {key}
                  </span>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  const handleSubmit = async () => {
    setSaving(true);
    const loadingId = toast.loading(
      isFinalLevel && finalConfirm ? "Submitting final rating..." : "Submitting rating..."
    );
    try {
      const pk = myEntry?.id || myEntry?.approval_id || myEntry?.pk;
      const apiCalls = [];

      // Split questions into Filled (has employee_appraisal_rating) and Unfilled
      const filledActions = [];
      const unfilledQuestions = [];

      unifiedQuestions.forEach(group => {
        group.items.forEach(q => {
          const val = String(marks[q.questionId] ?? "0");
          if (q.ratingId) {
            filledActions.push({
              employee_appraisal_rating: q.ratingId,
              marks_by_authority: val
            });
          } else {
            unfilledQuestions.push({
              questionId: q.questionId,
              mark: val
            });
          }
        });
      });

      // 1. Process Filled / Existing API
      if (pk || filledActions.length > 0) {
        const oldPayload = {
          level: Number(actualLevel),
          approver: myEmpCode,
          status,
          remarks,
          ...(isFinalLevel ? { is_final_submission: finalConfirm } : {}),
          appraisal_actions: filledActions,
        };

        if (pk) {
          apiCalls.push(axios.put(`${BASE_URL}/wfm/appraisal-approval-hierarchy-update/${pk}/`, oldPayload));
        } else if (filledActions.length > 0) {
          apiCalls.push(axios.post(`${BASE_URL}/wfm/appraisal-approval-hierarchy-create/`, oldPayload));
        }
      }

      // 2. Process Unfilled / New API
      if (unfilledQuestions.length > 0) {
        const employee_appraisal_ratings = unfilledQuestions.map(q => ({
          employee: employeeCode,
          appraisal_sub_details: q.questionId,
          created_by: myEmpCode,
          updated_by: myEmpCode
        }));

        const appraisal_approval_actions = unfilledQuestions.map((q, index) => ({
          rating_index: index,
          marks_by_authority: q.mark
        }));

        const newPayload = {
          employee_appraisal_ratings,
          appraisal_approval_hierarchy: {
            level: Number(actualLevel),
            approver: myEmpCode,
            status,
            remarks,
            ...(isFinalLevel ? { is_final_submission: finalConfirm } : {}),
            created_by: myEmpCode,
            updated_by: myEmpCode
          },
          appraisal_approval_actions
        };

        apiCalls.push(axios.post(`${BASE_URL}/wfm/employee-appraisal-rating-with-hierarchy-create/`, newPayload));
      }

      const res = await Promise.all(apiCalls);
      const allSuccess = res.every((r) => r.status === 200 || r.status === 201);

      if (allSuccess) {
        await onSuccess();
        toast.success(isFinalLevel && finalConfirm ? "Final rating submitted & locked." : "Rating submitted.");
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err, loadingId);
    } finally {
      setSaving(false);
      toast.dismiss(loadingId);
    }
  };

  const overall = getOverallTotals();
  const overallPct = overall.max ? Math.round((overall.scored / overall.max) * 100) : 0;
  const overallTag = getRatingLabel(overall.scored, overall.max);

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model modal-xl" backdrop="static">
      <Modal.Header closeButton className="sar-modal-header">
        <div>
          <Modal.Title className="sar-modal-title">
            {data.employee?.name} — {currentRoleName} Rating
          </Modal.Title>
          <div className="sar-modal-subtitle">
            {formattedDateLong(data.appraisal?.rating_period_start)} to {formattedDateLong(data.appraisal?.rating_period_end)}
            {" · "}
            {isLocked
              ? "Locked — final submission recorded, this appraisal is now view-only."
              : editable
                ? "Rate the parameters below and submit. You can revise until you lock the final submission."
                : "Locked — the next level has already acted on this appraisal, making it view-only."}
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="bg-light">
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

        <div className="register-form p-2">

          {/* ---- Summary cards ---- */}
          <div className="sar-summary-row">
            {unifiedQuestions.map((group, idx) => {
              const { scored, max } = getSectionTotals(group);
              const pct = max ? Math.round((scored / max) * 100) : 0;
              return (
                <div className="sar-summary-card sar-card-neutral" key={idx}>
                  <div className="sar-card-icon" style={{ background: `${getSectionColor(group.label)}15` }}>
                    {getSectionIcon(group.label)}
                  </div>
                  <div className="sar-card-label">{group.label}</div>
                  <div className="sar-card-score">
                    <span className="sar-card-score-value" style={{ color: getSectionColor(group.label) }}>
                      {scored.toFixed(1)}
                    </span>
                    <small className="sar-card-score-max"> / {max}</small>
                  </div>
                  <div className="sar-card-progress-track">
                    <div
                      className="sar-card-progress-fill"
                      style={{ width: `${pct}%`, background: getSectionColor(group.label) }}
                    />
                  </div>
                  <div className="sar-card-progress-pct">{pct}%</div>
                </div>
              );
            })}

            <div className="sar-summary-card sar-card-overall">
              <div className="sar-card-icon">
                <OverallIcon />
              </div>
              <div className="sar-card-label">Overall</div>
              <div className="sar-card-score">
                {overall.scored.toFixed(1)} <small>/ {overall.max}</small>
              </div>
              <div className="sar-card-progress-track">
                <div className="sar-card-progress-fill" style={{ width: `${overallPct}%`, background: "#fff" }} />
              </div>
              {overallTag && (
                <span className="sar-card-badge" style={{ background: overallTag.color }}>
                  {overallTag.label}
                </span>
              )}
            </div>
          </div>

          {/* ---- Ratings table ---- */}
          <div className="sar-table-wrap" style={{ overflowX: "auto" }}>
            <table className="table sar-table mb-0">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th className="w-25">Description</th>
                  <th className="text-center">Max marks</th>
                  <th className="text-center">Employee Rating</th>

                  {previousLevels.map(pl => (
                    <th key={pl.level} className="text-center">{pl.name}</th>
                  ))}

                  <th className="text-center" style={{ minWidth: "140px" }}>
                    {currentRoleName} (Your Rating)
                  </th>
                </tr>
              </thead>
              <tbody>
                {unifiedQuestions.map((group, idx) => {
                  // NEW: is this section editable for the current approver's role?
                  const sectionEditable = editable && isSectionEnabledForRole(group.label, currentRoleName);

                  return (
                    <React.Fragment key={idx}>
                      <tr className="sar-section-row">
                        <td colSpan={categoryColSpan} className="font-weight-bold bg-light">
                          {group.label?.toUpperCase()}
                          {/* NEW: show lock badge when this role can't rate this section */}
                          {editable && !sectionEditable && (
                            <span className="sar-lock-badge">🔒 View only</span>
                          )}
                        </td>
                      </tr>
                      {group.items.map((q) => {
                        const currentValue = marks[q.questionId];
                        const tag = getRatingLabel(currentValue, Number(q.max));
                        const isFilled = currentValue !== "" && currentValue !== undefined && currentValue !== null;

                        return (
                          <tr key={q.questionId} className="sar-param-row">
                            <td><span className="sar-param-name">{q.name}</span></td>
                            <td className="sar-param-desc">{q?.description}</td>
                            <td className="text-center"><span className="sar-max-badge">{q.max}</span></td>
                            <td className="text-center text-muted">{q.employee_marks ?? "-"}</td>

                            {previousLevels.map(pl => (
                              <td key={pl.level} className="text-center text-muted">
                                {getMarksForLevel(q.ratingId, pl.level, levelWiseRatings)}
                              </td>
                            ))}

                            <td className="text-center">
                              {sectionEditable ? (
                                <>
                                  <select
                                    value={currentValue ?? ""}
                                    onChange={(e) => handleMarkChange(q.questionId, e.target.value)}
                                    className={`sar-rating-select ${isFilled ? "sar-select-filled" : ""}`}
                                  >
                                    <option value="">--</option>
                                    {getRatingOptions(Number(q.max)).map((opt) => (
                                      <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                  </select>
                                  {tag && (
                                    <span className="sar-rating-tag" style={{ color: tag.color }}>
                                      {tag.label}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <>
                                  <span className="sar-readonly-value font-weight-bold">
                                    {isFilled ? currentValue : "-"}
                                  </span>
                                  {tag && (
                                    <span className="sar-rating-tag" style={{ color: tag.color }}>
                                      {tag.label}
                                    </span>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  )
                })}

                {/* Grand total row */}
                <tr className="sar-total-row">
                  <td colSpan={2 + previousLevels.length}>TOTAL RATING MARKS</td>
                  <td className="text-center"></td>
                  <td ></td>
                  <td className="text-center">{overall.scored.toFixed(1)} / {overall.max}</td>

                </tr>
              </tbody>
            </table>
          </div>

          {/* ---- Rating scale legend ---- */}
          {renderRatingLegend()}



          <div>
            <label className="sar-confirm-text fw-bold d-block mb-1">Remarks</label>
            <textarea
              className="form-control"
              rows={2}
              value={remarks}
              disabled={!editable}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Add remarks for this level..."
            />
          </div>

          {/* NEW: final lock confirmation — only for the last hierarchy level (e.g. Admin) */}
          {isFinalLevel && editable && (
            <div className="form-check form-switch d-flex align-items-start mt-3 pt-3 border-top">
              <input
                className="form-check-input cursor-pointer mt-1"
                type="checkbox"
                id="finalLockSwitch"
                checked={finalConfirm}
                onChange={() => setFinalConfirm(!finalConfirm)}
                style={{ width: "2.6em", height: "1.3em" }}
              />
              <label className="form-check-label ms-3" htmlFor="finalLockSwitch">
                <div className="sar-confirm-text">
                  This is my final submission for this appraisal.
                </div>
                <div className="sar-confirm-subtext">
                  Once submitted with this checked, the ratings will be locked and cannot be edited by anyone, including you.
                </div>
              </label>
            </div>
          )}


          <div className="button-models" style={{ marginTop: '20px' }}>
            <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}>
              {editable ? "Cancel" : "Close"}
            </button>
            {editable && (
              <button
                type="button"
                className="model-button model-button-leave font-weight500 font-size-heading"
                onClick={handleSubmit}
                disabled={saving}
              >
                {saving
                  ? "Submitting..."
                  : isFinalLevel && finalConfirm
                    ? "Final Submit & Lock"
                    : myEntry?.status === 'approved'
                      ? "Update Rating"
                      : "Submit Rating"}
              </button>
            )}
          </div>

        </div>
      </Modal.Body>
    </Modal>
  );
};

//--------------------------------------------------------------------------not used

const UploadAppraisalDetailsByRH = ({ i, getDepartmentAppraisalData }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  const [formData, setFormData] = useState({
    emp_code: sessionStorage.getItem("emp_code"),

    accuracy_rh: 0,
    speedlyWork_rh: 0,
    SelfInitiative_rh: 0,
    responsbilityaccountability_rh: 0,
    independentWorking_rh: 0,
    decisonMakingCapsability_rh: 0,
    totalperformance_rh: 0,

    punctuality_rh: 0,
    teamwork_rh: 0,
    loyalitytowardsWork_rh: 0,
    dedicationtowardsWork_rh: 0,
    obeideintorLeadership_rh: 0,
    totaldecipline_rh: 0,

    total_rh: 0,

    rh_update_by: "",
    rh_update_datetime: ""
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    console.log("newErrors")
    console.log(newErrors)
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, min, max } = e.target;
    const minValue = parseFloat(min);
    const maxValue = parseFloat(max);
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue)) {
      // Allow numbers up to one decimal place
      const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

      if (!decimalPrecisionCheck.test(numericValue.toString())) {
        setErrors({
          ...errors,
          [name]: "Only up to one decimal place allowed.",
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue < minValue) {
        setErrors({
          ...errors,
          [name]: `Min limit ${minValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue > maxValue) {
        setErrors({
          ...errors,
          [name]: `Max limit ${maxValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });

        setFormData({
          ...formData,
          [name]: numericValue,
        });

        setInputState({
          ...inputState,
          [name]: "success",
        });
      }
    } else {
      setErrors({});
      setFormData({
        ...formData,
        [name]: 0,
      });

      setInputState({
        ...inputState,
        [name]: "",
      });
    }
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,

      totalperformance_rh: (
        (parseFloat(formData.accuracy_rh) || 0) +
        (parseFloat(formData.speedlyWork_rh) || 0) +
        (parseFloat(formData.SelfInitiative_rh) || 0) +
        (parseFloat(formData.responsbilityaccountability_rh) || 0) +
        (parseFloat(formData.independentWorking_rh) || 0) +
        (parseFloat(formData.decisonMakingCapability_rh) || 0)
      ).toFixed(1),

      totaldecipline_rh: (
        (parseFloat(formData.punctuality_rh) || 0) +
        (parseFloat(formData.teamwork_rh) || 0) +
        (parseFloat(formData.loyalitytowardsWork_rh) || 0) +
        (parseFloat(formData.dedicationtowardsWork_rh) || 0) +
        (parseFloat(formData.obeideintorLeadership_rh) || 0)
      ).toFixed(1),

      total_rh: (
        (parseFloat(formData.accuracy_rh) || 0) +
        (parseFloat(formData.speedlyWork_rh) || 0) +
        (parseFloat(formData.SelfInitiative_rh) || 0) +
        (parseFloat(formData.responsbilityaccountability_rh) || 0) +
        (parseFloat(formData.independentWorking_rh) || 0) +
        (parseFloat(formData.decisonMakingCapability_rh) || 0) +
        (parseFloat(formData.punctuality_rh) || 0) +
        (parseFloat(formData.teamwork_rh) || 0) +
        (parseFloat(formData.loyalitytowardsWork_rh) || 0) +
        (parseFloat(formData.dedicationtowardsWork_rh) || 0) +
        (parseFloat(formData.obeideintorLeadership_rh) || 0)
      ).toFixed(1),


      rh_update_by: `${sessionStorage.getItem('emp_code')}-${sessionStorage.getItem('name')}`,
      rh_update_datetime: new Date().toISOString(),
    };


    if (validateForm()) {

      console.log("updatedFormData")
      console.log(updatedFormData)

      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      let ress = await axios.put(`${BASE_URL}/wfm/QuickAppresalUpdate/${i.id}/`, updatedFormData);
      if (ress.status === 200) {
        // window.location.reload();
        await getDepartmentAppraisalData();
        handleClose();
      } else {
        alert(ress);
      }
      try {

        // alert("appraisalspost");
      } catch (err) {
        handleAllError(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title="Update Reporting Head Raitings" className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Reporting Head Appraisal Ratings Upload for "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center width-5vw">Reporting Head Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={5} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_rh", emp: "accuracy_emp", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_rh", emp: "speedlyWork_emp", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_rh", emp: "SelfInitiative_emp", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_rh", emp: "responsbilityaccountability_emp", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_rh", emp: "independentWorking_emp", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_rh", emp: "decisonMakingCapability_emp", min: -10, max: 10 },
                    ].map(({ label, name, emp, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_rh) || 0) +
                          (parseFloat(formData.speedlyWork_rh) || 0) +
                          (parseFloat(formData.SelfInitiative_rh) || 0) +
                          (parseFloat(formData.responsbilityaccountability_rh) || 0) +
                          (parseFloat(formData.independentWorking_rh) || 0) +
                          (parseFloat(formData.decisonMakingCapability_rh) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={5} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_rh", emp: "punctuality_emp", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_rh", emp: "teamwork_emp", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_rh", emp: "loyalitytowardsWork_emp", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_rh", emp: "dedicationtowardsWork_emp", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_rh", emp: "obeideintorLeadership_emp", min: -10, max: 10 }
                    ].map(({ label, name, emp, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.punctuality_rh) || 0) +
                          (parseFloat(formData.teamwork_rh) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_rh) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_rh) || 0) +
                          (parseFloat(formData.obeideintorLeadership_rh) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_rh) || 0) +
                          (parseFloat(formData.speedlyWork_rh) || 0) +
                          (parseFloat(formData.SelfInitiative_rh) || 0) +
                          (parseFloat(formData.responsbilityaccountability_rh) || 0) +
                          (parseFloat(formData.independentWorking_rh) || 0) +
                          (parseFloat(formData.decisonMakingCapability_rh) || 0) +
                          (parseFloat(formData.punctuality_rh) || 0) +
                          (parseFloat(formData.teamwork_rh) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_rh) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_rh) || 0) +
                          (parseFloat(formData.obeideintorLeadership_rh) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="float-right">
              <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
                <input
                  type="checkbox"
                  checked={submitConfirmation}
                  onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
                />
                <></>
                <span>
                  Click to Confirm and Sumbit
                </span>
              </label>
            </div>
            <br />

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>

              {submitConfirmation ?
                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                  {loading ? 'Submiting...' : 'Submit'}
                </button>
                :
                <button
                  className={`model-button model-button-cancel  font-weight500`}
                  disabled={!submitConfirmation}
                >
                  {"Confirmation Needed"}
                </button>
              }
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ViewAppraisalDetailsByRH = ({ i }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i)
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [formData, setFormData] = useState({});


  return (
    <>
      <button title="View By Reporting Head" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Reporting Head Appraisal Ratings of : "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">Reporting Head Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={5} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", rh: "accuracy_rh", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", rh: "speedlyWork_rh", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", rh: "SelfInitiative_rh", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", rh: "responsbilityaccountability_rh", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", rh: "independentWorking_rh", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", rh: "decisonMakingCapability_rh", min: -10, max: 10 },
                    ].map(({ label, name, emp, rh, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_rh}</th>
                    </tr>
                    <tr>
                      <th colSpan={5} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", rh: "punctuality_rh", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", rh: "teamwork_rh", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", rh: "loyalitytowardsWork_rh", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", rh: "dedicationtowardsWork_rh", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", rh: "obeideintorLeadership_rh", min: -10, max: 10 }
                    ].map(({ label, name, emp, rh, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_rh}</th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_rh}</th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Close
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UploadAppraisalDetailsByHOD = ({ i, getDepartmentAppraisalData }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  const [formData, setFormData] = useState({
    emp_code: sessionStorage.getItem("emp_code"),

    accuracy_hod: 0,
    speedlyWork_hod: 0,
    SelfInitiative_hod: 0,
    responsbilityaccountability_hod: 0,
    independentWorking_hod: 0,
    decisonMakingCapsability_hod: 0,
    totalperformance_hod: 0,

    punctuality_hod: 0,
    teamwork_hod: 0,
    loyalitytowardsWork_hod: 0,
    dedicationtowardsWork_hod: 0,
    obeideintorLeadership_hod: 0,
    totaldecipline_hod: 0,

    total_hod: 0,

    hod_update_by: "",
    hod_update_datetime: ""
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    console.log("newErrors")
    console.log(newErrors)
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value, min, max } = e.target;
    const minValue = parseFloat(min);
    const maxValue = parseFloat(max);
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue)) {
      // Allow numbers up to one decimal place
      const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

      if (!decimalPrecisionCheck.test(numericValue.toString())) {
        setErrors({
          ...errors,
          [name]: "Only up to one decimal place allowed.",
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue < minValue) {
        setErrors({
          ...errors,
          [name]: `Min limit ${minValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue > maxValue) {
        setErrors({
          ...errors,
          [name]: `Max limit ${maxValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });

        setFormData({
          ...formData,
          [name]: numericValue,
        });

        setInputState({
          ...inputState,
          [name]: "success",
        });
      }
    } else {
      setErrors({});
      setFormData({
        ...formData,
        [name]: 0,
      });

      setInputState({
        ...inputState,
        [name]: "",
      });
    }
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,

      totalperformance_hod:
        (
          (parseFloat(formData.accuracy_hod) || 0) +
          (parseFloat(formData.speedlyWork_hod) || 0) +
          (parseFloat(formData.SelfInitiative_hod) || 0) +
          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
          (parseFloat(formData.independentWorking_hod) || 0) +
          (parseFloat(formData.decisonMakingCapability_hod) || 0)
        ).toFixed(1),

      totaldecipline_hod:
        (
          (parseFloat(formData.punctuality_hod) || 0) +
          (parseFloat(formData.teamwork_hod) || 0) +
          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
          (parseFloat(formData.obeideintorLeadership_hod) || 0)
        ).toFixed(1),

      total_hod:
        (
          (parseFloat(formData.accuracy_hod) || 0) +
          (parseFloat(formData.speedlyWork_hod) || 0) +
          (parseFloat(formData.SelfInitiative_hod) || 0) +
          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
          (parseFloat(formData.independentWorking_hod) || 0) +
          (parseFloat(formData.decisonMakingCapability_hod) || 0) +
          (parseFloat(formData.punctuality_hod) || 0) +
          (parseFloat(formData.teamwork_hod) || 0) +
          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
          (parseFloat(formData.obeideintorLeadership_hod) || 0)
        ).toFixed(1),

      hod_update_by: `${sessionStorage.getItem('emp_code')}-${sessionStorage.getItem('name')}`,
      hod_update_datetime: new Date().toISOString(),
    };


    if (validateForm()) {

      console.log("updatedFormData")
      console.log(updatedFormData)

      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      let ress = await axios.put(`${BASE_URL}/wfm/QuickAppresalUpdate/${i.id}/`, updatedFormData);
      if (ress.status === 200) {
        // window.location.reload();
        await getDepartmentAppraisalData();
        handleClose();
      } else {
        alert(ress);
      }
      try {

        // alert("appraisalspost");
      } catch (err) {
        handleAllError(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title="Update HOD Raitings" className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>HOD Appraisal Ratings Upload for "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center width-5vw">HOD Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={5} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_hod", emp: "accuracy_emp", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_hod", emp: "speedlyWork_emp", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_hod", emp: "SelfInitiative_emp", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_hod", emp: "responsbilityaccountability_emp", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_hod", emp: "independentWorking_emp", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_hod", emp: "decisonMakingCapability_emp", min: -10, max: 10 },
                    ].map(({ label, name, emp, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_hod) || 0) +
                          (parseFloat(formData.speedlyWork_hod) || 0) +
                          (parseFloat(formData.SelfInitiative_hod) || 0) +
                          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
                          (parseFloat(formData.independentWorking_hod) || 0) +
                          (parseFloat(formData.decisonMakingCapability_hod) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={5} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_hod", emp: "punctuality_emp", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_hod", emp: "teamwork_emp", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_hod", emp: "loyalitytowardsWork_emp", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_hod", emp: "dedicationtowardsWork_emp", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_hod", emp: "obeideintorLeadership_emp", min: -10, max: 10 }
                    ].map(({ label, name, emp, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.punctuality_hod) || 0) +
                          (parseFloat(formData.teamwork_hod) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
                          (parseFloat(formData.obeideintorLeadership_hod) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_hod) || 0) +
                          (parseFloat(formData.speedlyWork_hod) || 0) +
                          (parseFloat(formData.SelfInitiative_hod) || 0) +
                          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
                          (parseFloat(formData.independentWorking_hod) || 0) +
                          (parseFloat(formData.decisonMakingCapability_hod) || 0) +
                          (parseFloat(formData.punctuality_hod) || 0) +
                          (parseFloat(formData.teamwork_hod) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
                          (parseFloat(formData.obeideintorLeadership_hod) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="float-right">
              <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
                <input
                  type="checkbox"
                  checked={submitConfirmation}
                  onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
                />
                <></>
                <span>
                  Click to Confirm and Sumbit
                </span>
              </label>
            </div>
            <br />

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>

              {submitConfirmation ?
                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                  {loading ? 'Submiting...' : 'Submit'}
                </button>
                :
                <button
                  className={`model-button model-button-cancel  font-weight500`}
                  disabled={!submitConfirmation}
                >
                  {"Confirmation Needed"}
                </button>
              }
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ViewAppraisalDetailsByHOD = ({ i }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i)
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [formData, setFormData] = useState({});


  return (
    <>
      <button title="View By HOD" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>HOD Appraisal Ratings of : "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">HOD Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={5} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", hod: "accuracy_hod", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", hod: "speedlyWork_hod", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", hod: "SelfInitiative_hod", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", hod: "independentWorking_hod", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
                    ].map(({ label, name, emp, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[hod]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_hod}</th>
                    </tr>
                    <tr>
                      <th colSpan={5} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", hod: "punctuality_hod", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", hod: "teamwork_hod", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
                    ].map(({ label, name, emp, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[hod]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_hod}</th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_hod}</th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Close
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UploadAppraisalDetailsByRHHOD = ({ i, getDepartmentAppraisalData }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [submitConfirmationError, setSubmitConfirmationError] = useState("");
  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  const [formData, setFormData] = useState({
    emp_code: sessionStorage.getItem("emp_code"),

    accuracy_hod: 0,
    speedlyWork_hod: 0,
    SelfInitiative_hod: 0,
    responsbilityaccountability_hod: 0,
    independentWorking_hod: 0,
    decisonMakingCapsability_hod: 0,
    totalperformance_hod: 0,

    punctuality_hod: 0,
    teamwork_hod: 0,
    loyalitytowardsWork_hod: 0,
    dedicationtowardsWork_hod: 0,
    obeideintorLeadership_hod: 0,
    totaldecipline_hod: 0,

    total_hod: 0,

    hod_update_by: "",
    hod_update_datetime: ""
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    console.log("newErrors")
    console.log(newErrors)
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value, min, max } = e.target;
    const minValue = parseFloat(min);
    const maxValue = parseFloat(max);
    const numericValue = parseFloat(value);

    if (i.rh_update_datetime === null) {
      setSubmitConfirmationError(`Reporting Head of "${i.name}" has not Uploaded the Ratings.`);
    }
    else {
      setSubmitConfirmationError("");
    }

    if (!isNaN(numericValue)) {
      // Allow numbers up to one decimal place
      const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

      if (!decimalPrecisionCheck.test(numericValue.toString())) {
        setErrors({
          ...errors,
          [name]: "Only up to one decimal place allowed.",
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue < minValue) {
        setErrors({
          ...errors,
          [name]: `Min limit ${minValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue > maxValue) {
        setErrors({
          ...errors,
          [name]: `Max limit ${maxValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });

        setFormData({
          ...formData,
          [name]: numericValue,
        });

        setInputState({
          ...inputState,
          [name]: "success",
        });
      }
    } else {
      setErrors({});
      setFormData({
        ...formData,
        [name]: 0,
      });

      setInputState({
        ...inputState,
        [name]: "",
      });
    }
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,

      totalperformance_hod:
        (
          (parseFloat(formData.accuracy_hod) || 0) +
          (parseFloat(formData.speedlyWork_hod) || 0) +
          (parseFloat(formData.SelfInitiative_hod) || 0) +
          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
          (parseFloat(formData.independentWorking_hod) || 0) +
          (parseFloat(formData.decisonMakingCapability_hod) || 0)
        ).toFixed(1),

      totaldecipline_hod:
        (
          (parseFloat(formData.punctuality_hod) || 0) +
          (parseFloat(formData.teamwork_hod) || 0) +
          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
          (parseFloat(formData.obeideintorLeadership_hod) || 0)
        ).toFixed(1),

      total_hod:
        (
          (parseFloat(formData.accuracy_hod) || 0) +
          (parseFloat(formData.speedlyWork_hod) || 0) +
          (parseFloat(formData.SelfInitiative_hod) || 0) +
          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
          (parseFloat(formData.independentWorking_hod) || 0) +
          (parseFloat(formData.decisonMakingCapability_hod) || 0) +
          (parseFloat(formData.punctuality_hod) || 0) +
          (parseFloat(formData.teamwork_hod) || 0) +
          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
          (parseFloat(formData.obeideintorLeadership_hod) || 0)
        ).toFixed(1),

      hod_update_by: `${sessionStorage.getItem('emp_code')}-${sessionStorage.getItem('name')}`,
      hod_update_datetime: new Date().toISOString(),
    };


    if (validateForm()) {

      console.log("updatedFormData")
      console.log(updatedFormData)

      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      let ress = await axios.put(`${BASE_URL}/wfm/QuickAppresalUpdate/${i.id}/`, updatedFormData);
      if (ress.status === 200) {
        // window.location.reload();
        await getDepartmentAppraisalData();
        handleClose();
      } else {
        alert(ress);
      }
      try {

        // alert("appraisalspost");
      } catch (err) {
        handleAllError(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title="Update HOD Raitings" className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>HOD Appraisal Ratings Upload for "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">Reporting Head Rating</th>
                    <th className="align-center width-5vw">HOD Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={6} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_hod", emp: "accuracy_emp", rh: "accuracy_rh", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_hod", emp: "speedlyWork_emp", rh: "speedlyWork_rh", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_hod", emp: "SelfInitiative_emp", rh: "SelfInitiative_rh", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_hod", emp: "responsbilityaccountability_emp", rh: "responsbilityaccountability_rh", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_hod", emp: "independentWorking_emp", rh: "independentWorking_rh", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_hod", emp: "decisonMakingCapability_emp", rh: "decisonMakingCapability_rh", min: -10, max: 10 },
                    ].map(({ label, name, emp, rh, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_rh}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_hod) || 0) +
                          (parseFloat(formData.speedlyWork_hod) || 0) +
                          (parseFloat(formData.SelfInitiative_hod) || 0) +
                          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
                          (parseFloat(formData.independentWorking_hod) || 0) +
                          (parseFloat(formData.decisonMakingCapability_hod) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={6} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_hod", emp: "punctuality_emp", rh: "punctuality_rh", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_hod", emp: "teamwork_emp", rh: "teamwork_rh", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_hod", emp: "loyalitytowardsWork_emp", rh: "loyalitytowardsWork_rh", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_hod", emp: "dedicationtowardsWork_emp", rh: "dedicationtowardsWork_rh", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_hod", emp: "obeideintorLeadership_emp", rh: "obeideintorLeadership_rh", min: -10, max: 10 }
                    ].map(({ label, name, emp, rh, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_rh}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.punctuality_hod) || 0) +
                          (parseFloat(formData.teamwork_hod) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
                          (parseFloat(formData.obeideintorLeadership_hod) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_rh}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_hod) || 0) +
                          (parseFloat(formData.speedlyWork_hod) || 0) +
                          (parseFloat(formData.SelfInitiative_hod) || 0) +
                          (parseFloat(formData.responsbilityaccountability_hod) || 0) +
                          (parseFloat(formData.independentWorking_hod) || 0) +
                          (parseFloat(formData.decisonMakingCapability_hod) || 0) +
                          (parseFloat(formData.punctuality_hod) || 0) +
                          (parseFloat(formData.teamwork_hod) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_hod) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_hod) || 0) +
                          (parseFloat(formData.obeideintorLeadership_hod) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>
            {submitConfirmationError === "" ?

              <div className="float-right">
                <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
                  <input
                    type="checkbox"
                    checked={submitConfirmation}
                    onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
                  />
                  <></>
                  <span>
                    Click to Confirm and Sumbit
                  </span>
                </label>

              </div>
              : (
                <div className="flex-column" style={{ marginTop: "5px" }}>
                  <div style={{ color: "red" }}>
                    Note:
                    <br />
                    {submitConfirmationError}
                  </div>
                  <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
                    <input
                      type="checkbox"
                      checked={submitConfirmation}
                      onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
                    />
                    <></>
                    <span>
                      Click to Confirm and Sumbit
                    </span>
                  </label>
                </div>
              )}


            <br />

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>

              {submitConfirmation ?
                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                  {loading ? 'Submiting...' : 'Submit'}
                </button>
                :
                <button
                  className={`model-button model-button-cancel  font-weight500`}
                  disabled={!submitConfirmation}
                >
                  {"Confirmation Needed"}
                </button>
              }
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ViewAppraisalDetailsByRHHOD = ({ i }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i)
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [formData, setFormData] = useState({});


  return (
    <>
      <button title="View EMP, RH, HOD Raitings" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>HOD Appraisal Ratings of : "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">Reporting Head Rating</th>
                    <th className="align-center">HOD Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={6} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", rh: "accuracy_rh", hod: "accuracy_hod", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", rh: "speedlyWork_rh", hod: "speedlyWork_hod", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", rh: "SelfInitiative_rh", hod: "SelfInitiative_hod", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", rh: "responsbilityaccountability_rh", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", rh: "independentWorking_rh", hod: "independentWorking_hod", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", rh: "decisonMakingCapability_rh", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
                    ].map(({ label, name, emp, rh, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td className="text-center">{formData[hod]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_rh}</th>
                      <th className="align-center">{formData.totalperformance_hod}</th>
                    </tr>
                    <tr>
                      <th colSpan={6} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", rh: "punctuality_rh", hod: "punctuality_hod", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", rh: "teamwork_rh", hod: "teamwork_hod", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", rh: "loyalitytowardsWork_rh", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", rh: "dedicationtowardsWork_rh", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", rh: "obeideintorLeadership_rh", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
                    ].map(({ label, name, emp, rh, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td className="text-center">{formData[hod]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_rh}</th>
                      <th className="align-center">{formData.totaldecipline_hod}</th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_rh}</th>
                      <th className="align-center">{formData.total_hod}</th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Close
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UploadAppraisalDetailsByHODAdmin = ({ i, getDepartmentAppraisalData }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }


  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  const [formData, setFormData] = useState({
    emp_code: sessionStorage.getItem("emp_code"),

    accuracy_admin: 0,
    speedlyWork_admin: 0,
    SelfInitiative_admin: 0,
    responsbilityaccountability_admin: 0,
    independentWorking_admin: 0,
    decisonMakingCapsability_admin: 0,
    totalperformance_admin: 0,

    punctuality_admin: 0,
    teamwork_admin: 0,
    loyalitytowardsWork_admin: 0,
    dedicationtowardsWork_admin: 0,
    obeideintorLeadership_admin: 0,
    totaldecipline_admin: 0,

    total_admin: 0,
    final_rating: 0,

    admin_update_by: "",
    admin_update_datetime: ""
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, min, max } = e.target;
    const minValue = parseFloat(min);
    const maxValue = parseFloat(max);
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue)) {
      // Allow numbers up to one decimal place
      const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

      if (!decimalPrecisionCheck.test(numericValue.toString())) {
        setErrors({
          ...errors,
          [name]: "Only up to one decimal place allowed.",
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue < minValue) {
        setErrors({
          ...errors,
          [name]: `Min limit ${minValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue > maxValue) {
        setErrors({
          ...errors,
          [name]: `Max limit ${maxValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });

        setFormData({
          ...formData,
          [name]: numericValue,
        });

        setInputState({
          ...inputState,
          [name]: "success",
        });
      }
    } else {
      setErrors({});
      setFormData({
        ...formData,
        [name]: 0,
      });

      setInputState({
        ...inputState,
        [name]: "",
      });
    }
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,

      totalperformance_admin: (
        (parseFloat(formData.accuracy_admin) || 0) +
        (parseFloat(formData.speedlyWork_admin) || 0) +
        (parseFloat(formData.SelfInitiative_admin) || 0) +
        (parseFloat(formData.responsbilityaccountability_admin) || 0) +
        (parseFloat(formData.independentWorking_admin) || 0) +
        (parseFloat(formData.decisonMakingCapability_admin) || 0)
      ).toFixed(1),

      totaldecipline_admin: (
        (parseFloat(formData.punctuality_admin) || 0) +
        (parseFloat(formData.teamwork_admin) || 0) +
        (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
        (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
        (parseFloat(formData.obeideintorLeadership_admin) || 0)
      ).toFixed(1),

      total_admin: (
        (parseFloat(formData.accuracy_admin) || 0) +
        (parseFloat(formData.speedlyWork_admin) || 0) +
        (parseFloat(formData.SelfInitiative_admin) || 0) +
        (parseFloat(formData.responsbilityaccountability_admin) || 0) +
        (parseFloat(formData.independentWorking_admin) || 0) +
        (parseFloat(formData.decisonMakingCapability_admin) || 0) +
        (parseFloat(formData.punctuality_admin) || 0) +
        (parseFloat(formData.teamwork_admin) || 0) +
        (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
        (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
        (parseFloat(formData.obeideintorLeadership_admin) || 0)
      ).toFixed(1),

      final_rating: (
        (parseFloat(formData.accuracy_admin) || 0) +
        (parseFloat(formData.speedlyWork_admin) || 0) +
        (parseFloat(formData.SelfInitiative_admin) || 0) +
        (parseFloat(formData.responsbilityaccountability_admin) || 0) +
        (parseFloat(formData.independentWorking_admin) || 0) +
        (parseFloat(formData.decisonMakingCapability_admin) || 0) +
        (parseFloat(formData.punctuality_admin) || 0) +
        (parseFloat(formData.teamwork_admin) || 0) +
        (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
        (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
        (parseFloat(formData.obeideintorLeadership_admin) || 0)
      ).toFixed(1),

      admin_update_by: `${sessionStorage.getItem('emp_code')}-${sessionStorage.getItem('name')}`,
      admin_update_datetime: new Date().toISOString(),
    };


    if (validateForm()) {

      console.log("updatedFormData")
      console.log(updatedFormData)

      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      let ress = await axios.put(`${BASE_URL}/wfm/QuickAppresalUpdate/${i.id}/`, updatedFormData);
      if (ress.status === 200) {
        // window.location.reload();
        await getDepartmentAppraisalData();
        handleClose();
      } else {
        alert(ress);
      }
      try {

        // alert("appraisalspost");
      } catch (err) {
        handleAllError(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };


  return (
    <>
      <button title="Update Admin Raitings" className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Admin Appraisal Ratings Upload for "{i.emp_code}-{i.name}" </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">HOD Rating</th>
                    <th className="align-center width-5vw">Admin Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={6} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", hod: "accuracy_hod", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", hod: "speedlyWork_hod", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", hod: "SelfInitiative_hod", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", hod: "independentWorking_hod", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
                    ].map(({ label, name, emp, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_hod}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={6} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", hod: "punctuality_hod", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", hod: "teamwork_hod", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
                    ].map(({ label, name, emp, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td title={`${hod}: ${formData[hod]}`} className="text-center">{formData[hod]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_hod}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_hod}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0) +
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="float-right">
              <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
                <input
                  type="checkbox"
                  checked={submitConfirmation}
                  onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
                />
                <></>
                <span>
                  Click to Confirm and Sumbit
                </span>
              </label>
            </div>
            <br />

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>

              {submitConfirmation ?
                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                  {loading ? 'Submiting...' : 'Submit'}
                </button>
                :
                <button
                  className={`model-button model-button-cancel  font-weight500`}
                  disabled={!submitConfirmation}
                >
                  {"Confirmation Needed"}
                </button>
              }
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ViewAppraisalDetailsHODAdmin = ({ i }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [formData, setFormData] = useState({});




  return (
    <>
      <button title="View Appraisal Raitings" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Appraisal Ratings - "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">HOD Rating</th>
                    <th className="align-center">Admin Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={6} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", hod: "accuracy_hod", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", hod: "speedlyWork_hod", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", hod: "SelfInitiative_hod", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", hod: "independentWorking_hod", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
                    ].map(({ label, name, emp, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td className="text-center">{formData[name]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-center"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_hod}</th>
                      <th className="align-center">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={6} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", hod: "punctuality_hod", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", hod: "teamwork_hod", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
                    ].map(({ label, name, emp, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td className="text-center">{formData[name]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-center"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_hod}</th>
                      <th className="align-center">
                        {(
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_hod}</th>
                      <th className="align-center">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0) +
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Close
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UploadAppraisalDetailsByRHHODAdmin = ({ i, getDepartmentAppraisalData }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }


  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  const [formData, setFormData] = useState({
    emp_code: sessionStorage.getItem("emp_code"),

    accuracy_admin: 0,
    speedlyWork_admin: 0,
    SelfInitiative_admin: 0,
    responsbilityaccountability_admin: 0,
    independentWorking_admin: 0,
    decisonMakingCapsability_admin: 0,
    totalperformance_admin: 0,

    punctuality_admin: 0,
    teamwork_admin: 0,
    loyalitytowardsWork_admin: 0,
    dedicationtowardsWork_admin: 0,
    obeideintorLeadership_admin: 0,
    totaldecipline_admin: 0,

    total_admin: 0,
    final_rating: 0,

    admin_update_by: "",
    admin_update_datetime: ""
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, min, max } = e.target;
    const minValue = parseFloat(min);
    const maxValue = parseFloat(max);
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue)) {
      // Allow numbers up to one decimal place
      const decimalPrecisionCheck = /^[0-9]+(\.[0-9]{1})?$/;

      if (!decimalPrecisionCheck.test(numericValue.toString())) {
        setErrors({
          ...errors,
          [name]: "Only up to one decimal place allowed.",
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue < minValue) {
        setErrors({
          ...errors,
          [name]: `Min limit ${minValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else if (numericValue > maxValue) {
        setErrors({
          ...errors,
          [name]: `Max limit ${maxValue}`,
        });

        setInputState({
          ...inputState,
          [name]: "error",
        });
      } else {
        setErrors({
          ...errors,
          [name]: "",
        });

        setFormData({
          ...formData,
          [name]: numericValue,
        });

        setInputState({
          ...inputState,
          [name]: "success",
        });
      }
    } else {
      setErrors({});
      setFormData({
        ...formData,
        [name]: 0,
      });

      setInputState({
        ...inputState,
        [name]: "",
      });
    }
  };


  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,
      totalperformance_admin:
        (
          (parseFloat(formData.accuracy_admin) || 0) +
          (parseFloat(formData.speedlyWork_admin) || 0) +
          (parseFloat(formData.SelfInitiative_admin) || 0) +
          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
          (parseFloat(formData.independentWorking_admin) || 0) +
          (parseFloat(formData.decisonMakingCapability_admin) || 0)
        ).toFixed(1),

      totaldecipline_admin:
        (
          (parseFloat(formData.punctuality_admin) || 0) +
          (parseFloat(formData.teamwork_admin) || 0) +
          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
          (parseFloat(formData.obeideintorLeadership_admin) || 0)
        ).toFixed(1),

      total_admin:
        (
          (parseFloat(formData.accuracy_admin) || 0) +
          (parseFloat(formData.speedlyWork_admin) || 0) +
          (parseFloat(formData.SelfInitiative_admin) || 0) +
          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
          (parseFloat(formData.independentWorking_admin) || 0) +
          (parseFloat(formData.decisonMakingCapability_admin) || 0) +
          (parseFloat(formData.punctuality_admin) || 0) +
          (parseFloat(formData.teamwork_admin) || 0) +
          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
          (parseFloat(formData.obeideintorLeadership_admin) || 0)
        ).toFixed(1),

      final_rating:
        (
          (parseFloat(formData.accuracy_admin) || 0) +
          (parseFloat(formData.speedlyWork_admin) || 0) +
          (parseFloat(formData.SelfInitiative_admin) || 0) +
          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
          (parseFloat(formData.independentWorking_admin) || 0) +
          (parseFloat(formData.decisonMakingCapability_admin) || 0) +
          (parseFloat(formData.punctuality_admin) || 0) +
          (parseFloat(formData.teamwork_admin) || 0) +
          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
          (parseFloat(formData.obeideintorLeadership_admin) || 0)
        ).toFixed(1),

      admin_update_by: `${sessionStorage.getItem('emp_code')}-${sessionStorage.getItem('name')}`,
      admin_update_datetime: new Date().toISOString(),
    };


    if (validateForm()) {

      console.log("updatedFormData")
      console.log(updatedFormData)

      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      let ress = await axios.put(`${BASE_URL}/wfm/QuickAppresalUpdate/${i.id}/`, updatedFormData);
      if (ress.status === 200) {
        // window.location.reload();
        await getDepartmentAppraisalData();
        handleClose();
      } else {
        alert(ress);
      }
      try {

        // alert("appraisalspost");
      } catch (err) {
        handleAllError(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };


  return (
    <>
      <button title="Update Admin Raitings" className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Admin Appraisal Ratings Upload for "{i.emp_code}-{i.name}" </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">Reporting Head Rating</th>
                    <th className="align-center">HOD Rating</th>
                    <th className="align-center width-5vw">Admin Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={7} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", rh: "accuracy_rh", hod: "accuracy_hod", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", rh: "speedlyWork_rh", hod: "speedlyWork_hod", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", rh: "SelfInitiative_rh", hod: "SelfInitiative_hod", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", rh: "responsbilityaccountability_rh", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", rh: "independentWorking_rh", hod: "independentWorking_hod", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", rh: "decisonMakingCapability_rh", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
                    ].map(({ label, name, emp, rh, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_rh}</th>
                      <th className="align-center">{formData.totalperformance_hod}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={7} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", rh: "punctuality_rh", hod: "punctuality_hod", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", rh: "teamwork_rh", hod: "teamwork_hod", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", rh: "loyalitytowardsWork_rh", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", rh: "dedicationtowardsWork_rh", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", rh: "obeideintorLeadership_rh", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
                    ].map(({ label, name, emp, rh, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td>
                          <input
                            type="number"
                            step={0}
                            min={min}
                            max={max}
                            name={name}
                            placeholder="Enter Rating"
                            value={formData[name]}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                            className={`form-input-tabular text-end ${errors[name] ? 'is-invalid' : ''}`}
                          />
                          <div className="align-center">
                            {errors[name] && <div className="error-message-input font-size-text">{errors[name]}</div>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-right"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_rh}</th>
                      <th className="align-center">{formData.totaldecipline_hod}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_rh}</th>
                      <th className="align-center">{formData.total_hod}</th>
                      <th className="align-right">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0) +
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="float-right">
              <label className="form-labels  font-weight500    font-size-subheading" style={{ marginTop: "5px" }}>
                <input
                  type="checkbox"
                  checked={submitConfirmation}
                  onChange={(e) => setSubmitConfirmation(!submitConfirmation)}
                />
                <></>
                <span>
                  Click to Confirm and Sumbit
                </span>
              </label>
            </div>
            <br />

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>

              {submitConfirmation ?
                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                  {loading ? 'Submiting...' : 'Submit'}
                </button>
                :
                <button
                  className={`model-button model-button-cancel  font-weight500`}
                  disabled={!submitConfirmation}
                >
                  {"Confirmation Needed"}
                </button>
              }
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ViewAppraisalDetailsRHHODAdmin = ({ i }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setFormData(i);
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [formData, setFormData] = useState({});

  return (
    <>
      <button title="View Appraisal Raitings" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Appraisal Ratings - "{i.emp_code}-{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">
            <div className="flex-row justify-center">
              <table className="nested-table-lightblue width-40vw">
                <thead>
                  <tr>
                    <th className="align-center">Rating Analysis</th>
                    <th colSpan={2} className="align-center">Total Rating Marks</th>
                    <th className="align-center">Emp Rating</th>
                    <th className="align-center">Reporting Head Rating</th>
                    <th className="align-center">HOD Rating</th>
                    <th className="align-center">Admin Rating</th>
                  </tr>
                  <tr>
                    <th className="align-center"></th>
                    <th className="align-center">+VE Marks</th>
                    <th className="align-center">-VE Marks</th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                    <th className="align-center"></th>
                  </tr>
                  <tr>
                    <th colSpan={7} className="align-leftt">PERFORMANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {[
                      { label: "Accuracy", name: "accuracy_admin", emp: "accuracy_emp", rh: "accuracy_rh", hod: "accuracy_hod", min: -20, max: 20 },
                      { label: "Speedly Work", name: "speedlyWork_admin", emp: "speedlyWork_emp", rh: "speedlyWork_rh", hod: "speedlyWork_hod", min: -10, max: 10 },
                      { label: "Self Initiative", name: "SelfInitiative_admin", emp: "SelfInitiative_emp", rh: "SelfInitiative_rh", hod: "SelfInitiative_hod", min: -15, max: 15 },
                      { label: "Responsibility & Accountability", name: "responsbilityaccountability_admin", emp: "responsbilityaccountability_emp", rh: "responsbilityaccountability_rh", hod: "responsbilityaccountability_hod", min: -10, max: 10 },
                      { label: "Independent Working", name: "independentWorking_admin", emp: "independentWorking_emp", rh: "independentWorking_rh", hod: "independentWorking_hod", min: -5, max: 5 },
                      { label: "Decision Making Capability", name: "decisonMakingCapability_admin", emp: "decisonMakingCapability_emp", rh: "decisonMakingCapability_rh", hod: "decisonMakingCapability_hod", min: -10, max: 10 },
                    ].map(({ label, name, emp, rh, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td className="text-center">{formData[name]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-center"></th>
                      <th className="align-center">70</th>
                      <th className="align-center">-70</th>
                      <th className="align-center">{formData.totalperformance_emp}</th>
                      <th className="align-center">{formData.totalperformance_rh}</th>
                      <th className="align-center">{formData.totalperformance_hod}</th>
                      <th className="align-center">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th colSpan={7} className="align-leftt">DISCIPLINE AND BEHAVIOUR</th>
                    </tr>
                    {[
                      { label: "Punctuality", name: "punctuality_admin", emp: "punctuality_emp", rh: "punctuality_rh", hod: "punctuality_hod", min: -5, max: 5 },
                      { label: "Teamwork", name: "teamwork_admin", emp: "teamwork_emp", rh: "teamwork_rh", hod: "teamwork_hod", min: -5, max: 5 },
                      { label: "Loyalty Towards Work", name: "loyalitytowardsWork_admin", emp: "loyalitytowardsWork_emp", rh: "loyalitytowardsWork_rh", hod: "loyalitytowardsWork_hod", min: -5, max: 5 },
                      { label: "Dedication Towards Work", name: "dedicationtowardsWork_admin", emp: "dedicationtowardsWork_emp", rh: "dedicationtowardsWork_rh", hod: "dedicationtowardsWork_hod", min: -5, max: 5 },
                      { label: "Obedient & Leadership", name: "obeideintorLeadership_admin", emp: "obeideintorLeadership_emp", rh: "obeideintorLeadership_rh", hod: "obeideintorLeadership_hod", min: -10, max: 10 }
                    ].map(({ label, name, emp, rh, hod, min, max }) => (
                      <tr key={name}>
                        <td className="text-center">{label}</td>
                        <td className="text-center">{max}</td>
                        <td className="text-center">{min}</td>
                        <td className="text-center">{formData[emp]}</td>
                        <td className="text-center">{formData[rh]}</td>
                        <td className="text-center">{formData[hod]}</td>
                        <td className="text-center">{formData[name]}</td>
                      </tr>
                    ))}
                    <tr>
                      <th className="align-center"></th>
                      <th className="align-center">30</th>
                      <th className="align-center">-30</th>
                      <th className="align-center">{formData.totaldecipline_emp}</th>
                      <th className="align-center">{formData.totaldecipline_rh}</th>
                      <th className="align-center">{formData.totaldecipline_hod}</th>
                      <th className="align-center">
                        {(
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                    <tr>
                      <th className="align-right">Total Rating Marks</th>
                      <th className="align-center">100</th>
                      <th className="align-center">-100</th>
                      <th className="align-center">{formData.total_emp}</th>
                      <th className="align-center">{formData.total_rh}</th>
                      <th className="align-center">{formData.total_hod}</th>
                      <th className="align-center">
                        {(
                          (parseFloat(formData.accuracy_admin) || 0) +
                          (parseFloat(formData.speedlyWork_admin) || 0) +
                          (parseFloat(formData.SelfInitiative_admin) || 0) +
                          (parseFloat(formData.responsbilityaccountability_admin) || 0) +
                          (parseFloat(formData.independentWorking_admin) || 0) +
                          (parseFloat(formData.decisonMakingCapability_admin) || 0) +
                          (parseFloat(formData.punctuality_admin) || 0) +
                          (parseFloat(formData.teamwork_admin) || 0) +
                          (parseFloat(formData.loyalitytowardsWork_admin) || 0) +
                          (parseFloat(formData.dedicationtowardsWork_admin) || 0) +
                          (parseFloat(formData.obeideintorLeadership_admin) || 0)
                        ).toFixed(1)}
                      </th>
                    </tr>
                  </React.Fragment>
                </tbody>
              </table>
            </div>

            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Close
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

//--------------------------------------------------------------------------not used

const ViewAppraisalDetailsbyQuickSetup = ({ i }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    // setFormData(i);
    getApplraisalFormListAdmin(i)
    getEmpList()
    // console.log('i-', i)
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  // const [ratingPeriod, setRatingPeriod] = useState(i.rating_period);
  const [selectedDepartment, setDepartment] = useState(`null`);
  const [selectedSubCompany, setSelectedSubCompany] = useState(
    // `${sessionStorage.getItem("company_id")}`
    i?.sub_company || null
  );

  const [timeStampView, setTimeStampView] = useState(false);
  const [applraisalFormList, setApplraisalFormList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const getApplraisalFormListAdmin = async (i) => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/appraisals/${i?.sub_company}/${selectedDepartment}/null/${employeeGet}/${i.id}/`
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setApplraisalFormList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const getEmpList = async () => {
    setBuffering1(true)
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/ /${active}/${selectedDepartment}/`);
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/${active}/${i?.sub_company}/`);
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);
    }
  };



  const tableRef = useRef(null);
  const handleDownloadAppraisalSheet = () => {
    downloadAsExcel(tableRef, "users",
      selectedDepartment === "" ? `AppraisalSheet` :
        `AppraisalSheet`);
  };


  return (
    <>
      <button title="View Appraisal Raitings" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title
            className="flex-row justify-between"
            style={{ width: '100%' }}
          >
            <>
              Appraisal Ratings
              {i.id !== "null" && ` "${formattedDateLong(i?.rating_period_start)} - ${formattedDateLong(i?.rating_period_end)}"`}
              {buffer1 ? <div className="spinner-vsmall"></div> : `(${applraisalFormList.length}/${employeeList.length})`}

            </>
            <div className="flex-row ">
              <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                Time Stamps {timeStampView ? "Shown" : "Hidden"} : {" "}
              </label>
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  id="toggle1"
                  checked={timeStampView}
                  onChange={() => setTimeStampView(!timeStampView)}
                />
                <label htmlFor="toggle1"></label>
              </div>
              <hr className="field-cont-hr" />
              <div className="btn-cont">
                <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
                  <DownloadIcon />
                </button>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

          <form className="register-form">

            <div className="scroll-container-table">

              <table ref={tableRef} className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">Sr.no</th>
                    <th className="align-center">Empolyee</th>
                    {i.id === "null" && <th className="align-center">Rating Period</th>}
                    <th className="align-center">Employee Self Rating</th>
                    {timeStampView ?
                      <th className="align-center">Employee TimeStamp</th>
                      : null
                    }
                    <th className="align-center">Reporting Head Rating</th>
                    <th className="align-center">Reporting Head Submission</th>
                    {timeStampView ?
                      <th className="align-center">Reporting Head TimeStamp</th>
                      : null
                    }
                    <th className="align-center">HOD Rating</th>
                    <th className="align-center">HOD Submission</th>
                    {timeStampView ?
                      <th className="align-center">HOD TimeStamp</th>
                      : null
                    }
                    <th className="align-center">Admin Rating</th>
                    <th className="align-center">Admin Submission</th>

                    {timeStampView ?
                      <th className="align-center">Admin TimeStamp</th>
                      : null
                    }
                    <th className="align-center">Final Rating</th>
                  </tr>
                </thead>
                {buffer ? (
                  <div className="spinner"></div>
                ) : (
                  <tbody>
                    {applraisalFormList.map((i, index) => (
                      <React.Fragment key={index}>
                        <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr>
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">
                            {i.profilepic &&
                              <>
                                <CustomImageModal customStyle>
                                  {i.profilepic ? (
                                    <img
                                      src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                      alt="profile" className="profile-img"
                                    />
                                  ) : (
                                    <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                  )}
                                </CustomImageModal>
                              </>
                            }
                            <p>{i.emp_code}-{i.name}</p>
                          </td>
                          {i.id === "null" && <td className="align-left">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                            <br />
                            {i.is_active === true || i.is_active === 'True' ?
                              <button className="priority-button color-tab-green">
                                Current
                              </button>
                              : null}
                          </td>}

                          <td className="align-center">
                            {i.emp_update_datetime ?
                              <>
                                {i.total_emp}
                              </>
                              : "-"
                            }
                          </td>

                          {timeStampView ?
                            <td className="align-center">
                              {i.emp_update_datetime ?
                                <>
                                  {i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : null}
                                </>
                                : "-"
                              }
                            </td>
                            : null
                          }
                          <td className="align-center">
                            {i.rh_update_datetime ?
                              <>
                                {i.total_rh}
                              </>
                              : "-"
                            }
                          </td>

                          <td className="align-center">
                            {i.rh_update_by ?
                              <>
                                {i.rh_update_by}
                              </>
                              : "-"
                            }
                          </td>
                          {timeStampView ?
                            <td className="align-center">
                              {i.rh_update_datetime ?
                                <>
                                  {i.rh_update_datetime ? formatDateTime(i.rh_update_datetime).full : null}
                                </>
                                : "-"
                              }
                            </td>
                            : null
                          }
                          <td className="align-center">
                            {i.hod_update_datetime ?
                              <>
                                {i.total_hod}
                              </>
                              : "-"
                            }
                          </td>

                          <td className="align-center">
                            {i.hod_update_by ?
                              <>
                                {i.hod_update_by}
                              </>
                              : "-"
                            }
                          </td>

                          {timeStampView ?
                            <td className="align-center">
                              {i.hod_update_datetime ?
                                <>
                                  {i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : null}
                                </>
                                : "-"
                              }
                            </td>
                            : null
                          }
                          <td className="align-center">
                            {i.admin_update_datetime ?
                              <>
                                {i.total_admin}
                              </>
                              : "-"
                            }
                          </td>

                          <td className="align-center">
                            {i.admin_update_by ?
                              <>
                                {i.admin_update_by}
                              </>
                              : "-"
                            }
                          </td>

                          {timeStampView ?
                            <td className="align-center">
                              {i.admin_update_datetime ?
                                <>
                                  {i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : null}
                                </>
                                : "-"
                              }
                            </td>
                            : null
                          }
                          <td className="align-center">
                            {i.final_rating || '-'}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                )}
              </table>
            </div>


            <div className="button-models">
              <button type="button" className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Close
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};


// ! ***************  Performance Heading Crud Models Start ***************


// const AddAppraisalType = ({ getAppraisalTypes, SUB_COMPANIES, SUPER_ADMIN }) => {
//   const [show, setShow] = useState(false)
//   const handleShow = () => {
//     setShow(true);
//   }

//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       other_name: "",
//       sub_company: sessionStorage.getItem('company_id'),
//     })
//   }

//   const initialData = {
//     sub_company: sessionStorage.getItem("company_id"),
//     code: "",
//     name: "",
//     description: "",
//     updated_by: sessionStorage.getItem('emp_code'),
//   }

//   const [formData, setFormData] = useState(initialData);
//   const [inputState, setInputState] = useState({});
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const validateForm = () => {
//     const newErrors = {};
//     let requiredFields = [
//       "sub_company",
//       "code",
//       "name",
//       "description",
//     ]

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     })

//     setErrors(newErrors);
//     setIsSubmitted(true);
//     return Object.keys(newErrors).length === 0;

//   };


//   const handleSubmitData = async (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please Wait....");

//       try {
//         const payload = {
//           ...formData,
//           code: formData.code
//             .trim()
//             .replace(/\s+/g, "-")
//             .toLowerCase()
//         };
//         let res = await axios.post(`${BASE_URL}/wfm/appraisal-dynamic-parametertype/`, payload);
//         if (res.status === 200 || res.status === 201) {
//           await getAppraisalTypes();
//           setShow(false);
//           setFormData(initialData);
//           toast.success("Appraisal Parameter Type Added Successfully!")
//         }
//       } catch (error) {
//         handleErrorToast(error, loadingToastId);
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   }

//   const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
//     value: i.id,
//     label: i.title
//   }))

//   const handleCompanyChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         sub_company: "",
//       })

//     } else {
//       setFormData({
//         ...formData,
//         sub_company: selectedOption.value,
//       })
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.sub_company;
//       return updatedErrors;
//     });

//   }

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     let newValue = value;

//     // if (name === "slip_category_code") {
//     //   newValue = newValue.trim().replace(/\s+/g, "-").toLowerCase()
//     // }
//     if (name === "name") {
//       const codeValue = value.trim().replace(/\s+/g, "-").toLowerCase();

//       setFormData({
//         ...formData,
//         name: value,
//         code: codeValue,
//       });
//     }
//     else {
//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });



//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[name];
//         return updatedErrors;
//       });
//     }
//   };

//   return (
//     <>
//       <button className='upload-svg' title='Add Slip Appraisal Parameter Type' onClick={handleShow}>
//         <AddwithWhiteCircle /> Parameter Type
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
//         <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
//           <Modal.Title>
//             Add Appraisal Parameter Type
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div>
//             <div>

//               <div className="flex-row mb-2 gap-2">
//                 <label
//                   htmlFor="code"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Code :
//                 </label>
//                 <span className="mt-1">{formData.code}</span>
//               </div>


//               {SUPER_ADMIN && <div className="flex-column">
//                 <div>
//                   <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
//                     Select Sub Company<span className="required">*</span>
//                   </label>
//                   <Select
//                     options={subcompanyOption}
//                     onChange={handleCompanyChange}
//                     value={subcompanyOption.find(option => option.value === formData.sub_company)}
//                     placeholder="Select SubCompany"
//                     isSearchable
//                     isClearable
//                     noOptionsMessage={() => "No other options"}
//                     styles={CSSForSelect}
//                   />
//                 </div>
//                 {errors.sub_company && (
//                   <div className="error-message font-size-text">{errors.sub_company}</div>

//                 )}
//               </div>}

//               {/* <div className="flex-column">
//                 <label
//                   htmlFor="code"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Code<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="code"
//                   name="code"
//                   maxLength={150}
//                   onChange={handleInputChange}
//                   value={formData.code}
//                   className={`form-input form-input-background  ${errors.code
//                     ? "error"
//                     : inputState.code
//                       ? "success"
//                       : ""
//                     }`
//                   }
//                 />
//                 {errors.code && (
//                   <span className="error-message font-size-text">
//                     {errors.code}
//                   </span>
//                 )}
//               </div> */}

//               <div className="flex-column">
//                 <label
//                   htmlFor="name"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Name<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   maxLength={150}
//                   onChange={handleInputChange}
//                   value={formData.name}
//                   className={`form-input form-input-background  ${errors.name
//                     ? "error"
//                     : inputState.name
//                       ? "success"
//                       : ""
//                     }`
//                   }
//                 />
//                 {errors.name && (
//                   <span className="error-message font-size-text">
//                     {errors.name}
//                   </span>
//                 )}
//               </div>

//               <div className="flex-column">
//                 <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                   Description<span className="required">*</span>
//                 </label>
//                 <textarea
//                   id="description"
//                   type="text"
//                   name="description"
//                   onChange={handleInputChange}
//                   value={formData.description}
//                   className={`form-input-textarea   font-weight400  font-size-subheading  ${errors.description
//                     ? "error"
//                     : inputState.description
//                       ? "success"
//                       : ""
//                     }
//                    `}
//                 />
//                 {errors.description && (
//                   <span className="error-message font-size-text ">{errors.description}</span>
//                 )}
//               </div>


//               <div className="button-models">
//                 <button
//                   type="button"
//                   className="model-button model-button-cancel font-weight500"
//                   onClick={handleClose}>
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="model-button model-button-leave font-weight500 font-size-heading"
//                   onClick={handleSubmitData}
//                   disabled={loading}
//                 >
//                   Submit
//                 </button>
//               </div>

//               <p className="error-message font-size-text">
//                 {isSubmitted && Object.keys(errors).length > 0 && (
//                   Object.keys(errors).length > 5 ? (
//                     <h5 className="text-center">Please fill all mandatory fields!</h5>
//                   ) : (
//                     <h6 className="text-center">
//                       {Object.keys(errors).map((field) =>
//                         field.charAt(0).toUpperCase() + field.slice(1)
//                       ).join(', ') + ' are required!'}
//                     </h6>
//                   )
//                 )}
//               </p>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//     </>
//   )

// }

// const UpdateAppraisalType = ({ i, getAppraisalTypes, SUB_COMPANIES, SUPER_ADMIN }) => {
//   const [show, setShow] = useState(false);

//   const handleShow = () => {
//     setShow(true);
//   }

//   const handleClose = () => {
//     setShow(false);
//   }

//   const [inputState, setInputState] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     sub_company: sessionStorage.getItem("company_id"),
//     code: "",
//     name: "",
//     description: "",
//     updated_by: sessionStorage.getItem('emp_code'),
//   });

//   useEffect(() => {
//     setFormData(i);
//   }, [i]);

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "sub_company",
//       "code",
//       "name",
//       "description",
//     ]

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     })

//     setErrors(newErrors);
//     setIsSubmitted(true);
//     return Object.keys(newErrors).length === 0;
//   };


//   const handleSubmitData = async (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       const loadingToastId = toast.loading("Loading: Please Wait....");
//       setLoading(true);
//       try {
//         const payload = {
//           ...formData,
//           code: formData.code
//             .trim()
//             .replace(/\s+/g, "-")
//             .toLowerCase()
//         };
//         let res = await axios.put(`${BASE_URL}/wfm/appraisal-dynamic-parametertype-update/${i.id}/`, payload);
//         if (res.status === 200) {
//           await getAppraisalTypes();
//           setShow(false);
//           toast.success('Appraisal Parameter Type Updated Successfully!')
//         }
//       } catch (error) {
//         handleErrorToast(error, loadingToastId);
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   }
//   const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
//     value: i.id,
//     label: i.title
//   }))

//   const handleCompanyChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         sub_company: "",
//       })

//     } else {
//       setFormData({
//         ...formData,
//         sub_company: selectedOption.value,
//       })
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.sub_company;
//       return updatedErrors;
//     });

//   }


//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     let newValue = value;

//     // if (name === "slip_category_code") {
//     //   newValue = newValue.trim().replace(/\s+/g, "-").toLowerCase()
//     // }

//     if (name === "name") {
//       const codeValue = value.trim().replace(/\s+/g, "-").toLowerCase();

//       setFormData({
//         ...formData,
//         name: value,
//         code: codeValue,
//       });
//     }
//     else {
//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });



//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[name];
//         return updatedErrors;
//       });
//     }
//   };

//   return (
//     <>
//       <button className='model-edit-button-ml' title='Update Slip Appraisal Parameter Type' onClick={handleShow}>
//         <UpdatePencil />
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
//         <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
//           <Modal.Title>
//             Update Appraisal Parameter Type
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div>
//             <div>
//               <div className="flex-row mb-2 gap-2">
//                 <label
//                   htmlFor="code"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Code :
//                 </label>
//                 <span className="mt-1">{formData.code}</span>
//               </div>
//               {SUPER_ADMIN && <div className="flex-column">
//                 <div>
//                   <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
//                     Select Sub Company<span className="required">*</span>
//                   </label>
//                   <Select
//                     options={subcompanyOption}
//                     onChange={handleCompanyChange}
//                     value={subcompanyOption.find(option => option.value === formData.sub_company)}
//                     placeholder="Select SubCompany"
//                     isSearchable
//                     isClearable
//                     noOptionsMessage={() => "No other options"}
//                     styles={CSSForSelect}
//                   />
//                 </div>
//                 {errors.sub_company && (
//                   <div className="error-message font-size-text">{errors.sub_company}</div>

//                 )}
//               </div>}

//               {/* <div className="flex-column">
//                 <label
//                   htmlFor="code"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Code<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="code"
//                   name="code"
//                   maxLength={150}
//                   onChange={handleInputChange}
//                   value={formData?.code}
//                   className={`form-input form-input-background  ${errors.code
//                     ? "error"
//                     : inputState.code
//                       ? "success"
//                       : ""
//                     }`
//                   }
//                 />
//                 {errors.code && (
//                   <span className="error-message font-size-text">
//                     {errors.code}
//                   </span>
//                 )}
//               </div> */}

//               <div className="flex-column">
//                 <label
//                   htmlFor="name"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Name<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   style={{ cursor: SUPER_ADMIN ? 'auto' : 'not-allowed' }}
//                   disabled={!SUPER_ADMIN}
//                   maxLength={150}
//                   onChange={handleInputChange}
//                   value={formData.name}
//                   className={`form-input form-input-background  ${errors.name
//                     ? "error"
//                     : inputState.name
//                       ? "success"
//                       : ""
//                     }`
//                   }
//                 />
//                 {errors.name && (
//                   <span className="error-message font-size-text">
//                     {errors.name}
//                   </span>
//                 )}
//               </div>

//               <div className="flex-column">
//                 <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                   Description<span className="required">*</span>
//                 </label>
//                 <textarea
//                   id="description"
//                   type="text"
//                   name="description"
//                   onChange={handleInputChange}
//                   value={formData.description}
//                   className={`form-input-textarea   font-weight400  font-size-subheading  ${errors.description
//                     ? "error"
//                     : inputState.description
//                       ? "success"
//                       : ""
//                     }
//                    `}
//                 />
//                 {errors.description && (
//                   <span className="error-message font-size-text ">{errors.description}</span>
//                 )}
//               </div>

//               <div className="button-models">
//                 <button
//                   type="button"
//                   className="model-button model-button-cancel font-weight500"
//                   onClick={handleClose}>
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="model-button model-button-leave font-weight500 font-size-heading"
//                   onClick={handleSubmitData}
//                   disabled={loading}
//                 >
//                   Update
//                 </button>
//               </div>

//               <p className="error-message font-size-text">
//                 {isSubmitted && Object.keys(errors).length > 0 && (
//                   Object.keys(errors).length > 5 ? (
//                     <h5 className="text-center">Please fill all mandatory fields!</h5>
//                   ) : (
//                     <h6 className="text-center">
//                       {Object.keys(errors).map((field) =>
//                         field.charAt(0).toUpperCase() + field.slice(1)
//                       ).join(', ') + ' are required!'}
//                     </h6>
//                   )
//                 )}
//               </p>
//             </div>
//           </div>
//         </Modal.Body>
//         <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       </Modal>
//     </>
//   )
// }

// const DeleteAppraisalType = ({ i, getAppraisalTypes }) => {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     setShow(true);
//   };
//   const [loading, setLoading] = useState(false);

//   const handleFormSubmitDelete = async (e) => {
//     e.preventDefault();
//     const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//     try {
//       let res = await axios.delete(
//         `${BASE_URL}/wfm/appraisal-dynamic-parametertype-update/${i?.id}/`
//       );

//       if (res.status === 200) {
//         await getAppraisalTypes();
//         setShow(false);
//         toast.success("Appraisal Parameter Type Deleted Successfully");
//       } else {
//         console.error(res);
//       }
//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       <button
//         title="Delete Slip Appraisal Parameter Type"
//         className="model-delete-button"
//         onClick={handleShow}
//       >
//         <DeleteDustbin />
//       </button>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="request-leave width-40vw"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Appraisal Parameter Type</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             Are You Sure You Want to delete the "{i?.name}" Appraisal Parameter Type
//             <div className="button-models">
//               <button
//                 className="model-button model-button-cancel font-weight500"
//                 onClick={handleClose}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleFormSubmitDelete}
//                 className="model-button model-button-delete font-weight500"
//                 disabled={loading}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>

//     </>
//   );
// };

const AddAppraisalType = ({ getAppraisalTypes, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false)
  const handleShow = () => setShow(true);

  const initialData = {
    sub_company: sessionStorage.getItem("company_id"),
    name: "",
    overall_marks: "",
    created_by: sessionStorage.getItem('emp_code'),
    updated_by: sessionStorage.getItem('emp_code'),
  }

  const handleClose = () => {
    setShow(false);
    setFormData(initialData);
    setErrors({});
    setIsSubmitted(false);
  }

  const [formData, setFormData] = useState(initialData);
  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    let requiredFields = ["sub_company", "name", "overall_marks"]

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    })

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please Wait....");

      try {
        const payload = {
          ...formData,
          overall_marks: Number(formData.overall_marks),
        };
        let res = await axios.post(`${BASE_URL}/wfm/appraisal-types/`, payload);
        if (res.status === 200 || res.status === 201) {
          await getAppraisalTypes();
          setShow(false);
          setFormData(initialData);
          toast.success("Appraisal Type Added Successfully!")
        }
      } catch (error) {
        handleErrorToast(error, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  }

  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    setFormData({
      ...formData,
      sub_company: selectedOption ? selectedOption.value : "",
    })
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    setInputState({
      ...inputState,
      [name]: value.toString().trim() ? "green" : "",
    });

    if (value.toString().trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  return (
    <>
      <button className='upload-svg' title='Add Appraisal Type' onClick={handleShow}>
        <AddwithWhiteCircle /> Appraisal Type
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
        <Modal.Header className='justify-center task-Tab-heading font-weight500 font-size-heading' closeButton>
          <Modal.Title>Add Appraisal Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>
                )}
              </div>}

              <div className="flex-column">
                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  maxLength={150}
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input form-input-background  ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                />
                {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
              </div>

              <div className="flex-column">
                <label htmlFor="overall_marks" className="form-labels font-weight500 font-size-subheading">
                  Overall Marks<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="overall_marks"
                  name="overall_marks"
                  min={0}
                  onChange={handleInputChange}
                  value={formData.overall_marks}
                  className={`form-input form-input-background  ${errors.overall_marks ? "error" : inputState.overall_marks ? "success" : ""}`}
                />
                {errors.overall_marks && <span className="error-message font-size-text">{errors.overall_marks}</span>}
              </div>

              <div className="button-models">
                <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  onClick={handleSubmitData}
                  disabled={loading}
                >
                  Submit
                </button>
              </div>

              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (
                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )
}

const UpdateAppraisalType = ({ i, getAppraisalTypes, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    sub_company: sessionStorage.getItem("company_id"),
    name: "",
    overall_marks: "",
    updated_by: sessionStorage.getItem('emp_code'),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["sub_company", "name", "overall_marks"]

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    })

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please Wait....");
      setLoading(true);
      try {
        const payload = {
          ...formData,
          updated_by: sessionStorage.getItem('emp_code'),
          overall_marks: Number(formData.overall_marks),
        };
        let res = await axios.put(`${BASE_URL}/wfm/appraisal-types-update/${i.id}/`, payload);
        if (res.status === 200) {
          await getAppraisalTypes();
          setShow(false);
          toast.success('Appraisal Type Updated Successfully!')
        }
      } catch (error) {
        handleErrorToast(error, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  }

  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    setFormData({
      ...formData,
      sub_company: selectedOption ? selectedOption.value : "",
    })
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    setInputState({
      ...inputState,
      [name]: value.toString().trim() ? "green" : "",
    });

    if (value.toString().trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  return (
    <>
      <button className='model-edit-button-ml' title='Update Appraisal Type' onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
        <Modal.Header className='justify-center task-Tab-heading font-weight500 font-size-heading' closeButton>
          <Modal.Title>Update Appraisal Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>
                )}
              </div>}

              <div className="flex-column">
                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  disabled={!SUPER_ADMIN}
                  style={{ cursor: SUPER_ADMIN ? 'auto' : 'not-allowed' }}
                  maxLength={150}
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input form-input-background  ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                />
                {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
              </div>

              <div className="flex-column">
                <label htmlFor="overall_marks" className="form-labels font-weight500 font-size-subheading">
                  Overall Marks<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="overall_marks"
                  name="overall_marks"
                  min={0}
                  onChange={handleInputChange}
                  value={formData.overall_marks}
                  className={`form-input form-input-background  ${errors.overall_marks ? "error" : inputState.overall_marks ? "success" : ""}`}
                />
                {errors.overall_marks && <span className="error-message font-size-text">{errors.overall_marks}</span>}
              </div>

              <div className="button-models">
                <button type="button" className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  onClick={handleSubmitData}
                  disabled={loading}
                >
                  Update
                </button>
              </div>

              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (
                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </Modal>
    </>
  )
}

const DeleteAppraisalType = ({ i, getAppraisalTypes }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/appraisal-types-update/${i?.id}/`);

      if (res.status === 200) {
        await getAppraisalTypes();
        setShow(false);
        toast.success("Appraisal Type Deleted Successfully");
      } else {
        console.error(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <button title="Delete Appraisal Type" className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Delete Appraisal Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete the "{i?.name}" Appraisal Type
            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button model-button-delete font-weight500"
                disabled={loading}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

// const AppraisalParameterHeadingAdd = ({ appraisalHeadings, getAppraisalHeadings, SUB_COMPANIES, SUPER_ADMIN }) => {
//   const [show, setShow] = useState(false);
//   const [buffer, setBuffering] = useState(false);
//   const [appraisalParameterView, setAppraisalParameterView] = useState(true);
//   const [appraisalParameterType, setAppraisalParameterType] = useState([]);

//   const handleClose = () => {
//     setFormData({
//       title: "",
//       sub_company: sessionStorage.getItem('company_id'),
//       sorting_var: "",
//       min_range: "",
//       max_range: "",
//       parameter_show_emp: true,
//       updated_by: sessionStorage.getItem('emp_code'),
//       category: "",
//     })
//     setShow(false)
//   };

//   const handleShow = () => {
//     setShow(true)
//     getAppraisalTypes();
//   };

//   const [formData, setFormData] = useState({
//     title: "",
//     sub_company: sessionStorage.getItem('company_id'),
//     sorting_var: "",
//     min_range: "",
//     max_range: "",
//     parameter_show_emp: true,
//     updated_by: sessionStorage.getItem('emp_code'),
//     category: "",
//   });
//   const [suggestion, setSuggestPosition] = useState("")

//   useEffect(() => {
//     const getNextSortingPosition = () => {
//       const maxSortingVar = Math.max(
//         ...appraisalHeadings?.map((heading) => Number(heading.sorting_var)),
//         1
//       );
//       setSuggestPosition(maxSortingVar + 1);
//     };

//     getNextSortingPosition();
//   }, [appraisalHeadings]);



//   // Validation
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});
//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "title",
//       "sorting_var",
//       "sub_company",
//       "min_range",
//       "max_range",
//       "category"
//     ];


//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
//     });

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };


//   const getAppraisalTypes = async () => {
//     try {
//       setBuffering(true);
//       const res = await axios.get(`${BASE_URL}/wfm/appraisal-dynamic-parametertype-by-subcompany/${formData.sub_company}/`);
//       setAppraisalParameterType(res.data);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setBuffering(false);
//     }
//   }





//   const [loading, setLoading] = useState(false); //loading logic
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const updatedFormData = {
//       ...formData,
//       // parameter_show_emp: appraisalParameterView,
//     };
//     if (validateForm()) {
//       const loadingToastId = toast.loading('Loading: Please wait...');
//       setLoading(true); //loading logic
//       try {
//         let res = await axios.post(`${BASE_URL}/wfm/appraisal-dynamic-parameterheading/`, updatedFormData);
//         if (res.status === 200 || res.status === 201) {
//           await getAppraisalHeadings();
//           handleClose()
//           toast.success("Appraisal Parameter Heading Added Successfully!");
//         }

//       } catch (err) {
//         handleErrorToast(err, loadingToastId)
//       } finally {
//         toast.dismiss(loadingToastId);
//         setLoading(false); //loading logic
//       }
//     }
//   };

//   return (
//     <>
//       <button className='upload-svg' title='Add Appraisal Parameter Heading' onClick={handleShow}>
//         <AddwithWhiteCircle /> Parameter Heading
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//         <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
//           <Modal.Title>Add Appraisal Parameter Heading</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             <div className="bdy-div">

//               <div className="flex-column">
//                 <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
//                   Title<span className="required">*</span>
//                 </label>
//                 <input
//                   maxLength={50}
//                   type="text"
//                   id="title"
//                   name="title"
//                   placeholder="Heading Name"
//                   onChange={handleInputChange}
//                   value={formData.title}
//                   className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
//                     }`}
//                 />
//                 {errors.title && (
//                   <span className="error-message font-size-text ">{errors.title}</span>
//                 )}
//               </div>

//               <div className="flex-column">
//                 <label htmlFor="sorting_var" className="form-labels font-weight500 font-size-subheading">
//                   Heading Sort Position (1 is Top)<span className="required">*</span>
//                 </label>
//                 <input
//                   id="sorting_var"
//                   name="sorting_var"
//                   type="number"
//                   min={1}
//                   maxLength={10}
//                   placeholder={`Heading Position (Suggestion: ${suggestion})`}
//                   onWheel={(e) => e.target.blur()}
//                   onChange={handleInputChange}
//                   value={formData.sorting_var}
//                   className={`form-input ${errors.sorting_var ? "error" : inputState.sorting_var ? "success" : ""
//                     }`}
//                 />
//                 {errors.sorting_var && (
//                   <span className="error-message font-size-text ">{errors.sorting_var}</span>
//                 )}
//               </div>

//               <div className="flex-row multi-day-input">
//                 <div className="flex-column multi-day">
//                   <label htmlFor="min_range" className="form-labels  font-weight500    font-size-subheading">
//                     Min Range Value<span className="required">*</span>
//                   </label>
//                   <input
//                     id="min_range"
//                     name="min_range"
//                     type="number"
//                     max={formData.max_range}
//                     placeholder="Min Range"
//                     onChange={handleInputChange}
//                     onWheel={(e) => e.target.blur()}
//                     value={formData.min_range}
//                     className={`multi-day-input1 form-input-background ${errors.min_range ? "error" : inputState.min_range ? "success" : ""
//                       }`}
//                   />
//                   <div>
//                     {errors.min_range && (
//                       <span className="error-message font-size-text ">{errors.min_range}</span>
//                     )}
//                   </div>
//                 </div>
//                 <div className="flex-column multi-day">
//                   <label htmlFor="max_range" className="form-labels  font-weight500    font-size-subheading">
//                     Max Range Value<span className="required">*</span>
//                   </label>
//                   <input
//                     id=""
//                     name="max_range"
//                     type="number"
//                     placeholder="Max Range"
//                     min={formData.min_range}
//                     onChange={handleInputChange}
//                     onWheel={(e) => e.target.blur()}
//                     value={formData.max_range}
//                     className={`multi-day-input1 form-input-background ${errors.max_range ? "error" : inputState.max_range ? "success" : ""
//                       }`}
//                   />
//                   <div>
//                     {errors.max_range && (
//                       <span className="error-message font-size-text ">{errors.max_range}</span>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* <div className="flex-column form-group-selectt">
//                 <label htmlFor="parameter_type " className="form-labels  font-weight500    font-size-subheading">
//                   Performance Type<span className="required">*</span>
//                 </label>
//                 <br />
//                 <select
//                   id="parameter_type"
//                   name="parameter_type"
//                   value={formData.parameter_type}
//                   onChange={handleInputChange}
//                   className={`form-input form-group-selection ${errors.parameter_type ? "error" : inputState.parameter_type ? "success" : ""
//                     }`}
//                 >
//                   <option value="">Select Parameter Type</option>
//                   <option value="performance">Performance</option>
//                   <option value="disclipline & behaviour">Disclipline & Behaviour</option>
//                 </select>
//                 <div className="form-group-selection-arrow">
//                   <DropdownArrowOption />
//                 </div>
//                 <div>
//                   {errors.parameter_type && (
//                     <span className="error-message font-size-text ">{errors.parameter_type}</span>
//                   )}
//                 </div>
//               </div> */}

//               <div className="flex-column form-group-selectt">
//                 <label htmlFor="category" className="form-labels  font-weight500    font-size-subheading">
//                   Performance Type<span className="required">*</span>
//                 </label>
//                 <br />
//                 <select
//                   id="category"
//                   name="category"
//                   value={formData.category}
//                   onChange={handleInputChange}
//                   className={`form-input form-group-selection ${errors.category ? "error" : inputState.category ? "success" : ""
//                     }`}
//                 >
//                   <option value="">Select Category</option>
//                   {appraisalParameterType
//                     .map((i, index) => (
//                       <option value={i.id}>
//                         {i.name}
//                       </option>
//                     ))}
//                 </select>
//                 <div className="form-group-selection-arrow">
//                   <DropdownArrowOption />
//                 </div>
//                 <div>
//                   {errors.category && (
//                     <span className="error-message font-size-text ">{errors.category}</span>
//                   )}
//                 </div>
//               </div>

//               {SUPER_ADMIN ?
//                 <div className="flex-column form-group-selectt">
//                   <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
//                     Sub Company<span className="required">*</span>
//                   </label>
//                   <br />
//                   <select
//                     id="sub_company"
//                     name="sub_company"
//                     value={formData.sub_company}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
//                       }`}
//                   >
//                     <option value="">Select Site Company  </option>
//                     {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
//                   </select>
//                   <div className="form-group-selection-arrow">
//                     <DropdownArrowOption />
//                   </div>
//                   <div>
//                     {errors.sub_company && (
//                       <span className="error-message font-size-text ">{errors.sub_company}</span>
//                     )}
//                   </div>
//                 </div>
//                 : null
//               }

//               <div className="flex-row ">
//                 <div className="checkbox-toggle">
//                   <input
//                     type="checkbox"
//                     id="parameterShowEmp"
//                     name="parameter_show_emp"
//                     // checked={appraisalParameterView}
//                     checked={formData.parameter_show_emp}
//                     onChange={handleInputChange}
//                   // onChange={() => setAppraisalParameterView(!appraisalParameterView)}
//                   />
//                   <label htmlFor="parameterShowEmp"></label>
//                 </div>
//                 <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
//                 <label htmlFor="parameterShowEmp" className="form-labels  font-weight500    font-size-subheading">
//                   {/* {appraisalParameterView ? "View" : "Hide"} for Employee {" "} */}
//                   {formData.parameter_show_emp ? "View" : "Hide"} for Employee {" "}
//                 </label>
//               </div>

//               <div className="button-models">
//                 <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
//                   Cancel
//                 </button>
//                 <button
//                   className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
//                   onClick={handleFormSubmit}
//                   disabled={loading}
//                 >
//                   Add
//                 </button>
//               </div>

//             </div>
//           </div>
//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const AppraisalParameterHeadingAdd = ({ appraisalHeadings, getAppraisalHeadings, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(false);
  const [appraisalParameterType, setAppraisalParameterType] = useState([]);
  const [rangeTypesList, setRangeTypesList] = useState([]);
  const [suggestion, setSuggestPosition] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  // Flattened state for easy input handling
  const [formData, setFormData] = useState({
    name: "",
    sub_company: sessionStorage.getItem('company_id') || "",
    sorting_order: "",
    range_type: "",
    // weightage: "",
    description: "",
    mandatory: true,
    appraisal_type: "",
  });

  const handleClose = () => {
    setFormData({
      name: "",
      sub_company: sessionStorage.getItem('company_id') || "",
      sorting_order: "",
      range_type: "",
      // weightage: "",
      description: "",
      mandatory: true,
      appraisal_type: "",
    });
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    // getAppraisalTypes();
  };

  useEffect(() => {
    const getNextSortingPosition = () => {
      // Assuming new headings list might use the new key "sorting_order-Appraisal"
      const maxSortingVar = Math.max(
        ...appraisalHeadings?.map((heading) => Number(heading['sorting_order-Appraisal'] || heading.sorting_var)) || [0],
        1
      );
      setSuggestPosition(maxSortingVar + 1);
    };

    if (appraisalHeadings) {
      getNextSortingPosition();
    }
  }, [appraisalHeadings]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "sorting_order",
      "range_type",
      // "weightage",
      "description",
      "appraisal_type"
    ];

    if (SUPER_ADMIN) requiredFields.push("sub_company");

    requiredFields.forEach((field) => {
      if (!formData[field] && formData[field] !== 0) {
        // Formatting field names nicely for the error message
        const formattedField = field.replace(/_/g, " ");
        newErrors[field] = `${formattedField.charAt(0).toUpperCase() + formattedField.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const getAppraisalTypes = async () => {
    // Prevent API call if sub_company is missing
    if (!formData.sub_company) return;

    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-types-by-subcompany/${formData.sub_company}/`);
      setAppraisalParameterType(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setBuffering(false);
    }
  };

  const getRangeTypes = async () => {
    if (!formData.sub_company) return;
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-rating-by-subcompany/${formData.sub_company}/`);
      setRangeTypesList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Only fetch if the modal is open and a sub_company is selected
    if (show && formData.sub_company) {
      getAppraisalTypes();
      getRangeTypes();
    }
  }, [formData.sub_company, show]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      // Reconstruct payload to match the requested nested structure
      const empCode = sessionStorage.getItem('emp_code');
      const payload = {
        name: formData.name.trim(),
        appraisal_type: formData.appraisal_type,
        sorting_order: String(formData.sorting_order),
        appraisal_rating: formData.range_type,
        data: {
          // weightage: Number(formData.weightage),
          description: formData.description.trim(),
          mandatory: formData.mandatory
        },
        created_by: empCode,
        updated_by: empCode
      };

      // Optional: Add sub_company to the payload if your backend still requires it
      if (SUPER_ADMIN) {
        payload.sub_company = formData.sub_company;
      }

      try {
        let res = await axios.post(`${BASE_URL}/wfm/appraisal-sub-details/`, payload);
        if (res.status === 200 || res.status === 201) {
          await getAppraisalHeadings();
          handleClose();
          toast.success("Appraisal Parameter Heading Added Successfully!");
        }
      } catch (err) {
        // Assuming handleErrorToast is a predefined function in your file
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className='upload-svg' title='Add Appraisal Parameter Heading' onClick={handleShow}>
        <AddwithWhiteCircle /> Parameter Heading
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Add Appraisal Parameter Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {SUPER_ADMIN && (
                <div className="flex-column form-group-selectt">
                  <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                    Sub Company<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                  >
                    <option value="">Select Site Company</option>
                    {SUB_COMPANIES.map((company, idx) => (
                      <option key={idx} value={company.id}>{company.title}</option>
                    ))}
                  </select>
                  {/* <div className="form-group-selection-arrow"><DropdownArrowOption /></div> */}
                  {errors.sub_company && <div><span className="error-message font-size-text">{errors.sub_company}</span></div>}
                </div>
              )}

              {/* Title -> Name */}
              <div className="flex-column">
                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                  Name<span className="required">*</span>
                </label>
                <input
                  maxLength={50}
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Heading Name (e.g., Accuracy)"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                />
                {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
              </div>

              {/* Sorting Var -> sorting_order */}
              <div className="flex-column">
                <label htmlFor="sorting_order" className="form-labels font-weight500 font-size-subheading">
                  Heading Sort Position (1 is Top)<span className="required">*</span>
                </label>
                <input
                  id="sorting_order"
                  name="sorting_order"
                  type="number"
                  min={1}
                  maxLength={10}
                  placeholder={`Heading Position (Suggestion: ${suggestion})`}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.sorting_order}
                  className={`form-input ${errors.sorting_order ? "error" : inputState.sorting_order ? "success" : ""}`}
                />
                {errors.sorting_order && <span className="error-message font-size-text">{errors.sorting_order}</span>}
              </div>

              {/* Dynamic Range Type Selection */}
              <div className="flex-column form-group-selectt">
                <label htmlFor="range_type" className="form-labels font-weight500 font-size-subheading">
                  Range Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="range_type"
                  name="range_type"
                  value={formData.range_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.range_type ? "error" : inputState.range_type ? "success" : ""}`}
                >
                  <option value="">Select Range</option>
                  {rangeTypesList.map((rt) => (
                    <option key={rt.id} value={rt.id}>
                      Out of {rt.out_of}
                    </option>
                  ))}
                </select>
                {errors.range_type && <div><span className="error-message font-size-text">{errors.range_type}</span></div>}
              </div>

              {/* Weightage */}
              {/* <div className="flex-column">
                <label htmlFor="weightage" className="form-labels font-weight500 font-size-subheading">
                  Weightage (%)<span className="required">*</span>
                </label>
                <input
                  id="weightage"
                  name="weightage"
                  type="number"
                  min={0}
                  max={100}
                  placeholder="e.g., 20"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.weightage}
                  className={`form-input ${errors.weightage ? "error" : inputState.weightage ? "success" : ""}`}
                />
                {errors.weightage && <span className="error-message font-size-text">{errors.weightage}</span>}
              </div> */}

              {/* Description */}
              <div className="flex-column">
                <label htmlFor="description" className="form-labels font-weight500 font-size-subheading">
                  Description<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="description"
                  name="description"
                  placeholder="e.g., Coding quality"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input ${errors.description ? "error" : inputState.description ? "success" : ""}`}
                />
                {errors.description && <span className="error-message font-size-text">{errors.description}</span>}
              </div>

              {/* Category -> appraisal_type */}
              <div className="flex-column form-group-selectt">
                <label htmlFor="appraisal_type" className="form-labels font-weight500 font-size-subheading">
                  Appraisal Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="appraisal_type"
                  name="appraisal_type"
                  value={formData.appraisal_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.appraisal_type ? "error" : inputState.appraisal_type ? "success" : ""}`}
                >
                  <option value="">Select Type</option>
                  {appraisalParameterType.map((i, index) => (
                    <option key={index} value={i.id}>
                      {i.name}
                    </option>
                  ))}
                </select>
                {/* <div className="form-group-selection-arrow"><DropdownArrowOption /></div> */}
                {errors.appraisal_type && <div><span className="error-message font-size-text">{errors.appraisal_type}</span></div>}
              </div>



              {/* parameter_show_emp -> mandatory */}
              <div className="flex-row">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="mandatory"
                    name="mandatory"
                    checked={formData.mandatory}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="mandatory"></label>
                </div>
                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                <label htmlFor="mandatory" className="form-labels font-weight500 font-size-subheading">
                  {formData.mandatory ? "Mandatory" : "Optional"} for Employee
                </label>
              </div>

              <div className="button-models">
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

// const AppraisalParameterHeadingUpdate = ({ i, appraisalHeadings, getAppraisalHeadings, SUB_COMPANIES, SUPER_ADMIN }) => {
//   const [show, setShow] = useState(false);
//   const [appraisalParameterView, setAppraisalParameterView] = useState(i.parameter_show_emp || false);
//   const [appraisalParameterType, setAppraisalParameterType] = useState([]);
//   const [buffer, setBuffering] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     setFormData(i);
//     setShow(true);
//     getAppraisalTypes();
//   };

//   const [formData, setFormData] = useState({
//     title: "",
//     sub_company: sessionStorage.getItem('company_id'),
//     sorting_var: "",
//     min_range: "",
//     max_range: "",
//     parameter_show_emp: true,
//     updated_by: sessionStorage.getItem('emp_code'),
//     category: "",
//   });

//   const [suggestion, setSuggestPosition] = useState("")

//   useEffect(() => {
//     const getNextSortingPosition = () => {
//       const maxSortingVar = Math.max(
//         ...appraisalHeadings.map((heading) => Number(heading.sorting_var)),
//         1
//       );
//       setSuggestPosition(maxSortingVar + 1);
//     };

//     getNextSortingPosition();
//   }, [appraisalHeadings]);

//   // Validation
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});
//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "title",
//       "sorting_var",
//       "sub_company",
//       "min_range",
//       "max_range",
//       "category",
//     ];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
//     });

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };


//   const getAppraisalTypes = async () => {
//     try {
//       setBuffering(true);
//       const res = await axios.get(`${BASE_URL}/wfm/appraisal-dynamic-parametertype-by-subcompany/${formData.sub_company}/`);
//       setAppraisalParameterType(res.data);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setBuffering(false);
//     }
//   }




//   const [loading, setLoading] = useState(false); //loading logic
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const updatedFormData = {
//       ...formData,
//       // parameter_show_emp: appraisalParameterView,
//     };
//     if (validateForm()) {
//       const loadingToastId = toast.loading('Loading: Please wait...');
//       setLoading(true); //loading logic
//       try {
//         let res = await axios.put(`${BASE_URL}/wfm/appraisal-dynamic-parameterheading-update/${i.id}/`, updatedFormData);
//         if (res.status === 200) {
//           await getAppraisalHeadings();
//           setShow(false);
//           toast.success('Appraisal Parameter Heading Updated Successfully!')
//         }

//       } catch (err) {
//         handleAllError(err, loadingToastId)
//       } finally {
//         toast.dismiss(loadingToastId);
//         setLoading(false); //loading logic
//       }
//     }
//   };

//   return (
//     <>
//       <button className="model-edit-button-ml" title="Update Appraisal Parameter Heading" onClick={handleShow}>
//         <UpdatePencil />
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//         <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
//           <Modal.Title>Update Appraisal Parameter Heading</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             <div className="bdy-div">

//               <div className="flex-column">
//                 <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
//                   Title<span className="required">*</span>
//                 </label>
//                 <input
//                   maxLength={50}
//                   type="text"
//                   id="title"
//                   name="title"
//                   placeholder="Heading Name"
//                   onChange={handleInputChange}
//                   value={formData.title}
//                   className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
//                     }`}
//                 />
//                 {errors.title && (
//                   <span className="error-message font-size-text ">{errors.title}</span>
//                 )}
//               </div>

//               <div className="flex-column">
//                 <label htmlFor="sorting_var" className="form-labels font-weight500 font-size-subheading">
//                   Heading Sort Position (1 is Top)<span className="required">*</span>
//                 </label>
//                 <input
//                   id="sorting_var"
//                   name="sorting_var"
//                   type="number"
//                   min={1}
//                   maxLength={10}
//                   placeholder={`Heading Position (Suggestion: ${suggestion})`}
//                   onWheel={(e) => e.target.blur()}
//                   onChange={handleInputChange}
//                   value={formData.sorting_var}
//                   className={`form-input ${errors.sorting_var ? "error" : inputState.sorting_var ? "success" : ""
//                     }`}
//                 />
//                 {errors.sorting_var && (
//                   <span className="error-message font-size-text ">{errors.sorting_var}</span>
//                 )}
//               </div>

//               <div className="flex-row multi-day-input">
//                 <div className="flex-column multi-day">
//                   <label htmlFor="min_range" className="form-labels  font-weight500    font-size-subheading">
//                     Min Range Value<span className="required">*</span>
//                   </label>
//                   <input
//                     id="min_range"
//                     name="min_range"
//                     type="number"
//                     max={formData.max_range}
//                     placeholder="Min Range"
//                     onChange={handleInputChange}
//                     onWheel={(e) => e.target.blur()}
//                     value={formData.min_range}
//                     className={`multi-day-input1 form-input-background ${errors.min_range ? "error" : inputState.min_range ? "success" : ""
//                       }`}
//                   />
//                   <div>
//                     {errors.min_range && (
//                       <span className="error-message font-size-text ">{errors.min_range}</span>
//                     )}
//                   </div>
//                 </div>
//                 <div className="flex-column multi-day">
//                   <label htmlFor="max_range" className="form-labels  font-weight500    font-size-subheading">
//                     Max Range Value<span className="required">*</span>
//                   </label>
//                   <input
//                     id=""
//                     name="max_range"
//                     type="number"
//                     placeholder="Max Range"
//                     min={formData.min_range}
//                     onChange={handleInputChange}
//                     onWheel={(e) => e.target.blur()}
//                     value={formData.max_range}
//                     className={`multi-day-input1 form-input-background ${errors.max_range ? "error" : inputState.max_range ? "success" : ""
//                       }`}
//                   />
//                   <div>
//                     {errors.max_range && (
//                       <span className="error-message font-size-text ">{errors.max_range}</span>
//                     )}
//                   </div>
//                 </div>
//               </div>




//               <div className="flex-column form-group-selectt">
//                 <label htmlFor="category" className="form-labels  font-weight500    font-size-subheading">
//                   Performance Type<span className="required">*</span>
//                 </label>
//                 <br />
//                 <select
//                   id="category"
//                   name="category"
//                   value={formData.category}
//                   onChange={handleInputChange}
//                   className={`form-input form-group-selection ${errors.category ? "error" : inputState.category ? "success" : ""
//                     }`}
//                 >
//                   <option value="">Select Category</option>
//                   {appraisalParameterType
//                     .map((i, index) => (
//                       <option value={i.id}>
//                         {i.name}
//                       </option>
//                     ))}
//                 </select>
//                 <div className="form-group-selection-arrow">
//                   <DropdownArrowOption />
//                 </div>
//                 <div>
//                   {errors.category && (
//                     <span className="error-message font-size-text ">{errors.category}</span>
//                   )}
//                 </div>
//               </div>


//               {SUPER_ADMIN ?
//                 <div className="flex-column form-group-selectt">
//                   <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
//                     Sub Company<span className="required">*</span>
//                   </label>
//                   <br />
//                   <select
//                     id="sub_company"
//                     name="sub_company"
//                     value={formData.sub_company}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
//                       }`}
//                   >
//                     <option value="">Select Site Company  </option>
//                     {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
//                   </select>
//                   <div className="form-group-selection-arrow">
//                     <DropdownArrowOption />
//                   </div>
//                   <div>
//                     {errors.parameter_type && (
//                       <span className="error-message font-size-text ">{errors.parameter_type}</span>
//                     )}
//                   </div>
//                 </div>
//                 : null
//               }

//               <div className="flex-row ">
//                 <div className="checkbox-toggle">
//                   <input
//                     type="checkbox"
//                     id="parameterShowEmp"
//                     name="parameter_show_emp"
//                     checked={formData.parameter_show_emp}
//                     onChange={handleInputChange}
//                   // type="checkbox"
//                   // id="parameter_show_emp"
//                   // checked={appraisalParameterView}
//                   // onChange={() => setAppraisalParameterView(!appraisalParameterView)}
//                   />
//                   <label htmlFor="parameterShowEmp"></label>
//                 </div>
//                 <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
//                 <label htmlFor="parameterShowEmp" className="form-labels  font-weight500    font-size-subheading">
//                   {/* {appraisalParameterView ? "View" : "Hide"} for Employee {" "} */}
//                   {formData.parameter_show_emp ? "View" : "Hide"} for Employee {" "}
//                 </label>
//               </div>

//               <div className="button-models">
//                 <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
//                   Cancel
//                 </button>
//                 <button
//                   className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
//                   onClick={handleFormSubmit}
//                   disabled={loading}
//                 >
//                   Update
//                 </button>
//               </div>

//             </div>
//           </div>
//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const AppraisalParameterHeadingUpdate = ({ i, appraisalHeadings, getAppraisalHeadings, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);
  const [appraisalParameterType, setAppraisalParameterType] = useState([]);
  const [rangeTypesList, setRangeTypesList] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [suggestion, setSuggestPosition] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  // Flattened state to match the Add component's structure
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    sub_company: sessionStorage.getItem("company_id"),
    sorting_order: "",
    range_type: "",
    // weightage: "",
    description: "",
    mandatory: true,
    appraisal_type: "",
    updated_by: sessionStorage.getItem('emp_code'),
  });

  const handleClose = () => {
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const handleShow = () => {
    // Map the incoming nested item `i` into our flattened state structure
    setFormData({
      id: i.id,
      name: i.name || "",
      sub_company: i.sub_company || sessionStorage.getItem('company_id') || "",
      sorting_order: i.sorting_order || "",
      range_type: i.appraisal_rating || "",
      // weightage: i.data?.weightage || "",
      description: i.data?.description || "",
      mandatory: i.data?.mandatory !== undefined ? i.data.mandatory : true,
      appraisal_type: i.appraisal_type || "",
    });
    setShow(true);
  };

  useEffect(() => {
    const getNextSortingPosition = () => {
      const maxSortingVar = Math.max(
        ...appraisalHeadings?.map((heading) => Number(heading['sorting_order-Appraisal'] || heading.sorting_var)) || [0],
        1
      );
      setSuggestPosition(maxSortingVar + 1);
    };

    if (appraisalHeadings) {
      getNextSortingPosition();
    }
  }, [appraisalHeadings]);

  // Trigger getAppraisalTypes when modal is open and sub_company changes
  useEffect(() => {
    if (show && formData.sub_company) {
      getAppraisalTypes();
      getRangeTypes();
    }
  }, [formData.sub_company, show]);

  useEffect(() => {
    setFormData(i);
  }, [i]);

  const getAppraisalTypes = async () => {
    if (!formData.sub_company) return;

    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-types-by-subcompany/${formData.sub_company}/`);
      setAppraisalParameterType(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setBuffering(false);
    }
  };

  const getRangeTypes = async () => {
    if (!formData.sub_company) return;
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-rating-by-subcompany/${formData.sub_company}/`);
      setRangeTypesList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "sorting_order",
      "range_type",
      // "weightage",
      "description",
      "appraisal_type"
    ];

    if (SUPER_ADMIN) requiredFields.push("sub_company");

    requiredFields.forEach((field) => {
      if (!formData[field] && formData[field] !== 0) {
        const formattedField = field.replace(/_/g, " ");
        newErrors[field] = `${formattedField.charAt(0).toUpperCase() + formattedField.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    setFormData({
      ...formData,
      sub_company: selectedOption ? selectedOption.value : "",
    })
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      // Reconstruct payload back into the nested structure for the update request
      const empCode = sessionStorage.getItem('emp_code');
      const payload = {
        name: formData.name.trim(),
        appraisal_type: formData.appraisal_type,
        sorting_order: String(formData.sorting_order),
        appraisal_rating: formData.range_type,
        data: {
          // weightage: Number(formData.weightage),
          description: formData.description.trim(),
          mandatory: formData.mandatory
        },
        updated_by: empCode
      };

      if (SUPER_ADMIN) {
        payload.sub_company = formData.sub_company;
      }

      try {
        let res = await axios.put(`${BASE_URL}/wfm/appraisal-sub-details-update/${formData.id}/`, payload);
        if (res.status === 200) {
          await getAppraisalHeadings();
          setShow(false);
          toast.success('Appraisal Parameter Heading Updated Successfully!');
        }
      } catch (err) {
        // Assuming handleAllError is imported
        handleAllError(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" title="Update Appraisal Parameter Heading" onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Update Appraisal Parameter Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">


              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>
                )}
              </div>}

              {/* Name */}
              <div className="flex-column">
                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                  Name<span className="required">*</span>
                </label>
                <input
                  maxLength={50}
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Heading Name (e.g., Accuracy)"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                />
                {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
              </div>

              {/* Sorting Position */}
              <div className="flex-column">
                <label htmlFor="sorting_order" className="form-labels font-weight500 font-size-subheading">
                  Heading Sort Position (1 is Top)<span className="required">*</span>
                </label>
                <input
                  id="sorting_order"
                  name="sorting_order"
                  type="number"
                  min={1}
                  maxLength={10}
                  placeholder={`Heading Position (Suggestion: ${suggestion})`}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.sorting_order}
                  className={`form-input ${errors.sorting_order ? "error" : inputState.sorting_order ? "success" : ""}`}
                />
                {errors.sorting_order && <span className="error-message font-size-text">{errors.sorting_order}</span>}
              </div>

              {/* Dynamic Range Type Selection */}
              <div className="flex-column form-group-selectt">
                <label htmlFor="range_type" className="form-labels font-weight500 font-size-subheading">
                  Range Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="range_type"
                  name="range_type"
                  value={formData.range_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.range_type ? "error" : inputState.range_type ? "success" : ""}`}
                >
                  <option value="">Select Range</option>
                  {rangeTypesList.map((rt) => (
                    <option key={rt.id} value={rt.id}>
                      Out of {rt.out_of}
                    </option>
                  ))}
                </select>
                {errors.range_type && <div><span className="error-message font-size-text">{errors.range_type}</span></div>}
              </div>

              {/* Weightage */}
              {/* <div className="flex-column">
                <label htmlFor="weightage" className="form-labels font-weight500 font-size-subheading">
                  Weightage (%)<span className="required">*</span>
                </label>
                <input
                  id="weightage"
                  name="weightage"
                  type="number"
                  min={0}
                  max={100}
                  placeholder="e.g., 20"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.weightage}
                  className={`form-input ${errors.weightage ? "error" : inputState.weightage ? "success" : ""}`}
                />
                {errors.weightage && <span className="error-message font-size-text">{errors.weightage}</span>}
              </div> */}

              {/* Description */}
              <div className="flex-column">
                <label htmlFor="description" className="form-labels font-weight500 font-size-subheading">
                  Description<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="description"
                  name="description"
                  placeholder="e.g., Coding quality"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input ${errors.description ? "error" : inputState.description ? "success" : ""}`}
                />
                {errors.description && <span className="error-message font-size-text">{errors.description}</span>}
              </div>

              {/* Appraisal Type */}
              <div className="flex-column form-group-selectt">
                <label htmlFor="appraisal_type" className="form-labels font-weight500 font-size-subheading">
                  Appraisal Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="appraisal_type"
                  name="appraisal_type"
                  value={formData.appraisal_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.appraisal_type ? "error" : inputState.appraisal_type ? "success" : ""}`}
                >
                  <option value="">Select Type</option>
                  {appraisalParameterType.map((typeObj, index) => (
                    <option key={index} value={typeObj.id}>
                      {typeObj.name}
                    </option>
                  ))}
                </select>
                {/* <div className="form-group-selection-arrow"><DropdownArrowOption /></div> */}
                {errors.appraisal_type && <div><span className="error-message font-size-text">{errors.appraisal_type}</span></div>}
              </div>


              {/* Mandatory Checkbox */}
              <div className="flex-row">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="mandatory"
                    name="mandatory"
                    checked={formData.mandatory}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="mandatory"></label>
                </div>
                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                <label htmlFor="mandatory" className="form-labels font-weight500 font-size-subheading">
                  {formData.mandatory ? "Mandatory" : "Optional"} for Employee
                </label>
              </div>

              <div className="button-models">
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Update
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

// const AppraisalParameterHeadingDelete = ({ i, getAppraisalHeadings }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const handleFormSubmitDelete = async (e) => {
//     e.preventDefault();
//     const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//     try {
//       let res = await axios.delete(`${BASE_URL}/wfm/appraisal-dynamic-parameterheading-update/${i.id}/`);

//       if (res.status === 200) {
//         await getAppraisalHeadings();
//         setShow(false);
//         toast.success("Appraisal Parameter Heading Deleted Successfully");
//       } else {
//         console.error(res);
//       }
//     } catch (err) {
//       handleErrorToast(err, loadingToastId)
//     } finally {
//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     }
//   };

//   return (
//     <>
//       <button className="model-delete-button" title="Delete Appraisal Parameter Heading" onClick={handleShow}>
//         <DeleteDustbin />
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Appraisal Parameter Heading: {i.title}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             Are You Sure You Want to Delete Appraisal Parameter Heading: "{i.title}"
//             <div className="button-models">
//               <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
//                 Cancel
//               </button>
//               <button
//                 onClick={handleFormSubmitDelete}
//                 disabled={loading}
//                 className="model-button   font-weight500    model-button-delete"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


const AppraisalParameterHeadingDelete = ({ i, getAppraisalHeadings }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/appraisal-sub-details-update/${i.id}/`);

      if (res.status === 200) {
        await getAppraisalHeadings();
        setShow(false);
        toast.success("Appraisal Parameter Heading Deleted Successfully");
      } else {
        console.error(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" title="Delete Appraisal Parameter Heading" onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Delete Appraisal Parameter Heading: {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Appraisal Parameter Heading: "{i.title}"
            <div className="button-models">
              <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                disabled={loading}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const AddRangeType = ({ getRangeTypes, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const initialStep = { min: "", max: "", label: "" };

  const [formData, setFormData] = useState({
    out_of: "",
    sub_company: sessionStorage.getItem('company_id') || "",
    steps: [{ ...initialStep }]
  });

  const handleClose = () => {
    setFormData({
      out_of: "",
      sub_company: sessionStorage.getItem('company_id') || "",
      steps: [{ ...initialStep }]
    });
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const handleShow = () => setShow(true);

  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (formData.out_of === "") newErrors.out_of = "Out Of (Total Rating) is required!";
    if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";

    formData.steps.forEach((step, index) => {
      if (step.min === "" || step.max === "" || !step.label.trim()) {
        newErrors[`step_${index}`] = "All step fields (Min, Max, Label) are required!";
      } else if (Number(step.min) >= Number(step.max)) {
        newErrors[`step_${index}`] = "Max must be greater than Min!";
      }
    });

    // Check for duplicate labels
    const labels = formData.steps.map(s => s.label.trim().toLowerCase());
    if (new Set(labels).size !== labels.length) {
      newErrors.general = "Step labels must be unique!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Dynamic Steps Handlers
  const handleStepChange = (index, e) => {
    const { name, value } = e.target;
    const updatedSteps = [...formData.steps];
    updatedSteps[index][name] = value;
    setFormData({ ...formData, steps: updatedSteps });
  };

  const addStep = () => {
    setFormData({
      ...formData,
      steps: [...formData.steps, { ...initialStep }]
    });
  };

  const removeStep = (index) => {
    const updatedSteps = formData.steps.filter((_, i) => i !== index);
    setFormData({ ...formData, steps: updatedSteps });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      // Build the 'data' object dynamically based on the steps
      const dataObj = {};
      formData.steps.forEach(step => {
        dataObj[step.label.trim()] = {
          min: Number(step.min),
          max: Number(step.max)
        };
      });
      dataObj.totalRating = Number(formData.out_of);

      const empCode = sessionStorage.getItem('emp_code');

      const payload = {
        sub_company: formData.sub_company,
        data: dataObj,
        out_of: formData.out_of.toString(),
        created_by: empCode,
        updated_by: empCode
      };

      try {
        let res = await axios.post(`${BASE_URL}/wfm/appraisal-rating/`, payload);
        if (res.status === 200 || res.status === 201) {
          if (getRangeTypes) await getRangeTypes();
          handleClose();
          toast.success("Range Type Added Successfully!");
        }
      } catch (err) {
        // handleErrorToast(err, loadingToastId);
        toast.error("Failed to add Range Type");
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className='upload-svg' title='Add Range Type' onClick={handleShow}>
        <AddwithWhiteCircle /> Add Range Type
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Add Range Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {errors.general && (
                <div style={{ color: '#dc3545', marginBottom: '15px', fontWeight: '500' }}>
                  {errors.general}
                </div>
              )}

              {/* Top Row: Out Of & Sub Company */}
              <div className="flex-row" style={{ gap: '20px', width: '100%', flexWrap: 'nowrap' }}>

                {SUPER_ADMIN && (
                  <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                    <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                      Sub Company<span className="required">*</span>
                    </label>
                    <select
                      id="sub_company"
                      name="sub_company"
                      value={formData.sub_company}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection form-input-background ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                      style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                    >
                      <option value="">Select Site Company</option>
                      {SUB_COMPANIES?.map((company, idx) => (
                        <option key={idx} value={company.id}>{company.title}</option>
                      ))}
                    </select>
                    {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                  </div>
                )}

                <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                  <label htmlFor="out_of" className="form-labels font-weight500 font-size-subheading">
                    Out Of (Total Rating)<span className="required">*</span>
                  </label>
                  <input
                    id="out_of"
                    name="out_of"
                    type="number"
                    placeholder="e.g., 5, 10"
                    onChange={handleInputChange}
                    onWheel={(e) => e.target.blur()}
                    value={formData.out_of}
                    className={`form-input form-input-background ${errors.out_of ? "error" : inputState.out_of ? "success" : ""}`}
                    style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                  />
                  {errors.out_of && <span className="error-message font-size-text">{errors.out_of}</span>}
                </div>


              </div>

              <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

              {/* Dynamic Steps Section */}
              <div className="flex-column">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
                    Range Configuration
                  </label>
                  <button type="button" onClick={addStep} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
                    + Add Step
                  </button>
                </div>

                {formData.steps.map((step, index) => (
                  <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>

                    <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

                      <div className="flex-column" style={{ flex: 2, minWidth: 0 }}>
                        <label className="form-labels font-weight500 font-size-text">Label</label>
                        <input
                          name="label"
                          type="text"
                          placeholder="e.g., Excellent"
                          value={step.label}
                          onChange={(e) => handleStepChange(index, e)}
                          className="form-input"
                          style={{ width: 'calc(100% - 22px)', margin: '8px 0 0 0' }}
                        />
                      </div>

                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        <label className="form-labels font-weight500 font-size-text">Min</label>
                        <input
                          name="min"
                          type="number"
                          placeholder="Min"
                          value={step.min}
                          onChange={(e) => handleStepChange(index, e)}
                          className="form-input"
                          style={{ width: 'calc(100% - 22px)', margin: '8px 0 0 0' }}
                        />
                      </div>

                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        <label className="form-labels font-weight500 font-size-text">Max</label>
                        <input
                          name="max"
                          type="number"
                          placeholder="Max"
                          value={step.max}
                          onChange={(e) => handleStepChange(index, e)}
                          className="form-input"
                          style={{ width: 'calc(100% - 22px)', margin: '8px 0 0 0' }}
                        />
                      </div>

                      {formData.steps.length > 1 && (
                        <div style={{ paddingTop: '28px', flexShrink: 0 }}>
                          <button
                            type="button"
                            onClick={() => removeStep(index)}
                            style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
                            title="Remove Step"
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>

                    {errors[`step_${index}`] && (
                      <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
                        {errors[`step_${index}`]}
                      </span>
                    )}

                  </div>
                ))}
              </div>

              {/* Submit Buttons */}
              <div className="button-models" style={{ marginTop: '20px' }}>
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Save Range
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const UpdateRangeType = ({ i, getRangeTypes, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const initialStep = { min: "", max: "", label: "" };

  const [formData, setFormData] = useState({
    id: "",
    out_of: "",
    sub_company: "",
    steps: [{ ...initialStep }]
  });

  const handleClose = () => {
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const handleShow = () => {
    // Reconstruct the steps array from the nested 'data' object
    const parsedSteps = [];
    let extractedTotal = "";

    if (i.data) {
      Object.keys(i.data).forEach(key => {
        if (key === 'totalRating') {
          extractedTotal = i.data[key];
        } else {
          parsedSteps.push({
            label: key,
            min: i.data[key].min ?? "",
            max: i.data[key].max ?? ""
          });
        }
      });
    }

    setFormData({
      id: i.id,
      out_of: i.out_of || extractedTotal?.toString() || "",
      sub_company: i.sub_company || sessionStorage.getItem('company_id') || "",
      steps: parsedSteps.length > 0 ? parsedSteps : [{ ...initialStep }]
    });
    setShow(true);
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};
    if (formData.out_of === "") newErrors.out_of = "Out Of (Total Rating) is required!";
    if (SUPER_ADMIN && !formData.sub_company) newErrors.sub_company = "Sub Company is required!";

    formData.steps.forEach((step, index) => {
      if (step.min === "" || step.max === "" || !step.label.trim()) {
        newErrors[`step_${index}`] = "All step fields (Min, Max, Label) are required!";
      } else if (Number(step.min) >= Number(step.max)) {
        newErrors[`step_${index}`] = "Max must be greater than Min!";
      }
    });

    // Check for duplicate labels
    const labels = formData.steps.map(s => s.label.trim().toLowerCase());
    if (new Set(labels).size !== labels.length) {
      newErrors.general = "Step labels must be unique!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Dynamic Steps Handlers
  const handleStepChange = (index, e) => {
    const { name, value } = e.target;
    const updatedSteps = [...formData.steps];
    updatedSteps[index][name] = value;
    setFormData({ ...formData, steps: updatedSteps });
  };

  const addStep = () => {
    setFormData({
      ...formData,
      steps: [...formData.steps, { ...initialStep }]
    });
  };

  const removeStep = (index) => {
    const updatedSteps = formData.steps.filter((_, i) => i !== index);
    setFormData({ ...formData, steps: updatedSteps });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true);

      // Build the 'data' object dynamically based on the steps
      const dataObj = {};
      formData.steps.forEach(step => {
        dataObj[step.label.trim()] = {
          min: Number(step.min),
          max: Number(step.max)
        };
      });
      dataObj.totalRating = Number(formData.out_of);

      const payload = {
        sub_company: formData.sub_company,
        data: dataObj,
        out_of: formData.out_of.toString(),
        updated_by: sessionStorage.getItem('emp_code'),
      };

      try {
        let res = await axios.put(`${BASE_URL}/wfm/appraisal-rating-update/${formData.id}/`, payload);
        if (res.status === 200) {
          if (getRangeTypes) await getRangeTypes();
          handleClose();
          toast.success("Rating Type Updated Successfully!");
        }
      } catch (err) {
        // handleAllError(err, loadingToastId);
        toast.error("Failed to update Range Type");
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" title="Update Range Type" onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Update Range Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              {errors.general && (
                <div style={{ color: '#dc3545', marginBottom: '15px', fontWeight: '500' }}>
                  {errors.general}
                </div>
              )}

              {/* Top Row: Out Of & Sub Company */}
              <div className="flex-row" style={{ gap: '20px', width: '100%', flexWrap: 'nowrap' }}>

                {SUPER_ADMIN && (
                  <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                    <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                      Sub Company<span className="required">*</span>
                    </label>
                    <select
                      id="sub_company"
                      name="sub_company"
                      value={formData.sub_company}
                      onChange={handleInputChange}
                      className={`form-input form-group-selection form-input-background ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                      style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                    >
                      <option value="">Select Site Company</option>
                      {SUB_COMPANIES?.map((company, idx) => (
                        <option key={idx} value={company.id}>{company.title}</option>
                      ))}
                    </select>
                    {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                  </div>
                )}

                <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                  <label htmlFor="out_of" className="form-labels font-weight500 font-size-subheading">
                    Out Of (Total Rating)<span className="required">*</span>
                  </label>
                  <input
                    id="out_of"
                    name="out_of"
                    type="number"
                    placeholder="e.g., 5, 10"
                    onChange={handleInputChange}
                    onWheel={(e) => e.target.blur()}
                    value={formData.out_of}
                    className={`form-input form-input-background ${errors.out_of ? "error" : inputState.out_of ? "success" : ""}`}
                    style={{ width: 'calc(100% - 22px)', margin: '8px 0' }}
                  />
                  {errors.out_of && <span className="error-message font-size-text">{errors.out_of}</span>}
                </div>


              </div>

              <hr className="field-cont-hr" style={{ margin: '15px 0', width: '100%', height: '1px' }} />

              {/* Dynamic Steps Section */}
              <div className="flex-column">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ margin: 0 }}>
                    Range Configuration
                  </label>
                  <button type="button" onClick={addStep} className="model-button font-weight500" style={{ padding: '5px 15px', fontSize: '12px' }}>
                    + Add Step
                  </button>
                </div>

                {formData.steps.map((step, index) => (
                  <div key={index} className="flex-column" style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>

                    <div className="flex-row" style={{ gap: '15px', alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>

                      <div className="flex-column" style={{ flex: 2, minWidth: 0 }}>
                        <label className="form-labels font-weight500 font-size-text">Label</label>
                        <input
                          name="label"
                          type="text"
                          placeholder="e.g., Excellent"
                          value={step.label}
                          onChange={(e) => handleStepChange(index, e)}
                          className="form-input"
                          style={{ width: 'calc(100% - 22px)', margin: '8px 0 0 0' }}
                        />
                      </div>

                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        <label className="form-labels font-weight500 font-size-text">Min</label>
                        <input
                          name="min"
                          type="number"
                          placeholder="Min"
                          value={step.min}
                          onChange={(e) => handleStepChange(index, e)}
                          className="form-input"
                          style={{ width: 'calc(100% - 22px)', margin: '8px 0 0 0' }}
                        />
                      </div>

                      <div className="flex-column" style={{ flex: 1, minWidth: 0 }}>
                        <label className="form-labels font-weight500 font-size-text">Max</label>
                        <input
                          name="max"
                          type="number"
                          placeholder="Max"
                          value={step.max}
                          onChange={(e) => handleStepChange(index, e)}
                          className="form-input"
                          style={{ width: 'calc(100% - 22px)', margin: '8px 0 0 0' }}
                        />
                      </div>

                      {formData.steps.length > 1 && (
                        <div style={{ paddingTop: '28px', flexShrink: 0 }}>
                          <button
                            type="button"
                            onClick={() => removeStep(index)}
                            style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '22px', fontWeight: 'bold', lineHeight: 1 }}
                            title="Remove Step"
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>

                    {errors[`step_${index}`] && (
                      <span className="error-message font-size-text" style={{ display: 'block', marginTop: '8px' }}>
                        {errors[`step_${index}`]}
                      </span>
                    )}

                  </div>
                ))}
              </div>

              {/* Submit Buttons */}
              <div className="button-models" style={{ marginTop: '20px' }}>
                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button font-weight500 model-button-leave font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Update Range
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const DeleteRangeType = ({ i, getRangeTypes }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading('Deleting: Please wait...');
    setLoading(true);

    try {
      let res = await axios.delete(`${BASE_URL}/wfm/appraisal-rating-update/${i.id}/`);
      if (res.status === 200 || res.status === 204) {
        if (getRangeTypes) await getRangeTypes();
        setShow(false);
        toast.success('Range Type Deleted Successfully!');
      }
    } catch (err) {
      // handleAllError(err, loadingToastId);
      toast.error('Failed to delete Range Type');
    } finally {
      toast.dismiss(loadingToastId);
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="model-delete-button-ml"
        title="Delete Range Type"
        onClick={handleShow}
        style={{ marginLeft: '10px' }}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-30vw">
        <Modal.Header closeButton className="task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div text-center" style={{ padding: '20px 0' }}>
              <h5 className="font-size-subheading font-weight500" style={{ marginBottom: '20px' }}>
                Are you sure you want to delete the Range Type <strong>"{i.name}"</strong>?
              </h5>
              <p className="font-size-text" style={{ color: '#6c757d', marginBottom: '30px' }}>
                This action cannot be undone.
              </p>

              <div className="button-models justify-content-center">
                <button
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="model-button font-weight500"
                  style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none' }}
                  onClick={handleDelete}
                  disabled={loading}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const AddAppraisalQuickSetup = ({ getAppraisalQuickSetupData, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false)
  const handleShow = () => {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
    setFormData(initialData)
  }

  const initialData = {
    sub_company: sessionStorage.getItem("company_id"),
    rating_period_start: "",
    rating_period_end: "",
    is_active: false,
    updated_by: sessionStorage.getItem('emp_code'),
  }

  const [formData, setFormData] = useState(initialData);
  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    let requiredFields = [
      "sub_company",
      "rating_period_start",
      "rating_period_end",
    ]

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    })

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;

  };


  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please Wait....");

      try {

        let res = await axios.post(`${BASE_URL}/wfm/appraisal-quickform-setup/`, formData);
        if (res.status === 200 || res.status === 201) {
          await getAppraisalQuickSetupData();
          handleClose()
          toast.success("Appraisal Quick Setup Added Successfully!")
        }
      } catch (error) {
        handleErrorToast(error, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  }

  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        sub_company: "",
      })

    } else {
      setFormData({
        ...formData,
        sub_company: selectedOption.value,
      })
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });

  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };



  return (
    <>
      <button className='upload-svg' title='Add Slip Appraisal Parameter Type' onClick={handleShow}>
        <AddwithWhiteCircle /> Appraisal Form
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
        <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
          <Modal.Title>
            Add Appraisal Quick Setup
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>

                )}
              </div>}


              <div className="flex-column">
                <label htmlFor="date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                  Start Date
                </label>
                <input
                  id="rating_period_start"
                  type="date"
                  name="rating_period_start"
                  placeholder="Start Date"
                  onChange={handleInputChange}
                  value={formData.rating_period_start}
                  className={`form-input ${errors.rating_period_start ? "error" : inputState.rating_period_start ? "success" : ""
                    }`}
                />
                {errors.rating_period_start && (
                  <span className="error-message font-size-text ">{errors.rating_period_start}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                  End Date
                </label>
                <input
                  id="rating_period_end"
                  type="date"
                  name="rating_period_end"
                  placeholder="End Date"
                  onChange={handleInputChange}
                  value={formData.rating_period_end}
                  className={`form-input ${errors.rating_period_end ? "error" : inputState.rating_period_end ? "success" : ""
                    }`}
                />
                {errors.rating_period_end && (
                  <span className="error-message font-size-text ">{errors.rating_period_end}</span>
                )}
              </div>

              <div className="flex-row">

                <label htmlFor="isDefault" className="font-weight500 font-size-subheading">
                  {formData.is_active ? "Is" : "Is Not"} Active
                </label>
                <hr className="field-cont-hr" />
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleInputChange}
                    id="is_active"
                  />
                  <label htmlFor={`is_active`}></label>
                </div>

              </div>

              <div className="button-models">
                <button
                  type="button"
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  onClick={handleSubmitData}
                  disabled={loading}
                >
                  Submit
                </button>
              </div>

              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (
                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )

}

const UpdateAppraisalQuickSetup = ({ i, getAppraisalQuickSetupData, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    sub_company: sessionStorage.getItem("company_id"),
    rating_period_start: "",
    rating_period_end: "",
    is_active: false,
    updated_by: sessionStorage.getItem('emp_code'),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "sub_company",
      "rating_period_start",
      "rating_period_end",
    ]

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    })

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please Wait....");
      setLoading(true);
      try {

        let res = await axios.put(`${BASE_URL}/wfm/appraisal-quickform-setup-update/${i.id}/`, formData);
        if (res.status === 200) {
          await getAppraisalQuickSetupData();
          setShow(false);
          toast.success('Appraisal Quick Setup Updated Successfully!')
        }
      } catch (error) {
        handleErrorToast(error, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  }
  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        sub_company: "",
      })

    } else {
      setFormData({
        ...formData,
        sub_company: selectedOption.value,
      })
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });

  }


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  return (
    <>
      <button className='model-edit-button-ml' title='Update  Appraisal Quick Setup' onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
        <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
          <Modal.Title>
            Update Appraisal Quick Setup
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>

              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>

                )}
              </div>}

              <div className="flex-column">
                <label htmlFor="date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                  Start Date
                </label>
                <input
                  id="rating_period_start"
                  type="date"
                  name="rating_period_start"
                  placeholder="Start Date"
                  onChange={handleInputChange}
                  value={formData.rating_period_start}
                  className={`form-input ${errors.rating_period_start ? "error" : inputState.rating_period_start ? "success" : ""
                    }`}
                />
                {errors.rating_period_start && (
                  <span className="error-message font-size-text ">{errors.rating_period_start}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                  End Date
                </label>
                <input
                  id="rating_period_end"
                  type="date"
                  name="rating_period_end"
                  placeholder="End Date"
                  onChange={handleInputChange}
                  value={formData.rating_period_end}
                  className={`form-input ${errors.rating_period_end ? "error" : inputState.rating_period_end ? "success" : ""
                    }`}
                />
                {errors.rating_period_end && (
                  <span className="error-message font-size-text ">{errors.rating_period_end}</span>
                )}
              </div>

              <div className="flex-row">

                <label htmlFor="isDefault" className="font-weight500 font-size-subheading">
                  {formData.is_active ? "Is" : "Is Not"} Active
                </label>
                <hr className="field-cont-hr" />
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleInputChange}
                    id="is_active"
                  />
                  <label htmlFor={`is_active`}></label>
                </div>

              </div>

              <div className="button-models">
                <button
                  type="button"
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  onClick={handleSubmitData}
                  disabled={loading}
                >
                  Update
                </button>
              </div>

              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (
                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </Modal>
    </>
  )
}

const DeleteAppraisalQuickSetup = ({ i, getAppraisalQuickSetupData }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [loading, setLoading] = useState(false);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(
        `${BASE_URL}/wfm/appraisal-quickform-setup-update/${i?.id}/`
      );

      if (res.status === 200) {
        await getAppraisalQuickSetupData();
        setShow(false);
        toast.success("Appraisal Quick Setup Deleted Successfully");
      } else {
        console.error(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <button
        title="Delete Appraisal Quick Setup"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Appraisal Quick Setup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete the Quick Appraisal Setup for
            <br />
            <b>
              {formattedDateLong(i.rating_period_start)} to {formattedDateLong(i.rating_period_end)}
            </b>
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button model-button-delete font-weight500"
                disabled={loading}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};



export {
  UploadAppraisalDetailsByEmployee,
  EditAppraisalDetailsByEmployee,
  ViewAppraisalDetailsByEmployee,

  UploadAppraisalDetailsByRH,
  ViewAppraisalDetailsByRH,

  UploadAppraisalDetailsByHOD,
  ViewAppraisalDetailsByHOD,
  UploadAppraisalDetailsByRHHOD,
  ViewAppraisalDetailsByRHHOD,

  UploadAppraisalDetailsByHODAdmin,
  ViewAppraisalDetailsHODAdmin,
  UploadAppraisalDetailsByRHHODAdmin,
  ViewAppraisalDetailsRHHODAdmin,

  ViewAppraisalDetailsbyQuickSetup,


  // New Appraisal Components 
  AddAppraisalType,
  UpdateAppraisalType,
  DeleteAppraisalType,

  AppraisalParameterHeadingAdd,
  AppraisalParameterHeadingUpdate,
  AppraisalParameterHeadingDelete,


  AddRangeType,
  UpdateRangeType,
  DeleteRangeType,

  AddAppraisalQuickSetup,
  UpdateAppraisalQuickSetup,
  DeleteAppraisalQuickSetup,

  // AppraisalRatingModal
  AppraisalApproverRatingModal
};
